import React from 'react'
import { Link } from 'react-router-dom'
import { isAuthenticated, logout } from '../../services/self'
import SignIn from '../../components/SignIn'
import Register from '../../components/Register'
import logo from '../../Nlogo.png'
import slack from '../../images/slack.jpeg'
import bst from '../../images/bst.png'
import avitru from '../../images/avitru.png'



export default class CaseStudies extends React.Component{

  logout() {
    logout()
    this.setState({ loggedOut: true })
  }





render() {


  return(
  <div>
  <div>
    <a href="https://developer.newforma.cloud/documentation">Back to Docs...</a>
  </div>

  <div>
    <h2>Newforma API (interface type 3) Documentation</h2>
    Product Version: 11.7.7.8079<br />
    (c) 2005-2016, Newforma, Inc. All rights reserved.<p>
      <b>Version 1170 Operations:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Request</th><th width="100px">Status</th>
        </tr><tr><td><a href="#CreateCompany2Request">CreateCompany2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateCompanyCommentRequest">CreateCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateCompanyCustomFieldValueRequest">CreateCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateContact3Request">CreateContact3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateContactCommentRequest">CreateContactComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateContactCustomFieldValueRequest">CreateContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateMyProjectRequest">CreateMyProject</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateOfficeLocation2Request">CreateOfficeLocation2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectCustomFieldValueRequest">CreateProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectFromTemplate2Request">CreateProjectFromTemplate2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectTeamGroupMemberRequest">CreateProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamGroupRequest">CreateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectTeamMember4Request">CreateProjectTeamMember4</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamMemberCustomFieldValueRequest">CreateProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateSourceDescriptor3Request">CreateSourceDescriptor3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateUser3Request">CreateUser3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateWebLinkRequest">CreateWebLink</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteCompanyCommentRequest">DeleteCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteCompanyCustomFieldValueRequest">DeleteCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteCompanyRequest">DeleteCompany</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteContactCommentRequest">DeleteContactComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteContactCustomFieldValueRequest">DeleteContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteContactRequest">DeleteContact</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteMyProjectRequest">DeleteMyProject</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteOfficeLocationRequest">DeleteOfficeLocation</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectCustomFieldValueRequest">DeleteProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamGroupMemberRequest">DeleteProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectTeamGroupRequest">DeleteProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamMemberCustomFieldValueRequest">DeleteProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectTeamMemberRequest">DeleteProjectTeamMember</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteSourceDescriptorRequest">DeleteSourceDescriptor</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteUserRequest">DeleteUser</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteWebLinkRequest">DeleteWebLink</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#EvaluateLiveFolders2Request">EvaluateLiveFolders2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetActionItemSummaryRequest">GetActionItemSummary</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetActionItems2Request">GetActionItems2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllCompanyDescriptorsRequest">GetAllCompanyDescriptors</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllContactDescriptorsRequest">GetAllContactDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllCustomFieldsRequest">GetAllCustomFields</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllEDMSPluginConfigsRequest">GetAllEDMSPluginConfigs</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllKeywordLists3Request">GetAllKeywordLists3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllPermissionSets2Request">GetAllPermissionSets2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllProjectDescriptors2Request">GetAllProjectDescriptors2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllSourceDescriptors3Request">GetAllSourceDescriptors3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllUserNamesRequest">GetAllUserNames</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCalendarItemSummaryRequest">GetCalendarItemSummary</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetCalendarItems2Request">GetCalendarItems2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCompaniesForIds2Request">GetCompaniesForIds2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetCompanyDescriptorsForNamesRequest">GetCompanyDescriptorsForNames</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCompanyDescriptorsForSourceDescriptorsRequest">GetCompanyDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetContactDescriptorsForEmailAddressesRequest">GetContactDescriptorsForEmailAddresses</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetContactDescriptorsForSourceDescriptorsRequest">GetContactDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetContactsForIds3Request">GetContactsForIds3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetDocumentSetSummaryRequest">GetDocumentSetSummary</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetDocumentSets2Request">GetDocumentSets2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetKeywordsForAllProjectFilesRequest">GetKeywordsForAllProjectFiles</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetKeywordsForProjectFilesRequest">GetKeywordsForProjectFiles</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetLiteProjectItemsRequest">GetLiteProjectItems</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetMyProjectsRequest">GetMyProjects</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetOfficeLocations2Request">GetOfficeLocations2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetProjectDescriptorsForNumbersRequest">GetProjectDescriptorsForNumbers</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectDescriptorsForSourceDescriptorsRequest">GetProjectDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetProjectFolders4Request">GetProjectFolders4</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectTeam4Request">GetProjectTeam4</a></td><td> New</td></tr>
        <tr><td><a href="#GetProjectsForIds3Request">GetProjectsForIds3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetRecordDocumentSummaryRequest">GetRecordDocumentSummary</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetRecordDocuments2Request">GetRecordDocuments2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetServerSettingsRequest">GetServerSettings</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetSupportedVersionRequest">GetSupportedVersion</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetTransmittalDetailRequest">GetTransmittalDetail</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetTransmittalSummaryRequest">GetTransmittalSummary</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetUsersForNames3Request">GetUsersForNames3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetWebLinksRequest">GetWebLinks</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#LinkCompaniesRequest">LinkCompanies</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#LinkContactsRequest">LinkContacts</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#NIDGetMyProjectsRequest">NIDGetMyProjects</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#NIDGetUserForVEOAuthenticationRequest">NIDGetUserForVEOAuthentication</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#ReplicateWithServerRequest">ReplicateWithServer</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#SearchProjectFileContentsRequest">SearchProjectFileContents</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#SearchProjectFileNamesRequest">SearchProjectFileNames</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#SearchProjectFilePropertiesRequest">SearchProjectFileProperties</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#SendNixAccountNotificationRequest">SendNixAccountNotification</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#SendNixPasswordReminderRequest">SendNixPasswordReminder</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateCompany2Request">UpdateCompany2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateCompanyCommentRequest">UpdateCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateCompanyCustomFieldValueRequest">UpdateCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateContact3Request">UpdateContact3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateContactCommentRequest">UpdateContactComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateContactCustomFieldValueRequest">UpdateContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateKeywordsForProjectFilesRequest">UpdateKeywordsForProjectFiles</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateMyProjectRequest">UpdateMyProject</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateOfficeLocation2Request">UpdateOfficeLocation2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateProjectCustomFieldValueRequest">UpdateProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateProjectTeamGroupRequest">UpdateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateProjectTeamMember4Request">UpdateProjectTeamMember4</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateProjectTeamMemberCustomFieldValueRequest">UpdateProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateSourceDescriptor3Request">UpdateSourceDescriptor3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateUser3Request">UpdateUser3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateWebLinkRequest">UpdateWebLink</a></td><td>&nbsp;</td></tr>
      </tbody></table>
    <p>
      <b>Version 1160 Operations:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Request</th><th width="100px">Status</th>
        </tr><tr><td><a href="#CreateCompany2Request">CreateCompany2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateCompanyCommentRequest">CreateCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateCompanyCustomFieldValueRequest">CreateCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateContact3Request">CreateContact3</a></td><td> New</td></tr>
        <tr><td><a href="#CreateContactCommentRequest">CreateContactComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateContactCustomFieldValueRequest">CreateContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateMyProjectRequest">CreateMyProject</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateOfficeLocation2Request">CreateOfficeLocation2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectCustomFieldValueRequest">CreateProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectFromTemplate2Request">CreateProjectFromTemplate2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectTeamGroupMemberRequest">CreateProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamGroupRequest">CreateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectTeamMember3Request">CreateProjectTeamMember3</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamMemberCustomFieldValueRequest">CreateProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateSourceDescriptor3Request">CreateSourceDescriptor3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateUser3Request">CreateUser3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateWebLinkRequest">CreateWebLink</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteCompanyCommentRequest">DeleteCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteCompanyCustomFieldValueRequest">DeleteCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteCompanyRequest">DeleteCompany</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteContactCommentRequest">DeleteContactComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteContactCustomFieldValueRequest">DeleteContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteContactRequest">DeleteContact</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteMyProjectRequest">DeleteMyProject</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteOfficeLocationRequest">DeleteOfficeLocation</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectCustomFieldValueRequest">DeleteProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamGroupMemberRequest">DeleteProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectTeamGroupRequest">DeleteProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamMemberCustomFieldValueRequest">DeleteProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectTeamMemberRequest">DeleteProjectTeamMember</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteSourceDescriptorRequest">DeleteSourceDescriptor</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteUserRequest">DeleteUser</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteWebLinkRequest">DeleteWebLink</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#EvaluateLiveFolders2Request">EvaluateLiveFolders2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetActionItemSummaryRequest">GetActionItemSummary</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetActionItems2Request">GetActionItems2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllCompanyDescriptorsRequest">GetAllCompanyDescriptors</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllContactDescriptorsRequest">GetAllContactDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllCustomFieldsRequest">GetAllCustomFields</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllEDMSPluginConfigsRequest">GetAllEDMSPluginConfigs</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllKeywordLists3Request">GetAllKeywordLists3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllPermissionSets2Request">GetAllPermissionSets2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllProjectDescriptors2Request">GetAllProjectDescriptors2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllSourceDescriptors3Request">GetAllSourceDescriptors3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllUserNamesRequest">GetAllUserNames</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCalendarItemSummaryRequest">GetCalendarItemSummary</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetCalendarItems2Request">GetCalendarItems2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCompaniesForIds2Request">GetCompaniesForIds2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetCompanyDescriptorsForNamesRequest">GetCompanyDescriptorsForNames</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCompanyDescriptorsForSourceDescriptorsRequest">GetCompanyDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetContactDescriptorsForEmailAddressesRequest">GetContactDescriptorsForEmailAddresses</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetContactDescriptorsForSourceDescriptorsRequest">GetContactDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetContactsForIds3Request">GetContactsForIds3</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetDocumentSetSummaryRequest">GetDocumentSetSummary</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetDocumentSets2Request">GetDocumentSets2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetKeywordsForAllProjectFilesRequest">GetKeywordsForAllProjectFiles</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetKeywordsForProjectFilesRequest">GetKeywordsForProjectFiles</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetLiteProjectItemsRequest">GetLiteProjectItems</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetMyProjectsRequest">GetMyProjects</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetOfficeLocations2Request">GetOfficeLocations2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetProjectDescriptorsForNumbersRequest">GetProjectDescriptorsForNumbers</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectDescriptorsForSourceDescriptorsRequest">GetProjectDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetProjectFolders4Request">GetProjectFolders4</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectTeam3Request">GetProjectTeam3</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetProjectsForIds3Request">GetProjectsForIds3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetRecordDocumentSummaryRequest">GetRecordDocumentSummary</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetRecordDocuments2Request">GetRecordDocuments2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetServerSettingsRequest">GetServerSettings</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetSupportedVersionRequest">GetSupportedVersion</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetTransmittalDetailRequest">GetTransmittalDetail</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetTransmittalSummaryRequest">GetTransmittalSummary</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetUsersForNames3Request">GetUsersForNames3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetWebLinksRequest">GetWebLinks</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#LinkCompaniesRequest">LinkCompanies</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#LinkContactsRequest">LinkContacts</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#NIDGetMyProjectsRequest">NIDGetMyProjects</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#NIDGetUserForVEOAuthenticationRequest">NIDGetUserForVEOAuthentication</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#ReplicateWithServerRequest">ReplicateWithServer</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#SearchProjectFileContentsRequest">SearchProjectFileContents</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#SearchProjectFileNamesRequest">SearchProjectFileNames</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#SearchProjectFilePropertiesRequest">SearchProjectFileProperties</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#SendNixAccountNotificationRequest">SendNixAccountNotification</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#SendNixPasswordReminderRequest">SendNixPasswordReminder</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateCompany2Request">UpdateCompany2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateCompanyCommentRequest">UpdateCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateCompanyCustomFieldValueRequest">UpdateCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateContact3Request">UpdateContact3</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateContactCommentRequest">UpdateContactComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateContactCustomFieldValueRequest">UpdateContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateKeywordsForProjectFilesRequest">UpdateKeywordsForProjectFiles</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateMyProjectRequest">UpdateMyProject</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateOfficeLocation2Request">UpdateOfficeLocation2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateProjectCustomFieldValueRequest">UpdateProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateProjectTeamGroupRequest">UpdateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateProjectTeamMember3Request">UpdateProjectTeamMember3</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateProjectTeamMemberCustomFieldValueRequest">UpdateProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateSourceDescriptor3Request">UpdateSourceDescriptor3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateUser3Request">UpdateUser3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateWebLinkRequest">UpdateWebLink</a></td><td>&nbsp;</td></tr>
      </tbody></table>
    <p>
      <b>Version 1150 Operations:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Request</th><th width="100px">Status</th>
        </tr><tr><td><a href="#CreateCompany2Request">CreateCompany2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateCompanyCommentRequest">CreateCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateCompanyCustomFieldValueRequest">CreateCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateContact2Request">CreateContact2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateContactCommentRequest">CreateContactComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateContactCustomFieldValueRequest">CreateContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateMyProjectRequest">CreateMyProject</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateOfficeLocation2Request">CreateOfficeLocation2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectCustomFieldValueRequest">CreateProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectFromTemplate2Request">CreateProjectFromTemplate2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectTeamGroupMemberRequest">CreateProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamGroupRequest">CreateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectTeamMember3Request">CreateProjectTeamMember3</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamMemberCustomFieldValueRequest">CreateProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateSourceDescriptor3Request">CreateSourceDescriptor3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateUser3Request">CreateUser3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateWebLinkRequest">CreateWebLink</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteCompanyCommentRequest">DeleteCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteCompanyCustomFieldValueRequest">DeleteCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteCompanyRequest">DeleteCompany</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteContactCommentRequest">DeleteContactComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteContactCustomFieldValueRequest">DeleteContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteContactRequest">DeleteContact</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteMyProjectRequest">DeleteMyProject</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteOfficeLocationRequest">DeleteOfficeLocation</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectCustomFieldValueRequest">DeleteProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamGroupMemberRequest">DeleteProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectTeamGroupRequest">DeleteProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamMemberCustomFieldValueRequest">DeleteProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectTeamMemberRequest">DeleteProjectTeamMember</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteSourceDescriptorRequest">DeleteSourceDescriptor</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteUserRequest">DeleteUser</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteWebLinkRequest">DeleteWebLink</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#EvaluateLiveFolders2Request">EvaluateLiveFolders2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetActionItemSummaryRequest">GetActionItemSummary</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetActionItems2Request">GetActionItems2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllCompanyDescriptorsRequest">GetAllCompanyDescriptors</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllContactDescriptorsRequest">GetAllContactDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllCustomFieldsRequest">GetAllCustomFields</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllEDMSPluginConfigsRequest">GetAllEDMSPluginConfigs</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllKeywordLists3Request">GetAllKeywordLists3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllPermissionSets2Request">GetAllPermissionSets2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllProjectDescriptors2Request">GetAllProjectDescriptors2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllSourceDescriptors3Request">GetAllSourceDescriptors3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllUserNamesRequest">GetAllUserNames</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCalendarItemSummaryRequest">GetCalendarItemSummary</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetCalendarItems2Request">GetCalendarItems2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCompaniesForIds2Request">GetCompaniesForIds2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetCompanyDescriptorsForNamesRequest">GetCompanyDescriptorsForNames</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCompanyDescriptorsForSourceDescriptorsRequest">GetCompanyDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetContactDescriptorsForEmailAddressesRequest">GetContactDescriptorsForEmailAddresses</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetContactDescriptorsForSourceDescriptorsRequest">GetContactDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetContactsForIds2Request">GetContactsForIds2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetDocumentSetSummaryRequest">GetDocumentSetSummary</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetDocumentSets2Request">GetDocumentSets2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetKeywordsForAllProjectFilesRequest">GetKeywordsForAllProjectFiles</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetKeywordsForProjectFilesRequest">GetKeywordsForProjectFiles</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetLiteProjectItemsRequest">GetLiteProjectItems</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetMyProjectsRequest">GetMyProjects</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetOfficeLocations2Request">GetOfficeLocations2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetProjectDescriptorsForNumbersRequest">GetProjectDescriptorsForNumbers</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectDescriptorsForSourceDescriptorsRequest">GetProjectDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetProjectFolders4Request">GetProjectFolders4</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectTeam3Request">GetProjectTeam3</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetProjectsForIds3Request">GetProjectsForIds3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetRecordDocumentSummaryRequest">GetRecordDocumentSummary</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetRecordDocuments2Request">GetRecordDocuments2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetServerSettingsRequest">GetServerSettings</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetSupportedVersionRequest">GetSupportedVersion</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetTransmittalDetailRequest">GetTransmittalDetail</a></td><td> New</td></tr>
        <tr><td><a href="#GetTransmittalSummaryRequest">GetTransmittalSummary</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetUsersForNames3Request">GetUsersForNames3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetWebLinksRequest">GetWebLinks</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#LinkCompaniesRequest">LinkCompanies</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#LinkContactsRequest">LinkContacts</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#NIDGetMyProjectsRequest">NIDGetMyProjects</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#NIDGetUserForVEOAuthenticationRequest">NIDGetUserForVEOAuthentication</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#ReplicateWithServerRequest">ReplicateWithServer</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#SearchProjectFileContentsRequest">SearchProjectFileContents</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#SearchProjectFileNamesRequest">SearchProjectFileNames</a></td><td> New</td></tr>
        <tr><td><a href="#SearchProjectFilePropertiesRequest">SearchProjectFileProperties</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#SendNixAccountNotificationRequest">SendNixAccountNotification</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#SendNixPasswordReminderRequest">SendNixPasswordReminder</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateCompany2Request">UpdateCompany2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateCompanyCommentRequest">UpdateCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateCompanyCustomFieldValueRequest">UpdateCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateContact2Request">UpdateContact2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateContactCommentRequest">UpdateContactComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateContactCustomFieldValueRequest">UpdateContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateKeywordsForProjectFilesRequest">UpdateKeywordsForProjectFiles</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateMyProjectRequest">UpdateMyProject</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateOfficeLocation2Request">UpdateOfficeLocation2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateProjectCustomFieldValueRequest">UpdateProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateProjectTeamGroupRequest">UpdateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateProjectTeamMember3Request">UpdateProjectTeamMember3</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateProjectTeamMemberCustomFieldValueRequest">UpdateProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateSourceDescriptor3Request">UpdateSourceDescriptor3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateUser3Request">UpdateUser3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateWebLinkRequest">UpdateWebLink</a></td><td>&nbsp;</td></tr>
      </tbody></table>
    <p>
      <b>Version 1110 Operations:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Request</th><th width="100px">Status</th>
        </tr><tr><td><a href="#CreateCompany2Request">CreateCompany2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateCompanyCommentRequest">CreateCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateCompanyCustomFieldValueRequest">CreateCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateContact2Request">CreateContact2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateContactCommentRequest">CreateContactComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateContactCustomFieldValueRequest">CreateContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateMyProjectRequest">CreateMyProject</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateOfficeLocation2Request">CreateOfficeLocation2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectCustomFieldValueRequest">CreateProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectFromTemplate2Request">CreateProjectFromTemplate2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectTeamGroupMemberRequest">CreateProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamGroupRequest">CreateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectTeamMember3Request">CreateProjectTeamMember3</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamMemberCustomFieldValueRequest">CreateProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateSourceDescriptor3Request">CreateSourceDescriptor3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateUser3Request">CreateUser3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateWebLinkRequest">CreateWebLink</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteCompanyCommentRequest">DeleteCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteCompanyCustomFieldValueRequest">DeleteCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteCompanyRequest">DeleteCompany</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteContactCommentRequest">DeleteContactComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteContactCustomFieldValueRequest">DeleteContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteContactRequest">DeleteContact</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteMyProjectRequest">DeleteMyProject</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteOfficeLocationRequest">DeleteOfficeLocation</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectCustomFieldValueRequest">DeleteProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamGroupMemberRequest">DeleteProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectTeamGroupRequest">DeleteProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamMemberCustomFieldValueRequest">DeleteProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectTeamMemberRequest">DeleteProjectTeamMember</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteSourceDescriptorRequest">DeleteSourceDescriptor</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteUserRequest">DeleteUser</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteWebLinkRequest">DeleteWebLink</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#EvaluateLiveFolders2Request">EvaluateLiveFolders2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetActionItemSummaryRequest">GetActionItemSummary</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetActionItems2Request">GetActionItems2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllCompanyDescriptorsRequest">GetAllCompanyDescriptors</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllContactDescriptorsRequest">GetAllContactDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllCustomFieldsRequest">GetAllCustomFields</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllEDMSPluginConfigsRequest">GetAllEDMSPluginConfigs</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllKeywordLists3Request">GetAllKeywordLists3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllPermissionSets2Request">GetAllPermissionSets2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllProjectDescriptors2Request">GetAllProjectDescriptors2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllSourceDescriptors3Request">GetAllSourceDescriptors3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllUserNamesRequest">GetAllUserNames</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCalendarItemSummaryRequest">GetCalendarItemSummary</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetCalendarItems2Request">GetCalendarItems2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCompaniesForIds2Request">GetCompaniesForIds2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetCompanyDescriptorsForNamesRequest">GetCompanyDescriptorsForNames</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCompanyDescriptorsForSourceDescriptorsRequest">GetCompanyDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetContactDescriptorsForEmailAddressesRequest">GetContactDescriptorsForEmailAddresses</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetContactDescriptorsForSourceDescriptorsRequest">GetContactDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetContactsForIds2Request">GetContactsForIds2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetDocumentSetSummaryRequest">GetDocumentSetSummary</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetDocumentSets2Request">GetDocumentSets2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetKeywordsForAllProjectFilesRequest">GetKeywordsForAllProjectFiles</a></td><td> New</td></tr>
        <tr><td><a href="#GetKeywordsForProjectFilesRequest">GetKeywordsForProjectFiles</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetLiteProjectItemsRequest">GetLiteProjectItems</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetMyProjectsRequest">GetMyProjects</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetOfficeLocations2Request">GetOfficeLocations2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetProjectDescriptorsForNumbersRequest">GetProjectDescriptorsForNumbers</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectDescriptorsForSourceDescriptorsRequest">GetProjectDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetProjectFolders4Request">GetProjectFolders4</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectTeam3Request">GetProjectTeam3</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetProjectsForIds3Request">GetProjectsForIds3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetRecordDocumentSummaryRequest">GetRecordDocumentSummary</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetRecordDocuments2Request">GetRecordDocuments2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetServerSettingsRequest">GetServerSettings</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetSupportedVersionRequest">GetSupportedVersion</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetUsersForNames3Request">GetUsersForNames3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetWebLinksRequest">GetWebLinks</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#LinkCompaniesRequest">LinkCompanies</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#LinkContactsRequest">LinkContacts</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#NIDGetMyProjectsRequest">NIDGetMyProjects</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#NIDGetUserForVEOAuthenticationRequest">NIDGetUserForVEOAuthentication</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#ReplicateWithServerRequest">ReplicateWithServer</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#SendNixAccountNotificationRequest">SendNixAccountNotification</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#SendNixPasswordReminderRequest">SendNixPasswordReminder</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateCompany2Request">UpdateCompany2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateCompanyCommentRequest">UpdateCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateCompanyCustomFieldValueRequest">UpdateCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateContact2Request">UpdateContact2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateContactCommentRequest">UpdateContactComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateContactCustomFieldValueRequest">UpdateContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateKeywordsForProjectFilesRequest">UpdateKeywordsForProjectFiles</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateMyProjectRequest">UpdateMyProject</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateOfficeLocation2Request">UpdateOfficeLocation2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateProjectCustomFieldValueRequest">UpdateProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateProjectTeamGroupRequest">UpdateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateProjectTeamMember3Request">UpdateProjectTeamMember3</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#UpdateProjectTeamMemberCustomFieldValueRequest">UpdateProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateSourceDescriptor3Request">UpdateSourceDescriptor3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateUser3Request">UpdateUser3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateWebLinkRequest">UpdateWebLink</a></td><td>&nbsp;</td></tr>
      </tbody></table>
    <p>
      <b>Version 1100 Operations:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Request</th><th width="100px">Status</th>
        </tr><tr><td><a href="#CreateCompany2Request">CreateCompany2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateCompanyCommentRequest">CreateCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateCompanyCustomFieldValueRequest">CreateCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateContact2Request">CreateContact2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateContactCommentRequest">CreateContactComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateContactCustomFieldValueRequest">CreateContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateMyProjectRequest">CreateMyProject</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateOfficeLocation2Request">CreateOfficeLocation2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectCustomFieldValueRequest">CreateProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectFromTemplate2Request">CreateProjectFromTemplate2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectTeamGroupMemberRequest">CreateProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamGroupRequest">CreateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectTeamMember3Request">CreateProjectTeamMember3</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamMemberCustomFieldValueRequest">CreateProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateSourceDescriptor3Request">CreateSourceDescriptor3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateUser3Request">CreateUser3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateWebLinkRequest">CreateWebLink</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteCompanyCommentRequest">DeleteCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteCompanyCustomFieldValueRequest">DeleteCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteCompanyRequest">DeleteCompany</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteContactCommentRequest">DeleteContactComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteContactCustomFieldValueRequest">DeleteContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteContactRequest">DeleteContact</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteMyProjectRequest">DeleteMyProject</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteOfficeLocationRequest">DeleteOfficeLocation</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectCustomFieldValueRequest">DeleteProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamGroupMemberRequest">DeleteProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectTeamGroupRequest">DeleteProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamMemberCustomFieldValueRequest">DeleteProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectTeamMemberRequest">DeleteProjectTeamMember</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteSourceDescriptorRequest">DeleteSourceDescriptor</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteUserRequest">DeleteUser</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteWebLinkRequest">DeleteWebLink</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#EvaluateLiveFolders2Request">EvaluateLiveFolders2</a></td><td> New</td></tr>
        <tr><td><a href="#GetActionItemSummaryRequest">GetActionItemSummary</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetActionItems2Request">GetActionItems2</a></td><td> New</td></tr>
        <tr><td><a href="#GetAllCompanyDescriptorsRequest">GetAllCompanyDescriptors</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllContactDescriptorsRequest">GetAllContactDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllCustomFieldsRequest">GetAllCustomFields</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllEDMSPluginConfigsRequest">GetAllEDMSPluginConfigs</a></td><td> New</td></tr>
        <tr><td><a href="#GetAllKeywordLists3Request">GetAllKeywordLists3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllPermissionSets2Request">GetAllPermissionSets2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllProjectDescriptors2Request">GetAllProjectDescriptors2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllSourceDescriptors3Request">GetAllSourceDescriptors3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllUserNamesRequest">GetAllUserNames</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCalendarItemSummaryRequest">GetCalendarItemSummary</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetCalendarItems2Request">GetCalendarItems2</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCompaniesForIds2Request">GetCompaniesForIds2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetCompanyDescriptorsForNamesRequest">GetCompanyDescriptorsForNames</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCompanyDescriptorsForSourceDescriptorsRequest">GetCompanyDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetContactDescriptorsForEmailAddressesRequest">GetContactDescriptorsForEmailAddresses</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetContactDescriptorsForSourceDescriptorsRequest">GetContactDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetContactsForIds2Request">GetContactsForIds2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetDocumentSetSummaryRequest">GetDocumentSetSummary</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetDocumentSets2Request">GetDocumentSets2</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetLiteProjectItemsRequest">GetLiteProjectItems</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetMyProjectsRequest">GetMyProjects</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetOfficeLocations2Request">GetOfficeLocations2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetProjectDescriptorsForNumbersRequest">GetProjectDescriptorsForNumbers</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectDescriptorsForSourceDescriptorsRequest">GetProjectDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetProjectFolders4Request">GetProjectFolders4</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectTeam3Request">GetProjectTeam3</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetProjectsForIds3Request">GetProjectsForIds3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetRecordDocumentSummaryRequest">GetRecordDocumentSummary</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetRecordDocuments2Request">GetRecordDocuments2</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetServerSettingsRequest">GetServerSettings</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetSupportedVersionRequest">GetSupportedVersion</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetUsersForNames3Request">GetUsersForNames3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetWebLinksRequest">GetWebLinks</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#LinkCompaniesRequest">LinkCompanies</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#LinkContactsRequest">LinkContacts</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#NIDGetMyProjectsRequest">NIDGetMyProjects</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#NIDGetUserForVEOAuthenticationRequest">NIDGetUserForVEOAuthentication</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#ReplicateWithServerRequest">ReplicateWithServer</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#SendNixAccountNotificationRequest">SendNixAccountNotification</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#SendNixPasswordReminderRequest">SendNixPasswordReminder</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateCompany2Request">UpdateCompany2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateCompanyCommentRequest">UpdateCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateCompanyCustomFieldValueRequest">UpdateCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateContact2Request">UpdateContact2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateContactCommentRequest">UpdateContactComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateContactCustomFieldValueRequest">UpdateContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateMyProjectRequest">UpdateMyProject</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateOfficeLocation2Request">UpdateOfficeLocation2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateProjectCustomFieldValueRequest">UpdateProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateProjectTeamGroupRequest">UpdateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateProjectTeamMember3Request">UpdateProjectTeamMember3</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateProjectTeamMemberCustomFieldValueRequest">UpdateProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateSourceDescriptor3Request">UpdateSourceDescriptor3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateUser3Request">UpdateUser3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateWebLinkRequest">UpdateWebLink</a></td><td>&nbsp;</td></tr>
      </tbody></table>
    <p>
      <b>Version 1020 Operations:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Request</th><th width="100px">Status</th>
        </tr><tr><td><a href="#CreateCompany2Request">CreateCompany2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateCompanyCommentRequest">CreateCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateCompanyCustomFieldValueRequest">CreateCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateContact2Request">CreateContact2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateContactCommentRequest">CreateContactComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateContactCustomFieldValueRequest">CreateContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateMyProjectRequest">CreateMyProject</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateOfficeLocation2Request">CreateOfficeLocation2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectCustomFieldValueRequest">CreateProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectFromTemplate2Request">CreateProjectFromTemplate2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectTeamGroupMemberRequest">CreateProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamGroupRequest">CreateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectTeamMember3Request">CreateProjectTeamMember3</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamMemberCustomFieldValueRequest">CreateProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateSourceDescriptor3Request">CreateSourceDescriptor3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateUser3Request">CreateUser3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateWebLinkRequest">CreateWebLink</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteCompanyCommentRequest">DeleteCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteCompanyCustomFieldValueRequest">DeleteCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteCompanyRequest">DeleteCompany</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteContactCommentRequest">DeleteContactComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteContactCustomFieldValueRequest">DeleteContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteContactRequest">DeleteContact</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteMyProjectRequest">DeleteMyProject</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteOfficeLocationRequest">DeleteOfficeLocation</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectCustomFieldValueRequest">DeleteProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamGroupMemberRequest">DeleteProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectTeamGroupRequest">DeleteProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamMemberCustomFieldValueRequest">DeleteProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectTeamMemberRequest">DeleteProjectTeamMember</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteSourceDescriptorRequest">DeleteSourceDescriptor</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteUserRequest">DeleteUser</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteWebLinkRequest">DeleteWebLink</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#EvaluateLiveFoldersRequest">EvaluateLiveFolders</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetActionItemSummaryRequest">GetActionItemSummary</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetActionItemsRequest">GetActionItems</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllCompanyDescriptorsRequest">GetAllCompanyDescriptors</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllContactDescriptorsRequest">GetAllContactDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllCustomFieldsRequest">GetAllCustomFields</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllKeywordLists3Request">GetAllKeywordLists3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllPermissionSets2Request">GetAllPermissionSets2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllProjectDescriptors2Request">GetAllProjectDescriptors2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllSourceDescriptors3Request">GetAllSourceDescriptors3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllUserNamesRequest">GetAllUserNames</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetCalendarItemSummaryRequest">GetCalendarItemSummary</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCalendarItemsRequest">GetCalendarItems</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetCompaniesForIds2Request">GetCompaniesForIds2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCompanyDescriptorsForNamesRequest">GetCompanyDescriptorsForNames</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetCompanyDescriptorsForSourceDescriptorsRequest">GetCompanyDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetContactDescriptorsForEmailAddressesRequest">GetContactDescriptorsForEmailAddresses</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetContactDescriptorsForSourceDescriptorsRequest">GetContactDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetContactsForIds2Request">GetContactsForIds2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetDocumentSetSummaryRequest">GetDocumentSetSummary</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetDocumentSetsRequest">GetDocumentSets</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetLiteProjectItemsRequest">GetLiteProjectItems</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetMyProjectsRequest">GetMyProjects</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetOfficeLocations2Request">GetOfficeLocations2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectDescriptorsForNumbersRequest">GetProjectDescriptorsForNumbers</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetProjectDescriptorsForSourceDescriptorsRequest">GetProjectDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectFolders3Request">GetProjectFolders3</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetProjectTeam3Request">GetProjectTeam3</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectsForIds3Request">GetProjectsForIds3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetRecordDocumentSummaryRequest">GetRecordDocumentSummary</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetRecordDocumentsRequest">GetRecordDocuments</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetServerSettingsRequest">GetServerSettings</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetSupportedVersionRequest">GetSupportedVersion</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetUsersForNames3Request">GetUsersForNames3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetWebLinksRequest">GetWebLinks</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#LinkCompaniesRequest">LinkCompanies</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#LinkContactsRequest">LinkContacts</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#NIDGetMyProjectsRequest">NIDGetMyProjects</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#NIDGetUserForVEOAuthenticationRequest">NIDGetUserForVEOAuthentication</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#ReplicateWithServerRequest">ReplicateWithServer</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#SendNixAccountNotificationRequest">SendNixAccountNotification</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#SendNixPasswordReminderRequest">SendNixPasswordReminder</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateCompany2Request">UpdateCompany2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateCompanyCommentRequest">UpdateCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateCompanyCustomFieldValueRequest">UpdateCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateContact2Request">UpdateContact2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateContactCommentRequest">UpdateContactComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateContactCustomFieldValueRequest">UpdateContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateMyProjectRequest">UpdateMyProject</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateOfficeLocation2Request">UpdateOfficeLocation2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateProjectCustomFieldValueRequest">UpdateProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateProjectTeamGroupRequest">UpdateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateProjectTeamMember3Request">UpdateProjectTeamMember3</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#UpdateProjectTeamMemberCustomFieldValueRequest">UpdateProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateSourceDescriptor3Request">UpdateSourceDescriptor3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateUser3Request">UpdateUser3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateWebLinkRequest">UpdateWebLink</a></td><td>&nbsp;</td></tr>
      </tbody></table>
    <p>
      <b>Version 1010 Operations:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Request</th><th width="100px">Status</th>
        </tr><tr><td><a href="#CreateCompany2Request">CreateCompany2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateCompanyCommentRequest">CreateCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateCompanyCustomFieldValueRequest">CreateCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateContact2Request">CreateContact2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateContactCommentRequest">CreateContactComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateContactCustomFieldValueRequest">CreateContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateMyProjectRequest">CreateMyProject</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateOfficeLocation2Request">CreateOfficeLocation2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectCustomFieldValueRequest">CreateProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectFromTemplate2Request">CreateProjectFromTemplate2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectTeamGroupMemberRequest">CreateProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamGroupRequest">CreateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectTeamMember3Request">CreateProjectTeamMember3</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamMemberCustomFieldValueRequest">CreateProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateSourceDescriptor3Request">CreateSourceDescriptor3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateUser3Request">CreateUser3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateWebLinkRequest">CreateWebLink</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteCompanyCommentRequest">DeleteCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteCompanyCustomFieldValueRequest">DeleteCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteCompanyRequest">DeleteCompany</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteContactCommentRequest">DeleteContactComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteContactCustomFieldValueRequest">DeleteContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteContactRequest">DeleteContact</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteMyProjectRequest">DeleteMyProject</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteOfficeLocationRequest">DeleteOfficeLocation</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectCustomFieldValueRequest">DeleteProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamGroupMemberRequest">DeleteProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectTeamGroupRequest">DeleteProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamMemberCustomFieldValueRequest">DeleteProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectTeamMemberRequest">DeleteProjectTeamMember</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteSourceDescriptorRequest">DeleteSourceDescriptor</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteUserRequest">DeleteUser</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteWebLinkRequest">DeleteWebLink</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#EvaluateLiveFoldersRequest">EvaluateLiveFolders</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetActionItemSummaryRequest">GetActionItemSummary</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetActionItemsRequest">GetActionItems</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllCompanyDescriptorsRequest">GetAllCompanyDescriptors</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllContactDescriptorsRequest">GetAllContactDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllCustomFieldsRequest">GetAllCustomFields</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllKeywordLists3Request">GetAllKeywordLists3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllPermissionSets2Request">GetAllPermissionSets2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllProjectDescriptors2Request">GetAllProjectDescriptors2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllSourceDescriptors3Request">GetAllSourceDescriptors3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllUserNamesRequest">GetAllUserNames</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetCalendarItemSummaryRequest">GetCalendarItemSummary</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCalendarItemsRequest">GetCalendarItems</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetCompaniesForIds2Request">GetCompaniesForIds2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCompanyDescriptorsForNamesRequest">GetCompanyDescriptorsForNames</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetCompanyDescriptorsForSourceDescriptorsRequest">GetCompanyDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetContactDescriptorsForEmailAddressesRequest">GetContactDescriptorsForEmailAddresses</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetContactDescriptorsForSourceDescriptorsRequest">GetContactDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetContactsForIds2Request">GetContactsForIds2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetDocumentSetSummaryRequest">GetDocumentSetSummary</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetDocumentSetsRequest">GetDocumentSets</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetMyProjectsRequest">GetMyProjects</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetOfficeLocations2Request">GetOfficeLocations2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetProjectDescriptorsForNumbersRequest">GetProjectDescriptorsForNumbers</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectDescriptorsForSourceDescriptorsRequest">GetProjectDescriptorsForSourceDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetProjectFolders3Request">GetProjectFolders3</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectTeam3Request">GetProjectTeam3</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetProjectsForIds3Request">GetProjectsForIds3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetRecordDocumentSummaryRequest">GetRecordDocumentSummary</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetRecordDocumentsRequest">GetRecordDocuments</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetServerSettingsRequest">GetServerSettings</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetSupportedVersionRequest">GetSupportedVersion</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetUsersForNames3Request">GetUsersForNames3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetWebLinksRequest">GetWebLinks</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#LinkCompaniesRequest">LinkCompanies</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#LinkContactsRequest">LinkContacts</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#NIDGetMyProjectsRequest">NIDGetMyProjects</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#NIDGetUserForVEOAuthenticationRequest">NIDGetUserForVEOAuthentication</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#ReplicateWithServerRequest">ReplicateWithServer</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#SendNixAccountNotificationRequest">SendNixAccountNotification</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#SendNixPasswordReminderRequest">SendNixPasswordReminder</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateCompany2Request">UpdateCompany2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateCompanyCommentRequest">UpdateCompanyComment</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateCompanyCustomFieldValueRequest">UpdateCompanyCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateContact2Request">UpdateContact2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateContactCommentRequest">UpdateContactComment</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateContactCustomFieldValueRequest">UpdateContactCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateMyProjectRequest">UpdateMyProject</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateOfficeLocation2Request">UpdateOfficeLocation2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateProjectCustomFieldValueRequest">UpdateProjectCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateProjectTeamGroupRequest">UpdateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateProjectTeamMember3Request">UpdateProjectTeamMember3</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateProjectTeamMemberCustomFieldValueRequest">UpdateProjectTeamMemberCustomFieldValue</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateSourceDescriptor3Request">UpdateSourceDescriptor3</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateUser3Request">UpdateUser3</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateWebLinkRequest">UpdateWebLink</a></td><td>&nbsp;</td></tr>
      </tbody></table>
    <p>
      <b>Version 1000 Operations:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Request</th><th width="100px">Status</th>
        </tr><tr><td><a href="#CreateCompany2Request">CreateCompany2</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateCompanyCommentRequest">CreateCompanyComment</a></td><td> New</td></tr>
        <tr><td><a href="#CreateCompanyCustomFieldValueRequest">CreateCompanyCustomFieldValue</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateContact2Request">CreateContact2</a></td><td> New</td></tr>
        <tr><td><a href="#CreateContactCommentRequest">CreateContactComment</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateContactCustomFieldValueRequest">CreateContactCustomFieldValue</a></td><td> New</td></tr>
        <tr><td><a href="#CreateMyProjectRequest">CreateMyProject</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateOfficeLocation2Request">CreateOfficeLocation2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectCustomFieldValueRequest">CreateProjectCustomFieldValue</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectFromTemplate2Request">CreateProjectFromTemplate2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectTeamGroupMemberRequest">CreateProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamGroupRequest">CreateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectTeamMember3Request">CreateProjectTeamMember3</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamMemberCustomFieldValueRequest">CreateProjectTeamMemberCustomFieldValue</a></td><td> New</td></tr>
        <tr><td><a href="#CreateSourceDescriptor3Request">CreateSourceDescriptor3</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateUser3Request">CreateUser3</a></td><td> New</td></tr>
        <tr><td><a href="#CreateWebLinkRequest">CreateWebLink</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteCompanyCommentRequest">DeleteCompanyComment</a></td><td> New</td></tr>
        <tr><td><a href="#DeleteCompanyCustomFieldValueRequest">DeleteCompanyCustomFieldValue</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteCompanyRequest">DeleteCompany</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteContactCommentRequest">DeleteContactComment</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteContactCustomFieldValueRequest">DeleteContactCustomFieldValue</a></td><td> New</td></tr>
        <tr><td><a href="#DeleteContactRequest">DeleteContact</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteMyProjectRequest">DeleteMyProject</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteOfficeLocationRequest">DeleteOfficeLocation</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectCustomFieldValueRequest">DeleteProjectCustomFieldValue</a></td><td> New</td></tr>
        <tr><td><a href="#DeleteProjectTeamGroupMemberRequest">DeleteProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectTeamGroupRequest">DeleteProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamMemberCustomFieldValueRequest">DeleteProjectTeamMemberCustomFieldValue</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectTeamMemberRequest">DeleteProjectTeamMember</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteSourceDescriptorRequest">DeleteSourceDescriptor</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteUserRequest">DeleteUser</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteWebLinkRequest">DeleteWebLink</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#EvaluateLiveFoldersRequest">EvaluateLiveFolders</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetActionItemSummaryRequest">GetActionItemSummary</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetActionItemsRequest">GetActionItems</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllCompanyDescriptorsRequest">GetAllCompanyDescriptors</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllContactDescriptorsRequest">GetAllContactDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllCustomFieldsRequest">GetAllCustomFields</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllKeywordLists3Request">GetAllKeywordLists3</a></td><td> New</td></tr>
        <tr><td><a href="#GetAllPermissionSets2Request">GetAllPermissionSets2</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllProjectDescriptors2Request">GetAllProjectDescriptors2</a></td><td> New</td></tr>
        <tr><td><a href="#GetAllSourceDescriptors3Request">GetAllSourceDescriptors3</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllUserNamesRequest">GetAllUserNames</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetCalendarItemSummaryRequest">GetCalendarItemSummary</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCalendarItemsRequest">GetCalendarItems</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetCompaniesForIds2Request">GetCompaniesForIds2</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCompanyDescriptorsForNamesRequest">GetCompanyDescriptorsForNames</a></td><td> New</td></tr>
        <tr><td><a href="#GetCompanyDescriptorsForSourceDescriptorsRequest">GetCompanyDescriptorsForSourceDescriptors</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetContactDescriptorsForEmailAddressesRequest">GetContactDescriptorsForEmailAddresses</a></td><td> New</td></tr>
        <tr><td><a href="#GetContactDescriptorsForSourceDescriptorsRequest">GetContactDescriptorsForSourceDescriptors</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetContactsForIds2Request">GetContactsForIds2</a></td><td> New</td></tr>
        <tr><td><a href="#GetDocumentSetSummaryRequest">GetDocumentSetSummary</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetDocumentSetsRequest">GetDocumentSets</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetMyProjectsRequest">GetMyProjects</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetOfficeLocations2Request">GetOfficeLocations2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetProjectDescriptorsForNumbersRequest">GetProjectDescriptorsForNumbers</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectDescriptorsForSourceDescriptorsRequest">GetProjectDescriptorsForSourceDescriptors</a></td><td> New</td></tr>
        <tr><td><a href="#GetProjectFolders3Request">GetProjectFolders3</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectTeam3Request">GetProjectTeam3</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetProjectsForIds3Request">GetProjectsForIds3</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetRecordDocumentSummaryRequest">GetRecordDocumentSummary</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetRecordDocumentsRequest">GetRecordDocuments</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetServerSettingsRequest">GetServerSettings</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetSupportedVersionRequest">GetSupportedVersion</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetUsersForNames3Request">GetUsersForNames3</a></td><td> New</td></tr>
        <tr><td><a href="#GetWebLinksRequest">GetWebLinks</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#LinkCompaniesRequest">LinkCompanies</a></td><td> New</td></tr>
        <tr><td><a href="#LinkContactsRequest">LinkContacts</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#NIDGetMyProjectsRequest">NIDGetMyProjects</a></td><td> New</td></tr>
        <tr><td><a href="#ReplicateWithServerRequest">ReplicateWithServer</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#SendNixAccountNotificationRequest">SendNixAccountNotification</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#SendNixPasswordReminderRequest">SendNixPasswordReminder</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateCompany2Request">UpdateCompany2</a></td><td> New</td></tr>
        <tr><td><a href="#UpdateCompanyCommentRequest">UpdateCompanyComment</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateCompanyCustomFieldValueRequest">UpdateCompanyCustomFieldValue</a></td><td> New</td></tr>
        <tr><td><a href="#UpdateContact2Request">UpdateContact2</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateContactCommentRequest">UpdateContactComment</a></td><td> New</td></tr>
        <tr><td><a href="#UpdateContactCustomFieldValueRequest">UpdateContactCustomFieldValue</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateMyProjectRequest">UpdateMyProject</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateOfficeLocation2Request">UpdateOfficeLocation2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateProjectCustomFieldValueRequest">UpdateProjectCustomFieldValue</a></td><td> New</td></tr>
        <tr><td><a href="#UpdateProjectTeamGroupRequest">UpdateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateProjectTeamMember3Request">UpdateProjectTeamMember3</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#UpdateProjectTeamMemberCustomFieldValueRequest">UpdateProjectTeamMemberCustomFieldValue</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateSourceDescriptor3Request">UpdateSourceDescriptor3</a></td><td> New</td></tr>
        <tr><td><a href="#UpdateUser3Request">UpdateUser3</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateWebLinkRequest">UpdateWebLink</a></td><td> New</td></tr>
      </tbody></table>
    <p>
      <b>Version 910 Operations:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Request</th><th width="100px">Status</th>
        </tr><tr><td><a href="#CreateCompanyRequest">CreateCompany</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateContactRequest">CreateContact</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#CreateMyProjectRequest">CreateMyProject</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateOfficeLocation2Request">CreateOfficeLocation2</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectFromTemplate2Request">CreateProjectFromTemplate2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamGroupMemberRequest">CreateProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectTeamGroupRequest">CreateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamMember2Request">CreateProjectTeamMember2</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#CreateSourceDescriptor2Request">CreateSourceDescriptor2</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateUser2Request">CreateUser2</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#DeleteCompanyRequest">DeleteCompany</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteContactRequest">DeleteContact</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteMyProjectRequest">DeleteMyProject</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteOfficeLocationRequest">DeleteOfficeLocation</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamGroupMemberRequest">DeleteProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectTeamGroupRequest">DeleteProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamMemberRequest">DeleteProjectTeamMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteSourceDescriptorRequest">DeleteSourceDescriptor</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteUserRequest">DeleteUser</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#EvaluateLiveFoldersRequest">EvaluateLiveFolders</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetActionItemSummaryRequest">GetActionItemSummary</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetActionItemsRequest">GetActionItems</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllCompanyDescriptorsRequest">GetAllCompanyDescriptors</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllContactDescriptorsRequest">GetAllContactDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllKeywordLists2Request">GetAllKeywordLists2</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllPermissionSetsRequest">GetAllPermissionSets</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetAllProjectDescriptorsRequest">GetAllProjectDescriptors</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllSourceDescriptors2Request">GetAllSourceDescriptors2</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetAllUserNamesRequest">GetAllUserNames</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCalendarItemSummaryRequest">GetCalendarItemSummary</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetCalendarItemsRequest">GetCalendarItems</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCompaniesForIdsRequest">GetCompaniesForIds</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetCompaniesForNamesRequest">GetCompaniesForNames</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCompaniesForSourceDescriptorsRequest">GetCompaniesForSourceDescriptors</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetContactsForEmailAddressesRequest">GetContactsForEmailAddresses</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetContactsForIdsRequest">GetContactsForIds</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetContactsForSourceDescriptorsRequest">GetContactsForSourceDescriptors</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetDocumentSetSummaryRequest">GetDocumentSetSummary</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetDocumentSetsRequest">GetDocumentSets</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetMyProjectsRequest">GetMyProjects</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetOfficeLocations2Request">GetOfficeLocations2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectFolders2Request">GetProjectFolders2</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetProjectTeam2Request">GetProjectTeam2</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectsForIds2Request">GetProjectsForIds2</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetProjectsForNumbers2Request">GetProjectsForNumbers2</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectsForSourceDescriptors2Request">GetProjectsForSourceDescriptors2</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetRecordDocumentSummaryRequest">GetRecordDocumentSummary</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetRecordDocumentsRequest">GetRecordDocuments</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetServerSettingsRequest">GetServerSettings</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetSupportedVersionRequest">GetSupportedVersion</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetUsersForNames2Request">GetUsersForNames2</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#LinkContactsRequest">LinkContacts</a></td><td> New</td></tr>
        <tr><td><a href="#ReplicateWithServerRequest">ReplicateWithServer</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#SendNixAccountNotificationRequest">SendNixAccountNotification</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#SendNixPasswordReminderRequest">SendNixPasswordReminder</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateCompanyRequest">UpdateCompany</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#UpdateContactRequest">UpdateContact</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateMyProjectRequest">UpdateMyProject</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateOfficeLocation2Request">UpdateOfficeLocation2</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateProjectTeamGroupRequest">UpdateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateProjectTeamMember2Request">UpdateProjectTeamMember2</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateSourceDescriptor2Request">UpdateSourceDescriptor2</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#UpdateUser2Request">UpdateUser2</a></td><td> Deprecated</td></tr>
      </tbody></table>
    <p>
      <b>Version 900 Operations:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Request</th><th width="100px">Status</th>
        </tr><tr><td><a href="#CreateCompanyRequest">CreateCompany</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateContactRequest">CreateContact</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#CreateMyProjectRequest">CreateMyProject</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateOfficeLocation2Request">CreateOfficeLocation2</a></td><td> New</td></tr>
        <tr><td><a href="#CreateProjectFromTemplate2Request">CreateProjectFromTemplate2</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamGroupMemberRequest">CreateProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectTeamGroupRequest">CreateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamMember2Request">CreateProjectTeamMember2</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#CreateSourceDescriptor2Request">CreateSourceDescriptor2</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateUser2Request">CreateUser2</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#DeleteCompanyRequest">DeleteCompany</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteContactRequest">DeleteContact</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteMyProjectRequest">DeleteMyProject</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteOfficeLocationRequest">DeleteOfficeLocation</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamGroupMemberRequest">DeleteProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectTeamGroupRequest">DeleteProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamMemberRequest">DeleteProjectTeamMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteSourceDescriptorRequest">DeleteSourceDescriptor</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteUserRequest">DeleteUser</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#EvaluateLiveFoldersRequest">EvaluateLiveFolders</a></td><td> New</td></tr>
        <tr><td><a href="#GetActionItemSummaryRequest">GetActionItemSummary</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetActionItemsRequest">GetActionItems</a></td><td> New</td></tr>
        <tr><td><a href="#GetAllCompanyDescriptorsRequest">GetAllCompanyDescriptors</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllContactDescriptorsRequest">GetAllContactDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllKeywordLists2Request">GetAllKeywordLists2</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllPermissionSetsRequest">GetAllPermissionSets</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetAllProjectDescriptorsRequest">GetAllProjectDescriptors</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllSourceDescriptors2Request">GetAllSourceDescriptors2</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetAllUserNamesRequest">GetAllUserNames</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCalendarItemSummaryRequest">GetCalendarItemSummary</a></td><td> New</td></tr>
        <tr><td><a href="#GetCalendarItemsRequest">GetCalendarItems</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCompaniesForIdsRequest">GetCompaniesForIds</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetCompaniesForNamesRequest">GetCompaniesForNames</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCompaniesForSourceDescriptorsRequest">GetCompaniesForSourceDescriptors</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetContactsForEmailAddressesRequest">GetContactsForEmailAddresses</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetContactsForIdsRequest">GetContactsForIds</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetContactsForSourceDescriptorsRequest">GetContactsForSourceDescriptors</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetDocumentSetSummaryRequest">GetDocumentSetSummary</a></td><td> New</td></tr>
        <tr><td><a href="#GetDocumentSetsRequest">GetDocumentSets</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetMyProjectsRequest">GetMyProjects</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetOfficeLocations2Request">GetOfficeLocations2</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectFolders2Request">GetProjectFolders2</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetProjectTeam2Request">GetProjectTeam2</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectsForIds2Request">GetProjectsForIds2</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetProjectsForNumbers2Request">GetProjectsForNumbers2</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectsForSourceDescriptors2Request">GetProjectsForSourceDescriptors2</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetRecordDocumentSummaryRequest">GetRecordDocumentSummary</a></td><td> New</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetRecordDocumentsRequest">GetRecordDocuments</a></td><td> New</td></tr>
        <tr><td><a href="#GetServerSettingsRequest">GetServerSettings</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetSupportedVersionRequest">GetSupportedVersion</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetUsersForNames2Request">GetUsersForNames2</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#ReplicateWithServerRequest">ReplicateWithServer</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#SendNixAccountNotificationRequest">SendNixAccountNotification</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#SendNixPasswordReminderRequest">SendNixPasswordReminder</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateCompanyRequest">UpdateCompany</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateContactRequest">UpdateContact</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#UpdateMyProjectRequest">UpdateMyProject</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateOfficeLocation2Request">UpdateOfficeLocation2</a></td><td> New</td></tr>
        <tr><td><a href="#UpdateProjectTeamGroupRequest">UpdateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateProjectTeamMember2Request">UpdateProjectTeamMember2</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#UpdateSourceDescriptor2Request">UpdateSourceDescriptor2</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateUser2Request">UpdateUser2</a></td><td> Deprecated</td></tr>
      </tbody></table>
    <p>
      <b>Version 800 Operations:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Request</th><th width="100px">Status</th>
        </tr><tr><td><a href="#CreateCompanyRequest">CreateCompany</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateContactRequest">CreateContact</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#CreateMyProjectRequest">CreateMyProject</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateOfficeLocationRequest">CreateOfficeLocation</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#CreateProjectFromTemplateRequest">CreateProjectFromTemplate</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamGroupMemberRequest">CreateProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#CreateProjectTeamGroupRequest">CreateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateProjectTeamMemberRequest">CreateProjectTeamMember</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#CreateSourceDescriptorRequest">CreateSourceDescriptor</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#CreateUserRequest">CreateUser</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#DeleteCompanyRequest">DeleteCompany</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteContactRequest">DeleteContact</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteMyProjectRequest">DeleteMyProject</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteOfficeLocationRequest">DeleteOfficeLocation</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamGroupMemberRequest">DeleteProjectTeamGroupMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteProjectTeamGroupRequest">DeleteProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteProjectTeamMemberRequest">DeleteProjectTeamMember</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#DeleteSourceDescriptorRequest">DeleteSourceDescriptor</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#DeleteUserRequest">DeleteUser</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllCompanyDescriptorsRequest">GetAllCompanyDescriptors</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetAllContactDescriptorsRequest">GetAllContactDescriptors</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllKeywordListsRequest">GetAllKeywordLists</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetAllPermissionSetsRequest">GetAllPermissionSets</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllProjectDescriptorsRequest">GetAllProjectDescriptors</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetAllSourceDescriptorsRequest">GetAllSourceDescriptors</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetAllUserNamesRequest">GetAllUserNames</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetCompaniesForIdsRequest">GetCompaniesForIds</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetCompaniesForNamesRequest">GetCompaniesForNames</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetCompaniesForSourceDescriptorsRequest">GetCompaniesForSourceDescriptors</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetContactsForEmailAddressesRequest">GetContactsForEmailAddresses</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetContactsForIdsRequest">GetContactsForIds</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetContactsForSourceDescriptorsRequest">GetContactsForSourceDescriptors</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetMyProjectsRequest">GetMyProjects</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetOfficeLocationsRequest">GetOfficeLocations</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetProjectFoldersRequest">GetProjectFolders</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectTeamRequest">GetProjectTeam</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetProjectsForIdsRequest">GetProjectsForIds</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetProjectsForNumbersRequest">GetProjectsForNumbers</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#GetProjectsForSourceDescriptorsRequest">GetProjectsForSourceDescriptors</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetServerSettingsRequest">GetServerSettings</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#GetSupportedVersionRequest">GetSupportedVersion</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#GetUsersForNamesRequest">GetUsersForNames</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#ReplicateWithServerRequest">ReplicateWithServer</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#SendNixAccountNotificationRequest">SendNixAccountNotification</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#SendNixPasswordReminderRequest">SendNixPasswordReminder</a></td><td>&nbsp;</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateCompanyRequest">UpdateCompany</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#UpdateContactRequest">UpdateContact</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateMyProjectRequest">UpdateMyProject</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateOfficeLocationRequest">UpdateOfficeLocation</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateProjectTeamGroupRequest">UpdateProjectTeamGroup</a></td><td>&nbsp;</td></tr>
        <tr><td><a href="#UpdateProjectTeamMemberRequest">UpdateProjectTeamMember</a></td><td> Deprecated</td></tr>
        <tr bgcolor="efefef"><td><a href="#UpdateSourceDescriptorRequest">UpdateSourceDescriptor</a></td><td> Deprecated</td></tr>
        <tr><td><a href="#UpdateUserRequest">UpdateUser</a></td><td> Deprecated</td></tr>
      </tbody></table>
    <p>
      <a name="CreateCompanyRequest"><b>CreateCompanyRequest</b></a> (Deprecated: use <a href="#CreateCompany2Request">CreateCompany2</a> instead.)<br />
      Create a company in the Newforma database.</p><p>
      It is an error to create a company with the same company name as another company.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Company" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"MainContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DisciplineList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SpecSectionList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"WebUrl" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NoteText" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Company</td><td>The new company to create.</td></tr>
        <tr><td>Company.CompanyId</td><td>The company's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Company.MainContactId</td><td>The contact's associated main contact's Newforma database ID.</td></tr>
        <tr><td>Company.CompanyName</td><td>The company's name.</td></tr>
        <tr bgcolor="efefef"><td>Company.DisciplineList</td><td>The company's discipline list.</td></tr>
        <tr><td>Company.SpecSectionList</td><td>The company's spec section list.</td></tr>
        <tr bgcolor="efefef"><td>Company.WebUrl</td><td>The company's website URL.</td></tr>
        <tr><td>Company.NoteText</td><td>The company's HTML note text.</td></tr>
        <tr bgcolor="efefef"><td>Company.SourceDescriptor</td><td>The name of the original datasource that the company was imported from.</td></tr>
        <tr><td>Company.SourcePrimaryKey</td><td>The company's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <b>CreateCompanyResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"CompanyId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>CompanyId</td><td>The new company's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="CreateCompany2Request"><b>CreateCompany2Request</b></a><br />
      Create a company in the Newforma database.</p><p>
      It is an error to create a company with the same company name as another company.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Company" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"MainContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DisciplineList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SpecSectionList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"WebUrl" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NoteText" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Rating" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CustomFields" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Company</td><td>The new company to create.</td></tr>
        <tr><td>Company.CompanyId</td><td>The company's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Company.MainContactId</td><td>The contact's associated main contact's Newforma database ID.</td></tr>
        <tr><td>Company.CompanyName</td><td>The company's name.</td></tr>
        <tr bgcolor="efefef"><td>Company.DisciplineList</td><td>The company's discipline list.</td></tr>
        <tr><td>Company.SpecSectionList</td><td>The company's spec section list.</td></tr>
        <tr bgcolor="efefef"><td>Company.WebUrl</td><td>The company's website URL.</td></tr>
        <tr><td>Company.NoteText</td><td>The company's HTML note text.</td></tr>
        <tr bgcolor="efefef"><td>Company.SourceDescriptor</td><td>The name of the original datasource that the company was imported from.</td></tr>
        <tr><td>Company.SourcePrimaryKey</td><td>The company's primary key in its original datasource.</td></tr>
        <tr bgcolor="efefef"><td>Company.Rating</td><td>The company's rating in the range 0 - 5.</td></tr>
        <tr><td>Company.CompanyType</td><td>The company's type.</td></tr>
        <tr bgcolor="efefef"><td>Company.CustomFields</td><td>The company's custom fields.</td></tr>
        <tr><td>Company.CustomFields.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>Company.CustomFields.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>Company.CustomFields.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>Company.CustomFields.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>Company.CustomFields.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>Company.CustomFields.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>Company.CustomFields.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>Company.CustomFields.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>Company.CustomFields.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>Company.CustomFields.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>Company.CustomFields.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>Company.CustomFields.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Company.CustomFields.CompanyId</td><td>The company's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>CreateCompany2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"CompanyId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>CompanyId</td><td>The new company's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="CreateCompanyCommentRequest"><b>CreateCompanyCommentRequest</b></a><br />
      Create a company comment in the Newforma database.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Comment" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CommentId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AuthorContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CommentTime" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Remarks" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Comment</td><td>The new commnent.</td></tr>
        <tr><td>Comment.CommentId</td><td>The comment's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Comment.ProjectId</td><td>An optional associated project's Newforma database ID.</td></tr>
        <tr><td>Comment.AuthorContactId</td><td>The authoring contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Comment.CommentTime</td><td>The time when the comment was created/last changed.</td></tr>
        <tr><td>Comment.Remarks</td><td>The comment text.</td></tr>
        <tr bgcolor="efefef"><td>Comment.CompanyId</td><td>The company's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>CreateCompanyCommentResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"CommentId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>CommentId</td><td>The new comment's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="CreateCompanyCustomFieldValueRequest"><b>CreateCompanyCustomFieldValueRequest</b></a><br />
      Create a company custom field value in the Newforma database.  Creating a custom field value with its default value is a no-op.</p><p>
      It is an error to create a duplicate custom field value, set the custom field's value to an unsupported type for that field, or to create a custom field value not associated with a company custom field layout.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"FieldValue" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue</td><td>The new custom field value to create.</td></tr>
        <tr><td>FieldValue.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>FieldValue.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>FieldValue.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>FieldValue.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CompanyId</td><td>The company's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>CreateCompanyCustomFieldValueResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="CreateContactRequest"><b>CreateContactRequest</b></a> (Deprecated: use <a href="#CreateContact3Request">CreateContact3</a> instead.)<br />
      Create a contact in the Newforma database.</p><p>
      It is an error to create a contact with the same email address as another contact.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Contact" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"OfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"EmailAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FirstName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"LastName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DepartmentName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"JobTitle" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DisciplineList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberWork" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberMobile" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberHome" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FaxNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NoteText" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ActiveUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AddressType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"UseOfficeAddress" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Contact</td><td>The new contact to create.</td></tr>
        <tr><td>Contact.ContactId</td><td>The contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CompanyId</td><td>The contact's associated company's Newforma database ID.</td></tr>
        <tr><td>Contact.OfficeLocationId</td><td>The contact's associated office location's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contact.EmailAddress</td><td>The contact's email address.</td></tr>
        <tr><td>Contact.FirstName</td><td>The contact's first name.</td></tr>
        <tr bgcolor="efefef"><td>Contact.LastName</td><td>The contact's last name.</td></tr>
        <tr><td>Contact.DepartmentName</td><td>The contact's department name.</td></tr>
        <tr bgcolor="efefef"><td>Contact.JobTitle</td><td>The contact's job title.</td></tr>
        <tr><td>Contact.DisciplineList</td><td>The contact's discipline list.</td></tr>
        <tr bgcolor="efefef"><td>Contact.PhoneNumberWork</td><td>The contact's work phone number.</td></tr>
        <tr><td>Contact.PhoneNumberMobile</td><td>The contact's mobile phone number.</td></tr>
        <tr bgcolor="efefef"><td>Contact.PhoneNumberHome</td><td>The contact's home phone number.</td></tr>
        <tr><td>Contact.FaxNumber</td><td>The contact's fax number.</td></tr>
        <tr bgcolor="efefef"><td>Contact.StreetAddress</td><td>The contact's street address.  The format of a street address is either five
            fields (address│city│state│zip│country) separated
            by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>Contact.NoteText</td><td>The contact's HTML note text.</td></tr>
        <tr bgcolor="efefef"><td>Contact.ActiveUser</td><td>Is the contact an active Newforma user?</td></tr>
        <tr><td>Contact.NixUser</td><td>Does the contact have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Contact.AcceptedDisclaimer</td><td>Has the contact accepted the Terms and Conditions on NIX?</td></tr>
        <tr><td>Contact.AddressType</td><td>The contact's address type.</td></tr>
        <tr bgcolor="efefef"><td>Contact.UseOfficeAddress</td><td>Should the contact use their associated office location's address?</td></tr>
        <tr><td>Contact.SourceDescriptor</td><td>The name of the original datasource that the contact was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Contact.SourcePrimaryKey</td><td>The contact's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <b>CreateContactResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"ContactId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>ContactId</td><td>The new contact's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="CreateContact2Request"><b>CreateContact2Request</b></a><br />
      Create a contact in the Newforma database.</p><p>
      It is an error to create a contact with the same email address as another contact.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Contact" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"OfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"EmailAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FirstName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"LastName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DepartmentName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"JobTitle" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DisciplineList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberWork" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberMobile" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberHome" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FaxNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NoteText" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ActiveUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AddressType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"UseOfficeAddress" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Roles" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CustomFields" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Contact</td><td>The new contact to create.</td></tr>
        <tr><td>Contact.ContactId</td><td>The contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CompanyId</td><td>The contact's associated company's Newforma database ID.</td></tr>
        <tr><td>Contact.OfficeLocationId</td><td>The contact's associated office location's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contact.EmailAddress</td><td>The contact's email address.</td></tr>
        <tr><td>Contact.FirstName</td><td>The contact's first name.</td></tr>
        <tr bgcolor="efefef"><td>Contact.LastName</td><td>The contact's last name.</td></tr>
        <tr><td>Contact.DepartmentName</td><td>The contact's department name.</td></tr>
        <tr bgcolor="efefef"><td>Contact.JobTitle</td><td>The contact's job title.</td></tr>
        <tr><td>Contact.DisciplineList</td><td>The contact's discipline list.</td></tr>
        <tr bgcolor="efefef"><td>Contact.PhoneNumberWork</td><td>The contact's work phone number.</td></tr>
        <tr><td>Contact.PhoneNumberMobile</td><td>The contact's mobile phone number.</td></tr>
        <tr bgcolor="efefef"><td>Contact.PhoneNumberHome</td><td>The contact's home phone number.</td></tr>
        <tr><td>Contact.FaxNumber</td><td>The contact's fax number.</td></tr>
        <tr bgcolor="efefef"><td>Contact.StreetAddress</td><td>The contact's street address.  The format of a street address is either five
            fields (address│city│state│zip│country) separated
            by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>Contact.NoteText</td><td>The contact's HTML note text.</td></tr>
        <tr bgcolor="efefef"><td>Contact.ActiveUser</td><td>Is the contact an active Newforma user?</td></tr>
        <tr><td>Contact.NixUser</td><td>Does the contact have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Contact.AcceptedDisclaimer</td><td>Has the contact accepted the Terms and Conditions on NIX?</td></tr>
        <tr><td>Contact.AddressType</td><td>The contact's address type.</td></tr>
        <tr bgcolor="efefef"><td>Contact.UseOfficeAddress</td><td>Should the contact use their associated office location's address?</td></tr>
        <tr><td>Contact.SourceDescriptor</td><td>The name of the original datasource that the contact was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Contact.SourcePrimaryKey</td><td>The contact's primary key in its original datasource.</td></tr>
        <tr><td>Contact.Roles</td><td>The contact's roles.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields</td><td>The contact's custom fields.</td></tr>
        <tr><td>Contact.CustomFields.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>Contact.CustomFields.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>Contact.CustomFields.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>Contact.CustomFields.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>Contact.CustomFields.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>Contact.CustomFields.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>Contact.CustomFields.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.ContactId</td><td>The contact's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>CreateContact2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"ContactId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>ContactId</td><td>The new contact's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="CreateContact3Request"><b>CreateContact3Request</b></a><br />
      Create a contact in the Newforma database.</p><p>
      It is an error to create a contact with the same email address as another contact.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Contact" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"OfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"EmailAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FirstName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"LastName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DepartmentName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"JobTitle" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DisciplineList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberWork" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberMobile" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberHome" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FaxNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NoteText" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ActiveUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AddressType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"UseOfficeAddress" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Roles" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CustomFields" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Contact</td><td>The new contact to create.</td></tr>
        <tr><td>Contact.ContactId</td><td>The contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CompanyId</td><td>The contact's associated company's Newforma database ID.</td></tr>
        <tr><td>Contact.OfficeLocationId</td><td>The contact's associated office location's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contact.EmailAddress</td><td>The contact's email address.</td></tr>
        <tr><td>Contact.FirstName</td><td>The contact's first name.</td></tr>
        <tr bgcolor="efefef"><td>Contact.LastName</td><td>The contact's last name.</td></tr>
        <tr><td>Contact.DepartmentName</td><td>The contact's department name.</td></tr>
        <tr bgcolor="efefef"><td>Contact.JobTitle</td><td>The contact's job title.</td></tr>
        <tr><td>Contact.DisciplineList</td><td>The contact's discipline list.</td></tr>
        <tr bgcolor="efefef"><td>Contact.PhoneNumberWork</td><td>The contact's work phone number.</td></tr>
        <tr><td>Contact.PhoneNumberMobile</td><td>The contact's mobile phone number.</td></tr>
        <tr bgcolor="efefef"><td>Contact.PhoneNumberHome</td><td>The contact's home phone number.</td></tr>
        <tr><td>Contact.FaxNumber</td><td>The contact's fax number.</td></tr>
        <tr bgcolor="efefef"><td>Contact.StreetAddress</td><td>The contact's street address.  The format of a street address is either five
            fields (address│city│state│zip│country) separated
            by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>Contact.NoteText</td><td>The contact's HTML note text.</td></tr>
        <tr bgcolor="efefef"><td>Contact.ActiveUser</td><td>Is the contact an active Newforma user?</td></tr>
        <tr><td>Contact.NixUser</td><td>Does the contact have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Contact.AcceptedDisclaimer</td><td>Has the contact accepted the Terms and Conditions on NIX?</td></tr>
        <tr><td>Contact.AddressType</td><td>The contact's address type.</td></tr>
        <tr bgcolor="efefef"><td>Contact.UseOfficeAddress</td><td>Should the contact use their associated office location's address?</td></tr>
        <tr><td>Contact.SourceDescriptor</td><td>The name of the original datasource that the contact was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Contact.SourcePrimaryKey</td><td>The contact's primary key in its original datasource.</td></tr>
        <tr><td>Contact.Roles</td><td>The contact's roles.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields</td><td>The contact's custom fields.</td></tr>
        <tr><td>Contact.CustomFields.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>Contact.CustomFields.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>Contact.CustomFields.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>Contact.CustomFields.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>Contact.CustomFields.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>Contact.CustomFields.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>Contact.CustomFields.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.ContactId</td><td>The contact's Newforma database ID.</td></tr>
        <tr><td>Contact.Culture</td><td>The contact's culture for notifications without a project context.</td></tr>
      </tbody></table><p>
      <b>CreateContact3Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"ContactId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>ContactId</td><td>The new contact's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="CreateContactCommentRequest"><b>CreateContactCommentRequest</b></a><br />
      Create a contact comment in the Newforma database.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Comment" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CommentId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AuthorContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CommentTime" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Remarks" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Comment</td><td>The new commnent.</td></tr>
        <tr><td>Comment.CommentId</td><td>The comment's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Comment.ProjectId</td><td>An optional associated project's Newforma database ID.</td></tr>
        <tr><td>Comment.AuthorContactId</td><td>The authoring contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Comment.CommentTime</td><td>The time when the comment was created/last changed.</td></tr>
        <tr><td>Comment.Remarks</td><td>The comment text.</td></tr>
        <tr bgcolor="efefef"><td>Comment.ContactId</td><td>The contact's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>CreateContactCommentResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"CommentId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>CommentId</td><td>The new comment's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="CreateContactCustomFieldValueRequest"><b>CreateContactCustomFieldValueRequest</b></a><br />
      Create a contact custom field value in the Newforma database.  Creating a custom field value with its default value is a no-op.</p><p>
      It is an error to create a duplicate custom field value, set the custom field's value to an unsupported type for that field, or to create a custom field value not associated with a contact custom field layout.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"FieldValue" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue</td><td>The new custom field value to create.</td></tr>
        <tr><td>FieldValue.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>FieldValue.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>FieldValue.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>FieldValue.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.ContactId</td><td>The contact's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>CreateContactCustomFieldValueResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="CreateMyProjectRequest"><b>CreateMyProjectRequest</b></a><br />
      Create a my-project in the Newforma database.</p><p>
      It is an error to create a my-project with the same ProjectId/ContactId values as another my-project.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"MyProject" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"MyProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DisplayOrder" : <i>int</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>MyProject</td><td>The new my-project to create.</td></tr>
        <tr><td>MyProject.MyProjectId</td><td>The my-project's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>MyProject.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>MyProject.ContactId</td><td>The associated contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>MyProject.DisplayOrder</td><td>The my-project's display order within UIs.</td></tr>
      </tbody></table><p>
      <b>CreateMyProjectResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"MyProjectId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>MyProjectId</td><td>The new my-project's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="CreateOfficeLocationRequest"><b>CreateOfficeLocationRequest</b></a> (Deprecated: use <a href="#CreateOfficeLocation2Request">CreateOfficeLocation2</a> instead.)<br />
      Create an office location in the Newforma database.</p><p>
      It is an error to create an office location with the same location name as another office location in the same company.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"OfficeLocation" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"OfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"LocationName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FaxNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AddressType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation</td><td>The new office location to create.</td></tr>
        <tr><td>OfficeLocation.OfficeLocationId</td><td>The office location's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation.CompanyId</td><td>The office location's associated company's Newforma database ID.</td></tr>
        <tr><td>OfficeLocation.LocationName</td><td>The office location's name.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation.StreetAddress</td><td>The office location's street address.  The format of a street address is either
            five fields (address│city│state│zip│country)
            separated by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>OfficeLocation.PhoneNumber</td><td>The office location's primary phone number.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation.FaxNumber</td><td>The office location's primary fax number.</td></tr>
        <tr><td>OfficeLocation.AddressType</td><td>The office location's address type.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation.SourceDescriptor</td><td>The name of the original datasource that the office location was imported from.</td></tr>
        <tr><td>OfficeLocation.SourcePrimaryKey</td><td>The office location's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <b>CreateOfficeLocationResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"OfficeLocationId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>OfficeLocationId</td><td>The new office location's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="CreateOfficeLocation2Request"><b>CreateOfficeLocation2Request</b></a><br />
      Create an office location in the Newforma database.</p><p>
      It is an error to create an office location with the same location name as another office location in the same company.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"OfficeLocation" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"OfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"LocationName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FaxNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AddressType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PrimaryLocation" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation</td><td>The new office location to create.</td></tr>
        <tr><td>OfficeLocation.OfficeLocationId</td><td>The office location's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation.CompanyId</td><td>The office location's associated company's Newforma database ID.</td></tr>
        <tr><td>OfficeLocation.LocationName</td><td>The office location's name.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation.StreetAddress</td><td>The office location's street address.  The format of a street address is either
            five fields (address│city│state│zip│country)
            separated by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>OfficeLocation.PhoneNumber</td><td>The office location's primary phone number.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation.FaxNumber</td><td>The office location's primary fax number.</td></tr>
        <tr><td>OfficeLocation.AddressType</td><td>The office location's address type.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation.SourceDescriptor</td><td>The name of the original datasource that the office location was imported from.</td></tr>
        <tr><td>OfficeLocation.SourcePrimaryKey</td><td>The office location's primary key in its original datasource.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation.PrimaryLocation</td><td>Is this office location the company's primary location?</td></tr>
      </tbody></table><p>
      <b>CreateOfficeLocation2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"OfficeLocationId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>OfficeLocationId</td><td>The new office location's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="CreateProjectCustomFieldValueRequest"><b>CreateProjectCustomFieldValueRequest</b></a><br />
      Create a project custom field value in the Newforma database.  Creating a custom field value with its default value is a no-op.</p><p>
      It is an error to create a duplicate custom field value, set the custom field's value to an unsupported type for that field, or to create a custom field value not associated with a project custom field layout.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"FieldValue" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue</td><td>The new custom field value to create.</td></tr>
        <tr><td>FieldValue.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>FieldValue.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>FieldValue.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>FieldValue.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.ProjectId</td><td>The project's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>CreateProjectCustomFieldValueResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="CreateProjectFromTemplateRequest"><b>CreateProjectFromTemplateRequest</b></a> (Deprecated: use <a href="#CreateProjectFromTemplate2Request">CreateProjectFromTemplate2</a> instead.)<br />
      Create or update a project in the Newforma database using a batch project creation template.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Server" : <i>string</i>,<br />
        &nbsp;&nbsp;"MasterTemplatePath" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectKey" : <i>string</i>,<br />
        &nbsp;&nbsp;"Block" : <i>boolean</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Server</td><td>The NPCS server to execute the project creation template upon.  This is not necessarily the server where the project is pinned.</td></tr>
        <tr><td>MasterTemplatePath</td><td>The batch project creation master template path.</td></tr>
        <tr bgcolor="efefef"><td>ProjectKey</td><td>The (primary) key used to identify the project in its original datasource for embedded SQL queries within the project creation template.  This field translates to the <source primary key /> property in the project template.</td></tr>
        <tr><td>Block</td><td>Should the project creation operation block for the operation to complete, or perform the operation asynchronously?  Project creation may take a few minutes on servers depending upon many factors, so it may be desirable to perform this request as a non-blocking operation</td></tr>
      </tbody></table><p>
      <b>CreateProjectFromTemplateResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="CreateProjectFromTemplate2Request"><b>CreateProjectFromTemplate2Request</b></a><br />
      Create or update a project in the Newforma database using a batch project creation template.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Server" : <i>string</i>,<br />
        &nbsp;&nbsp;"MasterTemplatePath" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectKey" : <i>string</i>,<br />
        &nbsp;&nbsp;"Block" : <i>boolean</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Server</td><td>The NPCS server to execute the project creation template upon.  This is not necessarily the server where the project is pinned.</td></tr>
        <tr><td>MasterTemplatePath</td><td>The batch project creation master template path.</td></tr>
        <tr bgcolor="efefef"><td>ProjectKey</td><td>The (primary) key used to identify the project in its original datasource for embedded SQL queries within the project creation template.  This field translates to the <source primary key /> property in the project template.</td></tr>
        <tr><td>Block</td><td>Should the project creation operation block for the operation to complete, or perform the operation asynchronously?  Project creation may take a few minutes on servers depending upon many factors, so it may be desirable to perform this request as a non-blocking operation</td></tr>
      </tbody></table><p>
      <b>CreateProjectFromTemplate2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Action" : <i>int</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Action</td><td>The action that was performed on the project.  If the request was non-blocking this value will be ActionNone.<p>Allowed values:<br />
              ActionNone = 0<br />
              ActionCreate = 1<br />
              ActionUpdate = 2</p></td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The created/updated project's Newforma database ID.  If the request was non-blocking this value will be null.</td></tr>
      </tbody></table><p>
      <a name="CreateProjectTeamGroupRequest"><b>CreateProjectTeamGroupRequest</b></a><br />
      Create a project team group in the Newforma database.</p><p>
      It is an error to create a project team group with the same group name as another project team group in the project.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Group" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamGroupId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"GroupName" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Group</td><td>The new project team group to create.</td></tr>
        <tr><td>Group.ProjectTeamGroupId</td><td>The project team group's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Group.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>Group.GroupName</td><td>The project team group's name.</td></tr>
      </tbody></table><p>
      <b>CreateProjectTeamGroupResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectTeamGroupId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>ProjectTeamGroupId</td><td>The new project team group's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="CreateProjectTeamGroupMemberRequest"><b>CreateProjectTeamGroupMemberRequest</b></a><br />
      Create a project team group member in the Newforma database.</p><p>
      It is an error to create a project team group member with the same ProjectTeamGroupId/ProjectTeamMemberId values as another project team group member.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"GroupMember" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamGroupMemberId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamGroupId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>GroupMember</td><td>The new project team group member to create.</td></tr>
        <tr><td>GroupMember.ProjectTeamGroupMemberId</td><td>The project team group member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>GroupMember.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>GroupMember.ProjectTeamGroupId</td><td>The associated project team group's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>GroupMember.ProjectTeamMemberId</td><td>The associated project team member's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>CreateProjectTeamGroupMemberResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectTeamGroupMemberId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>ProjectTeamGroupMemberId</td><td>The new project team group member's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="CreateProjectTeamMemberRequest"><b>CreateProjectTeamMemberRequest</b></a> (Deprecated: use <a href="#CreateProjectTeamMember3Request">CreateProjectTeamMember3</a> instead.)<br />
      Create a project team member in the Newforma database.</p><p>
      It is an error to create a project team member with the same ProjectId/ContactId values as another project team member.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Member" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PermissionSetId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Visibility" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Member</td><td>The new project team member to create.</td></tr>
        <tr><td>Member.ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>Member.ContactId</td><td>The associated contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.PermissionSetId</td><td>The associated permission set's Newforma database ID.</td></tr>
        <tr><td>Member.NixUser</td><td>Does the project team member have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Member.Visibility</td><td>The visibility on NIX of the project team member to other team members.<p>Allowed values:<br />
              VisibilityExtendedProjectTeam = 1<br />
              VisibilityFellowCompanyMembers = 2<br />
              VisibilityNotVisible = 3<br />
              VisibilityExtendedProjectTeamNameAndEmailOnly = 4</p></td></tr>
        <tr><td>Member.AcceptedDisclaimer</td><td>Has the project team member accepted the Terms and Conditions on NIX for this project?</td></tr>
      </tbody></table><p>
      <b>CreateProjectTeamMemberResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>ProjectTeamMemberId</td><td>The new project team member's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="CreateProjectTeamMember2Request"><b>CreateProjectTeamMember2Request</b></a> (Deprecated: use <a href="#CreateProjectTeamMember3Request">CreateProjectTeamMember3</a> instead.)<br />
      Create a project team member in the Newforma database.</p><p>
      It is an error to create a project team member with the same ProjectId/ContactId values as another project team member.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Member" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PermissionSetId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Visibility" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PrimaryContact" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Member</td><td>The new project team member to create.</td></tr>
        <tr><td>Member.ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>Member.ContactId</td><td>The associated contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.PermissionSetId</td><td>The associated permission set's Newforma database ID.</td></tr>
        <tr><td>Member.NixUser</td><td>Does the project team member have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Member.Visibility</td><td>The visibility on NIX of the project team member to other team members.<p>Allowed values:<br />
              VisibilityExtendedProjectTeam = 1<br />
              VisibilityFellowCompanyMembers = 2<br />
              VisibilityNotVisible = 3<br />
              VisibilityExtendedProjectTeamNameAndEmailOnly = 4</p></td></tr>
        <tr><td>Member.AcceptedDisclaimer</td><td>Has the project team member accepted the Terms and Conditions on NIX for this project?</td></tr>
        <tr bgcolor="efefef"><td>Member.PrimaryContact</td><td>Is the project team member a primary contact on the project team?</td></tr>
      </tbody></table><p>
      <b>CreateProjectTeamMember2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>ProjectTeamMemberId</td><td>The new project team member's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="CreateProjectTeamMember3Request"><b>CreateProjectTeamMember3Request</b></a> (Deprecated: use <a href="#CreateProjectTeamMember4Request">CreateProjectTeamMember4</a> instead.)<br />
      Create a project team member in the Newforma database.</p><p>
      It is an error to create a project team member with the same ProjectId/ContactId values as another project team member.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Member" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PermissionSetId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Visibility" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PrimaryContact" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Roles" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ActiveUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CustomFields" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Member</td><td>The new project team member to create.</td></tr>
        <tr><td>Member.ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>Member.ContactId</td><td>The associated contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.PermissionSetId</td><td>The associated permission set's Newforma database ID.</td></tr>
        <tr><td>Member.NixUser</td><td>Does the project team member have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Member.Visibility</td><td>The visibility on NIX of the project team member to other team members.<p>Allowed values:<br />
              VisibilityExtendedProjectTeam = 1<br />
              VisibilityFellowCompanyMembers = 2<br />
              VisibilityNotVisible = 3<br />
              VisibilityExtendedProjectTeamNameAndEmailOnly = 4</p></td></tr>
        <tr><td>Member.AcceptedDisclaimer</td><td>Has the project team member accepted the Terms and Conditions on NIX for this project?</td></tr>
        <tr bgcolor="efefef"><td>Member.PrimaryContact</td><td>Is the project team member a primary contact on the project team?</td></tr>
        <tr><td>Member.Roles</td><td>The project team member's roles.</td></tr>
        <tr bgcolor="efefef"><td>Member.ActiveUser</td><td>Is the project team member active on the project team?</td></tr>
        <tr><td>Member.CustomFields</td><td>The project team member's custom fields.</td></tr>
        <tr><td>Member.CustomFields.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>Member.CustomFields.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>Member.CustomFields.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>Member.CustomFields.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>Member.CustomFields.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>Member.CustomFields.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>Member.CustomFields.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>CreateProjectTeamMember3Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>ProjectTeamMemberId</td><td>The new project team member's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="CreateProjectTeamMember4Request"><b>CreateProjectTeamMember4Request</b></a><br />
      Create a project team member in the Newforma database.</p><p>
      It is an error to create a project team member with the same ProjectId/ContactId values as another project team member.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Member" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PermissionSetId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Visibility" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PrimaryContact" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Roles" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ActiveUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CustomFields" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CloudServicesUser" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Member</td><td>The new project team member to create.</td></tr>
        <tr><td>Member.ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>Member.ContactId</td><td>The associated contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.PermissionSetId</td><td>The associated permission set's Newforma database ID.</td></tr>
        <tr><td>Member.NixUser</td><td>Does the project team member have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Member.Visibility</td><td>The visibility on NIX of the project team member to other team members.<p>Allowed values:<br />
              VisibilityExtendedProjectTeam = 1<br />
              VisibilityFellowCompanyMembers = 2<br />
              VisibilityNotVisible = 3<br />
              VisibilityExtendedProjectTeamNameAndEmailOnly = 4</p></td></tr>
        <tr><td>Member.AcceptedDisclaimer</td><td>Has the project team member accepted the Terms and Conditions on NIX for this project?</td></tr>
        <tr bgcolor="efefef"><td>Member.PrimaryContact</td><td>Is the project team member a primary contact on the project team?</td></tr>
        <tr><td>Member.Roles</td><td>The project team member's roles.</td></tr>
        <tr bgcolor="efefef"><td>Member.ActiveUser</td><td>Is the project team member active on the project team?</td></tr>
        <tr><td>Member.CustomFields</td><td>The project team member's custom fields.</td></tr>
        <tr><td>Member.CustomFields.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>Member.CustomFields.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>Member.CustomFields.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>Member.CustomFields.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>Member.CustomFields.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>Member.CustomFields.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>Member.CustomFields.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.CloudServicesUser</td><td>Does the project team member have Cloud Services access?</td></tr>
      </tbody></table><p>
      <b>CreateProjectTeamMember4Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>ProjectTeamMemberId</td><td>The new project team member's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="CreateProjectTeamMemberCustomFieldValueRequest"><b>CreateProjectTeamMemberCustomFieldValueRequest</b></a><br />
      Create a project team member custom field value in the Newforma database.  Creating a custom field value with its default value is a no-op.</p><p>
      It is an error to create a duplicate custom field value, set the custom field's value to an unsupported type for that field, or to create a custom field value not associated with a project team member custom field layout.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"FieldValue" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue</td><td>The new custom field value to create.</td></tr>
        <tr><td>FieldValue.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>FieldValue.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>FieldValue.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>FieldValue.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>CreateProjectTeamMemberCustomFieldValueResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="CreateSourceDescriptorRequest"><b>CreateSourceDescriptorRequest</b></a> (Deprecated: use <a href="#CreateSourceDescriptor2Request">CreateSourceDescriptor2</a> instead.)<br />
      Create a source descriptor in the Newforma database.</p><p>
      It is an error to create a source descriptor with the same DescriptorName/DescriptorType/FieldType values as another source descriptor.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"SourceDescriptor" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptorId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DescriptorName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DescriptorType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FieldType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"IsEditable" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptor</td><td>The new source descriptor to create.</td></tr>
        <tr><td>SourceDescriptor.SourceDescriptorId</td><td>The source descriptor's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptor.DescriptorName</td><td>The source descriptor's name.</td></tr>
        <tr><td>SourceDescriptor.DescriptorType</td><td>The source descriptor's object type.<p>Allowed values:<br />
              DescriptorTypeContact = 1<br />
              DescriptorTypeCompany = 4<br />
              DescriptorTypeOfficeLocation = 6</p></td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptor.FieldType</td><td>The source descriptor's field type.<p>Allowed values:<br />
              FieldTypeContactEmailAddress = 100<br />
              FieldTypeContactFirstName = 101<br />
              FieldTypeContactLastName = 102<br />
              FieldTypeContactCompany = 103<br />
              FieldTypeContactDepartmentName = 104<br />
              FieldTypeContactJobTitle = 105<br />
              FieldTypeContactDiscipline = 106<br />
              FieldTypeContactPhoneNumberWork = 107<br />
              FieldTypeContactPhoneNumberMobile = 108<br />
              FieldTypeContactPhoneNumberHome = 109<br />
              FieldTypeContactFaxNumber = 110<br />
              FieldTypeContactStreetAddress = 111<br />
              FieldTypeContactNoteText = 112<br />
              FieldTypeContactActiveUser = 113<br />
              FieldTypeCompanyCompanyName = 311<br />
              FieldTypeCompanyWebUrl = 312<br />
              FieldTypeCompanyDisciplineList = 313<br />
              FieldTypeCompanySpecSectionList = 314<br />
              FieldTypeCompanyMainContact = 315<br />
              FieldTypeCompanyNoteText = 316<br />
              FieldTypeOfficeLocationLocationName = 600<br />
              FieldTypeOfficeLocationStreetAddress = 601<br />
              FieldTypeOfficeLocationAddressType = 606<br />
              FieldTypeOfficeLocationPhoneNumber = 607<br />
              FieldTypeOfficeLocationFaxNumber = 608</p></td></tr>
        <tr><td>SourceDescriptor.IsEditable</td><td>Is the field editable in Newforma?</td></tr>
      </tbody></table><p>
      <b>CreateSourceDescriptorResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"SourceDescriptorId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>SourceDescriptorId</td><td>The new source descriptor's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="CreateSourceDescriptor2Request"><b>CreateSourceDescriptor2Request</b></a> (Deprecated: use <a href="#CreateSourceDescriptor3Request">CreateSourceDescriptor3</a> instead.)<br />
      Create a source descriptor in the Newforma database.</p><p>
      It is an error to create a source descriptor with the same DescriptorName/DescriptorType/FieldType values as another source descriptor.
      It is an error use the following values for a source descriptor name:
    </p><ul>
      <li>Manual</li>
      <li>Global Address List</li>
      <li>Microsoft Project</li>
      <li>Microsoft Outlook</li>
      <li>Ad Hoc</li>
    </ul>
    <p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"SourceDescriptor" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptorId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DescriptorName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DescriptorType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FieldType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"IsEditable" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptor</td><td>The new source descriptor to create.</td></tr>
        <tr><td>SourceDescriptor.SourceDescriptorId</td><td>The source descriptor's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptor.DescriptorName</td><td>The source descriptor's name.</td></tr>
        <tr><td>SourceDescriptor.DescriptorType</td><td>The source descriptor's object type.<p>Allowed values:<br />
              DescriptorTypeContact = 1<br />
              DescriptorTypeCompany = 4<br />
              DescriptorTypeOfficeLocation = 6</p></td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptor.FieldType</td><td>The source descriptor's field type.<p>Allowed values:<br />
              FieldTypeContactEmailAddress = 100<br />
              FieldTypeContactFirstName = 101<br />
              FieldTypeContactLastName = 102<br />
              FieldTypeContactCompany = 103<br />
              FieldTypeContactDepartmentName = 104<br />
              FieldTypeContactJobTitle = 105<br />
              FieldTypeContactDiscipline = 106<br />
              FieldTypeContactPhoneNumberWork = 107<br />
              FieldTypeContactPhoneNumberMobile = 108<br />
              FieldTypeContactPhoneNumberHome = 109<br />
              FieldTypeContactFaxNumber = 110<br />
              FieldTypeContactStreetAddress = 111<br />
              FieldTypeContactNoteText = 112<br />
              FieldTypeContactActiveUser = 113<br />
              FieldTypeCompanyCompanyName = 311<br />
              FieldTypeCompanyWebUrl = 312<br />
              FieldTypeCompanyDisciplineList = 313<br />
              FieldTypeCompanySpecSectionList = 314<br />
              FieldTypeCompanyMainContact = 315<br />
              FieldTypeCompanyNoteText = 316<br />
              FieldTypeOfficeLocationLocationName = 600<br />
              FieldTypeOfficeLocationStreetAddress = 601<br />
              FieldTypeOfficeLocationAddressType = 606<br />
              FieldTypeOfficeLocationPhoneNumber = 607<br />
              FieldTypeOfficeLocationFaxNumber = 608<br />
              FieldTypeContactOfficeLocation = 114<br />
              FieldTypeContactAddressType = 115<br />
              FieldTypeContactUseOfficeAddress = 116<br />
              FieldTypeOfficeLocationIsPrimary = 609</p></td></tr>
        <tr><td>SourceDescriptor.IsEditable</td><td>Is the field editable in Newforma?</td></tr>
      </tbody></table><p>
      <b>CreateSourceDescriptor2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"SourceDescriptorId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>SourceDescriptorId</td><td>The new source descriptor's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="CreateSourceDescriptor3Request"><b>CreateSourceDescriptor3Request</b></a><br />
      Create a source descriptor in the Newforma database.</p><p>
      It is an error to create a source descriptor with the same DescriptorName/DescriptorType/FieldType values as another source descriptor.
      It is an error use the following values for a source descriptor name:
    </p><ul>
      <li>Manual</li>
      <li>Global Address List</li>
      <li>Microsoft Project</li>
      <li>Microsoft Outlook</li>
      <li>Ad Hoc</li>
    </ul>
    <p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"SourceDescriptor" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptorId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DescriptorName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DescriptorType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FieldType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"IsEditable" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptor</td><td>The new source descriptor to create.</td></tr>
        <tr><td>SourceDescriptor.SourceDescriptorId</td><td>The source descriptor's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptor.DescriptorName</td><td>The source descriptor's name.</td></tr>
        <tr><td>SourceDescriptor.DescriptorType</td><td>The source descriptor's object type.<p>Allowed values:<br />
              DescriptorTypeContact = 1<br />
              DescriptorTypeCompany = 4<br />
              DescriptorTypeOfficeLocation = 6</p></td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptor.FieldType</td><td>The source descriptor's field type.<p>Allowed values:<br />
              FieldTypeContactEmailAddress = 100<br />
              FieldTypeContactFirstName = 101<br />
              FieldTypeContactLastName = 102<br />
              FieldTypeContactCompany = 103<br />
              FieldTypeContactDepartmentName = 104<br />
              FieldTypeContactJobTitle = 105<br />
              FieldTypeContactDiscipline = 106<br />
              FieldTypeContactPhoneNumberWork = 107<br />
              FieldTypeContactPhoneNumberMobile = 108<br />
              FieldTypeContactPhoneNumberHome = 109<br />
              FieldTypeContactFaxNumber = 110<br />
              FieldTypeContactStreetAddress = 111<br />
              FieldTypeContactNoteText = 112<br />
              FieldTypeContactActiveUser = 113<br />
              FieldTypeCompanyCompanyName = 311<br />
              FieldTypeCompanyWebUrl = 312<br />
              FieldTypeCompanyDisciplineList = 313<br />
              FieldTypeCompanySpecSectionList = 314<br />
              FieldTypeCompanyMainContact = 315<br />
              FieldTypeCompanyNoteText = 316<br />
              FieldTypeOfficeLocationLocationName = 600<br />
              FieldTypeOfficeLocationStreetAddress = 601<br />
              FieldTypeOfficeLocationAddressType = 606<br />
              FieldTypeOfficeLocationPhoneNumber = 607<br />
              FieldTypeOfficeLocationFaxNumber = 608<br />
              FieldTypeContactOfficeLocation = 114<br />
              FieldTypeContactAddressType = 115<br />
              FieldTypeContactUseOfficeAddress = 116<br />
              FieldTypeOfficeLocationIsPrimary = 609<br />
              FieldTypeContactRoles = 117</p></td></tr>
        <tr><td>SourceDescriptor.IsEditable</td><td>Is the field editable in Newforma?</td></tr>
      </tbody></table><p>
      <b>CreateSourceDescriptor3Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"SourceDescriptorId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>SourceDescriptorId</td><td>The new source descriptor's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="CreateUserRequest"><b>CreateUserRequest</b></a> (Deprecated: use <a href="#CreateUser3Request">CreateUser3</a> instead.)<br />
      Create a user in the Newforma database.</p><p>
      It is an error to create a user with the same user name as another user, or to set the ContactId of the user to a contact which is already associated with a different user.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"User" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"UserName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"HomeServer" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AdminUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectCreator" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CAUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProfessionalUser" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>User</td><td>The new user to create.</td></tr>
        <tr><td>User.UserName</td><td>The user's user name and Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>User.ContactId</td><td>The user's associated contact's Newforma database ID.</td></tr>
        <tr><td>User.HomeServer</td><td>The user's home NPCS server.</td></tr>
        <tr bgcolor="efefef"><td>User.AdminUser</td><td>Is the user a Newform administrator?</td></tr>
        <tr><td>User.ProjectCreator</td><td>Does the user have project creation privledges?  Administrators always have this privledge.</td></tr>
        <tr bgcolor="efefef"><td>User.CAUser</td><td>Is the user a Contract Administrator?</td></tr>
        <tr><td>User.ProfessionalUser</td><td>Is the user a Professional-licensed user?  Contact Administrators are always Professional-licensed users as well.</td></tr>
      </tbody></table><p>
      <b>CreateUserResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="CreateUser2Request"><b>CreateUser2Request</b></a> (Deprecated: use <a href="#CreateUser3Request">CreateUser3</a> instead.)<br />
      Create a user in the Newforma database.</p><p>
      It is an error to create a user with the same user name as another user, or to set the ContactId of the user to a contact which is already associated with a different user.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"User" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"UserName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"HomeServer" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AdminUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectCreator" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CAUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProfessionalUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContentAdmin" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>User</td><td>The new user to create.</td></tr>
        <tr><td>User.UserName</td><td>The user's user name and Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>User.ContactId</td><td>The user's associated contact's Newforma database ID.</td></tr>
        <tr><td>User.HomeServer</td><td>The user's home NPCS server.</td></tr>
        <tr bgcolor="efefef"><td>User.AdminUser</td><td>Is the user a Newform administrator?</td></tr>
        <tr><td>User.ProjectCreator</td><td>Does the user have project creation privledges?  Administrators always have this privledge.</td></tr>
        <tr bgcolor="efefef"><td>User.CAUser</td><td>Is the user a Contract Administrator?</td></tr>
        <tr><td>User.ProfessionalUser</td><td>Is the user a Professional-licensed user?  Contact Administrators are always Professional-licensed users as well.</td></tr>
        <tr bgcolor="efefef"><td>User.ContentAdmin</td><td>Does the user have content administration privledges?  Administrators always have this privledge.</td></tr>
      </tbody></table><p>
      <b>CreateUser2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="CreateUser3Request"><b>CreateUser3Request</b></a><br />
      Create a user in the Newforma database.</p><p>
      It is an error to create a user with the same user name as another user, or to set the ContactId of the user to a contact which is already associated with a different user.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"User" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"UserName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"HomeServer" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AdminUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectCreator" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CAUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProfessionalUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContentAdmin" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FinancialManager" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>User</td><td>The new user to create.</td></tr>
        <tr><td>User.UserName</td><td>The user's user name and Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>User.ContactId</td><td>The user's associated contact's Newforma database ID.</td></tr>
        <tr><td>User.HomeServer</td><td>The user's home NPCS server.</td></tr>
        <tr bgcolor="efefef"><td>User.AdminUser</td><td>Is the user a Newform administrator?</td></tr>
        <tr><td>User.ProjectCreator</td><td>Does the user have project creation privledges?  Administrators always have this privledge.</td></tr>
        <tr bgcolor="efefef"><td>User.CAUser</td><td>Is the user a Contract Administrator?</td></tr>
        <tr><td>User.ProfessionalUser</td><td>Is the user a Professional-licensed user?  Contact Administrators are always Professional-licensed users as well.</td></tr>
        <tr bgcolor="efefef"><td>User.ContentAdmin</td><td>Does the user have content administration privledges?  Administrators always have this privledge.</td></tr>
        <tr><td>User.FinancialManager</td><td>Does the user have financial manager privileges?</td></tr>
      </tbody></table><p>
      <b>CreateUser3Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="CreateWebLinkRequest"><b>CreateWebLinkRequest</b></a><br />
      Create a web link for a project item.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;"WebLink" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"UrlName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Subject" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SharedExternally" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma datababase ID.</td></tr>
        <tr><td>ProjectItemId</td><td>The project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>WebLink</td><td>The web link to add.</td></tr>
        <tr><td>WebLink.UrlName</td><td>The web link's URL.</td></tr>
        <tr bgcolor="efefef"><td>WebLink.Subject</td><td>The web link's subject.</td></tr>
        <tr><td>WebLink.SharedExternally</td><td>Is the web link shared externally on NIX?</td></tr>
      </tbody></table><p>
      <b>CreateWebLinkResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="DeleteCompanyRequest"><b>DeleteCompanyRequest</b></a><br />
      Delete a company in the Newforma database.</p><p>
      It is an error to delete a company that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"CompanyId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>CompanyId</td><td>The company's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>DeleteCompanyResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="DeleteCompanyCommentRequest"><b>DeleteCompanyCommentRequest</b></a><br />
      Delete a company comment in the Newforma database.</p><p>
      It is an error to delete a comment that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;"CommentId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>CompanyId</td><td>The company's Newforma database ID.</td></tr>
        <tr><td>CommentId</td><td>The comment's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>DeleteCompanyCommentResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="DeleteCompanyCustomFieldValueRequest"><b>DeleteCompanyCustomFieldValueRequest</b></a><br />
      Delete a company custom field value in the Newforma database.</p><p>
      It is an error to delete a custom field value that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;"CustomFieldId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>CompanyId</td><td>The company's Newforma database ID.</td></tr>
        <tr><td>CustomFieldId</td><td>The custom field's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>DeleteCompanyCustomFieldValueResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="DeleteContactRequest"><b>DeleteContactRequest</b></a><br />
      Delete a contact in the Newforma database.</p><p>
      It is an error to delete a contact that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ContactId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ContactId</td><td>The contact's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>DeleteContactResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="DeleteContactCommentRequest"><b>DeleteContactCommentRequest</b></a><br />
      Delete a contact comment in the Newforma database.</p><p>
      It is an error to delete a comment that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;"CommentId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ContactId</td><td>The contact's Newforma database ID.</td></tr>
        <tr><td>CommentId</td><td>The comment's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>DeleteContactCommentResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="DeleteContactCustomFieldValueRequest"><b>DeleteContactCustomFieldValueRequest</b></a><br />
      Delete a contact custom field value in the Newforma database.</p><p>
      It is an error to delete a custom field value that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;"CustomFieldId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ContactId</td><td>The contact's Newforma database ID.</td></tr>
        <tr><td>CustomFieldId</td><td>The custom field's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>DeleteContactCustomFieldValueResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="DeleteMyProjectRequest"><b>DeleteMyProjectRequest</b></a><br />
      Delete a my-project in the Newforma database.</p><p>
      It is an error to delete a my-project that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;"MyProjectId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ContactId</td><td>The associated contact's Newforma database ID.</td></tr>
        <tr><td>MyProjectId</td><td>The my-project's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>DeleteMyProjectResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="DeleteOfficeLocationRequest"><b>DeleteOfficeLocationRequest</b></a><br />
      Delete an office location in the Newforma database.</p><p>
      It is an error to delete an office location that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;"OfficeLocationId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>CompanyId</td><td>The associated company's Newforma database ID.</td></tr>
        <tr><td>OfficeLocationId</td><td>The office location's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>DeleteOfficeLocationResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="DeleteProjectCustomFieldValueRequest"><b>DeleteProjectCustomFieldValueRequest</b></a><br />
      Delete a project custom field value in the Newforma database.</p><p>
      It is an error to delete a custom field value that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"CustomFieldId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>CustomFieldId</td><td>The custom field's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>DeleteProjectCustomFieldValueResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="DeleteProjectTeamGroupRequest"><b>DeleteProjectTeamGroupRequest</b></a><br />
      Delete a project team group in the Newforma database.</p><p>
      It is an error to delete a project team group that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectTeamGroupId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>ProjectTeamGroupId</td><td>The project team group's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>DeleteProjectTeamGroupResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="DeleteProjectTeamGroupMemberRequest"><b>DeleteProjectTeamGroupMemberRequest</b></a><br />
      Delete a project team group member in the Newforma database.</p><p>
      It is an error to delete a project team group member that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectTeamGroupMemberId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>ProjectTeamGroupMemberId</td><td>The project team group member's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>DeleteProjectTeamGroupMemberResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="DeleteProjectTeamMemberRequest"><b>DeleteProjectTeamMemberRequest</b></a><br />
      Delete a project team member in the Newforma database.</p><p>
      It is an error to delete a project team member that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>DeleteProjectTeamMemberResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="DeleteProjectTeamMemberCustomFieldValueRequest"><b>DeleteProjectTeamMemberCustomFieldValueRequest</b></a><br />
      Delete a project team member custom field value in the Newforma database.</p><p>
      It is an error to delete a custom field value that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i>,<br />
        &nbsp;&nbsp;"CustomFieldId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
        <tr><td>CustomFieldId</td><td>The custom field's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>DeleteProjectTeamMemberCustomFieldValueResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="DeleteSourceDescriptorRequest"><b>DeleteSourceDescriptorRequest</b></a><br />
      Delete a source descriptor in the Newforma database.</p><p>
      It is an error to delete a source descriptor that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"SourceDescriptorId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptorId</td><td>The source descriptor's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>DeleteSourceDescriptorResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="DeleteUserRequest"><b>DeleteUserRequest</b></a><br />
      Delete a user in the Newforma database.</p><p>
      It is an error to delete a user that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"UserName" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>UserName</td><td>--</td></tr>
      </tbody></table><p>
      <b>DeleteUserResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="DeleteWebLinkRequest"><b>DeleteWebLinkRequest</b></a><br />
      Remove a web link from a project item.  The web link will still be associated with other project items that it was previously related to.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;"UrlName" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma datababase ID.</td></tr>
        <tr><td>ProjectItemId</td><td>The project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>UrlName</td><td>The URL of the web link to remove.</td></tr>
      </tbody></table><p>
      <b>DeleteWebLinkResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="EvaluateLiveFoldersRequest"><b>EvaluateLiveFoldersRequest</b></a><br />
      Get the contents of all live folders within a Document Set.</p><p>
      It is an error to retrieve live folder contents for a project/document set that does not exist, or the project is not available on NIX.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectItemId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>ProjectItemId</td><td>The Document Set's Newforma datababase ID.</td></tr>
      </tbody></table><p>
      <b>EvaluateLiveFoldersResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"LiveFolderContents" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>LiveFolderContents</td><td>The Document Set's live folder contents as a collection of UNC paths.</td></tr>
      </tbody></table><p>
      <a name="EvaluateLiveFolders2Request"><b>EvaluateLiveFolders2Request</b></a><br />
      Get the contents of all live folders within a Document Set.</p><p>
      It is an error to retrieve live folder contents for a project/document set that does not exist, or the project is not available on NIX.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectItemId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>ProjectItemId</td><td>The Document Set's Newforma datababase ID.</td></tr>
      </tbody></table><p>
      <b>EvaluateLiveFolders2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"LiveFolderContents" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>LiveFolderContents</td><td>--</td></tr>
        <tr><td>LiveFolderContents.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>LiveFolderContents.FullPath</td><td>Full path of the file/folder</td></tr>
      </tbody></table><p>
      <a name="GetActionItemSummaryRequest"><b>GetActionItemSummaryRequest</b></a><br />
      Get Action Item summaries from a project matching a category filter.</p><p>
      It is an error to retrieve project items for a project that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"CategoryFilter" : <i>int</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>CategoryFilter</td><td>The category of project items to return.  To return all project items use the CategoryFilterAll filter.<p>Allowed values:<br />
              CategoryFilterAll = 1<br />
              CategoryFilterOpen = 2<br />
              CategoryFilterOpenAwaitingAssignment = 4<br />
              CategoryFilterOpenDueIn8Days = 8<br />
              CategoryFilterOpenOverdue = 16<br />
              CategoryFilterClosed = 32<br />
              CategoryFilterDeferred = 64</p></td></tr>
      </tbody></table><p>
      <b>GetActionItemSummaryResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Summaries" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Name" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Summaries</td><td>The Action Item summaries matching the category filter.</td></tr>
        <tr><td>Summaries.ProjectItemId</td><td>The project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>Summaries.Name</td><td>The project item's name.</td></tr>
        <tr><td>Summaries.Number</td><td>The project item's number.</td></tr>
      </tbody></table><p>
      <a name="GetActionItemsRequest"><b>GetActionItemsRequest</b></a><br />
      Get Action Items from a project for a set of project item IDs.</p><p>
      It is an error to retrieve project items for a project that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectItemIds" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>ProjectItemIds</td><td>The project items' Newforma database IDs.</td></tr>
      </tbody></table><p>
      <b>GetActionItemsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"ActionItems" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Name" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Keywords" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SupportingDocuments" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EmailLog" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AssignedByContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AssignedToContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CCContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StatusLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Priority" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Disciplines" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DueDate" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ReminderDays" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CloseDate" : <i>datetime</i> <sup>1</sup><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>ActionItems</td><td>The Action Items matching the project item IDs.</td></tr>
        <tr><td>ActionItems.ProjectItemId</td><td>The project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>ActionItems.Name</td><td>The project item's name.</td></tr>
        <tr><td>ActionItems.Number</td><td>The project item's number.</td></tr>
        <tr bgcolor="efefef"><td>ActionItems.Keywords</td><td>The project item's keywords.</td></tr>
        <tr><td>ActionItems.SupportingDocuments</td><td>The project item's supporting documents as a collection of UNC paths.</td></tr>
        <tr bgcolor="efefef"><td>ActionItems.EmailLog</td><td>The project item's email log as a collection of UNC paths.</td></tr>
        <tr><td>ActionItems.AssignedByContactId</td><td>The Newforma database ID of the contact that assigned the Action Item.</td></tr>
        <tr bgcolor="efefef"><td>ActionItems.AssignedToContactIds</td><td>The Newforma database IDs of the contacts who are assigned to Action Item.</td></tr>
        <tr><td>ActionItems.CCContactIds</td><td>The Newforma database IDs of the contacts who are CCed on the Action Item.</td></tr>
        <tr bgcolor="efefef"><td>ActionItems.Status</td><td>The Action Item's status.<p>Allowed values:<br />
              StatusOpen = 0<br />
              StatusClosed = 1<br />
              StatusDeferred = 2</p></td></tr>
        <tr><td>ActionItems.StatusLabel</td><td>The Action Item's status label.</td></tr>
        <tr bgcolor="efefef"><td>ActionItems.Priority</td><td>The Action Item's priority.</td></tr>
        <tr><td>ActionItems.Disciplines</td><td>The Action Item's semicolon-separated discipline list.</td></tr>
        <tr bgcolor="efefef"><td>ActionItems.DueDate</td><td>The Action Item's due date in UTC time.</td></tr>
        <tr><td>ActionItems.ReminderDays</td><td>The number of days before the Action Item is due to send a reminder.</td></tr>
        <tr bgcolor="efefef"><td>ActionItems.CloseDate</td><td>The Action Item's closed date in UTC time.</td></tr>
      </tbody></table><p>
      <a name="GetActionItems2Request"><b>GetActionItems2Request</b></a><br />
      Get Action Items from a project for a set of project item IDs.</p><p>
      It is an error to retrieve project items for a project that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectItemIds" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>ProjectItemIds</td><td>The project items' Newforma database IDs.</td></tr>
      </tbody></table><p>
      <b>GetActionItems2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"ActionItems" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Name" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Keywords" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SupportingDocuments" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProviderId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"VersionNumber" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EmailLog" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProviderId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AssignedByContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AssignedToContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CCContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StatusLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Priority" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Disciplines" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DueDate" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ReminderDays" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CloseDate" : <i>datetime</i> <sup>1</sup><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>ActionItems</td><td>The Action Items matching the project item IDs.</td></tr>
        <tr><td>ActionItems.ProjectItemId</td><td>The project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>ActionItems.Name</td><td>The project item's name.</td></tr>
        <tr><td>ActionItems.Number</td><td>The project item's number.</td></tr>
        <tr bgcolor="efefef"><td>ActionItems.Keywords</td><td>The project item's keywords.</td></tr>
        <tr><td>ActionItems.SupportingDocuments</td><td>--</td></tr>
        <tr><td>ActionItems.SupportingDocuments.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>ActionItems.SupportingDocuments.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr><td>ActionItems.SupportingDocuments.ProviderId</td><td>File's EDMS plugin's provider id</td></tr>
        <tr bgcolor="efefef"><td>ActionItems.SupportingDocuments.VersionNumber</td><td>File's version number</td></tr>
        <tr bgcolor="efefef"><td>ActionItems.EmailLog</td><td>--</td></tr>
        <tr><td>ActionItems.EmailLog.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>ActionItems.EmailLog.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr><td>ActionItems.EmailLog.ProviderId</td><td>File's EDMS plugin's provider id</td></tr>
        <tr><td>ActionItems.AssignedByContactId</td><td>The Newforma database ID of the contact that assigned the Action Item.</td></tr>
        <tr bgcolor="efefef"><td>ActionItems.AssignedToContactIds</td><td>The Newforma database IDs of the contacts who are assigned to Action Item.</td></tr>
        <tr><td>ActionItems.CCContactIds</td><td>The Newforma database IDs of the contacts who are CCed on the Action Item.</td></tr>
        <tr bgcolor="efefef"><td>ActionItems.Status</td><td>The Action Item's status.<p>Allowed values:<br />
              StatusOpen = 0<br />
              StatusClosed = 1<br />
              StatusDeferred = 2</p></td></tr>
        <tr><td>ActionItems.StatusLabel</td><td>The Action Item's status label.</td></tr>
        <tr bgcolor="efefef"><td>ActionItems.Priority</td><td>The Action Item's priority.</td></tr>
        <tr><td>ActionItems.Disciplines</td><td>The Action Item's semicolon-separated discipline list.</td></tr>
        <tr bgcolor="efefef"><td>ActionItems.DueDate</td><td>The Action Item's due date in UTC time.</td></tr>
        <tr><td>ActionItems.ReminderDays</td><td>The number of days before the Action Item is due to send a reminder.</td></tr>
        <tr bgcolor="efefef"><td>ActionItems.CloseDate</td><td>The Action Item's closed date in UTC time.</td></tr>
      </tbody></table><p>
      <a name="GetAllCompanyDescriptorsRequest"><b>GetAllCompanyDescriptorsRequest</b></a><br />
      Get descriptor information about all companies in the Newforma database.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
      </tbody></table><p>
      <b>GetAllCompanyDescriptorsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Descriptors" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"OfficeLocations" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"OfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"LocationName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Descriptors</td><td>Descriptor information for all companies in the Newforma database.</td></tr>
        <tr><td>Descriptors.CompanyId</td><td>The company's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.CompanyName</td><td>The company's name.</td></tr>
        <tr><td>Descriptors.OfficeLocations</td><td>Descriptor information for all office locations associated with the company in the Newforma database.</td></tr>
        <tr><td>Descriptors.OfficeLocations.OfficeLocationId</td><td>The office location's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.OfficeLocations.LocationName</td><td>The office location's name.</td></tr>
        <tr><td>Descriptors.OfficeLocations.SourceDescriptor</td><td>The name of the original datasource that the office location was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.OfficeLocations.SourcePrimaryKey</td><td>The office location's primary key in its original datasource.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.SourceDescriptor</td><td>The name of the original datasource that the company was imported from.</td></tr>
        <tr><td>Descriptors.SourcePrimaryKey</td><td>The company's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <a name="GetAllContactDescriptorsRequest"><b>GetAllContactDescriptorsRequest</b></a><br />
      Get descriptor information about all contacts in the Newforma database.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
      </tbody></table><p>
      <b>GetAllContactDescriptorsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Descriptors" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EmailAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Descriptors</td><td>Descriptor information for all contacts in the Newforma database.</td></tr>
        <tr><td>Descriptors.ContactId</td><td>The contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.EmailAddress</td><td>The contact's email address.</td></tr>
        <tr><td>Descriptors.SourceDescriptor</td><td>The name of the original datasource that the contact was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.SourcePrimaryKey</td><td>The contact's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <a name="GetAllCustomFieldsRequest"><b>GetAllCustomFieldsRequest</b></a><br />
      Get all custom field definitions in the Newforma database.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
      </tbody></table><p>
      <b>GetAllCustomFieldsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"CustomFields" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"KeywordListId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FieldName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FieldType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Description" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Tag" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DefaultValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AllowExternalUserAccess" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ShowInLogView" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ShowInLogViewByDefault" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Active" : <i>boolean</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"CustomFieldLayouts" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldLayoutId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"LayoutName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Description" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"LayoutType" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"CustomFieldGroups" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldGroupId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldLayoutId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"GroupName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"GroupOrder" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Column" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"CustomFieldGroupMembers" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldGroupMemberId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldGroupId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FieldOrder" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>CustomFields</td><td>All of the custom fields in the Newforma database.</td></tr>
        <tr><td>CustomFields.CustomFieldId</td><td>The custom field's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>CustomFields.KeywordListId</td><td>Optional associated keyword list Newforma database ID used for keyword, and keyword list fields.</td></tr>
        <tr><td>CustomFields.FieldName</td><td>The custom field's name.</td></tr>
        <tr bgcolor="efefef"><td>CustomFields.FieldType</td><td>The custom field's data type.<p>Allowed values:<br />
              FieldTypeText = 1<br />
              FieldTypeNote = 2<br />
              FieldTypeDate = 3<br />
              FieldTypeDateTime = 4<br />
              FieldTypeTimeOfDay = 5<br />
              FieldTypeCurrency = 6<br />
              FieldTypeQuantity = 7<br />
              FieldTypeNumeric = 8<br />
              FieldTypeEmail = 9<br />
              FieldTypePhone = 10<br />
              FieldTypeBoolean = 11<br />
              FieldTypeURL = 12<br />
              FieldTypeKeyword = 13<br />
              FieldTypeKeywordList = 14</p></td></tr>
        <tr><td>CustomFields.Description</td><td>The custom field's description.</td></tr>
        <tr bgcolor="efefef"><td>CustomFields.Tag</td><td>The XML tag used in reports, and form letters for the custom field.</td></tr>
        <tr><td>CustomFields.DefaultValue</td><td>The default value for the custom field.</td></tr>
        <tr><td>CustomFields.DefaultValue.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>CustomFields.DefaultValue.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>CustomFields.DefaultValue.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>CustomFields.DefaultValue.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>CustomFields.DefaultValue.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>CustomFields.DefaultValue.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>CustomFields.DefaultValue.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>CustomFields.DefaultValue.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>CustomFields.DefaultValue.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>CustomFields.DefaultValue.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>CustomFields.DefaultValue.BooleanValue</td><td>The boolean value.</td></tr>
        <tr bgcolor="efefef"><td>CustomFields.AllowExternalUserAccess</td><td>Are external users allowed to see this custom field?</td></tr>
        <tr><td>CustomFields.ShowInLogView</td><td>Is the custom field shown in log views?</td></tr>
        <tr bgcolor="efefef"><td>CustomFields.ShowInLogViewByDefault</td><td>Is the custom field shown in log views by default?</td></tr>
        <tr><td>CustomFields.Active</td><td>Is the custom field active?</td></tr>
        <tr bgcolor="efefef"><td>CustomFieldLayouts</td><td>All of the custom field layouts in the Newforma database.</td></tr>
        <tr><td>CustomFieldLayouts.CustomFieldLayoutId</td><td>The custom field layout's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>CustomFieldLayouts.LayoutName</td><td>The custom field layout's name.</td></tr>
        <tr><td>CustomFieldLayouts.Description</td><td>The custom field layout's description.</td></tr>
        <tr bgcolor="efefef"><td>CustomFieldLayouts.LayoutType</td><td>The custom field layout's type.<p>Allowed values:<br />
              LayoutTypeContact = 1<br />
              LayoutTypeCompany = 2<br />
              LayoutTypeProject = 3<br />
              LayoutTypeProjectTeamMember = 4</p></td></tr>
        <tr><td>CustomFieldGroups</td><td>All of the custom field groups in the Newforma database.</td></tr>
        <tr><td>CustomFieldGroups.CustomFieldGroupId</td><td>The custom field group's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>CustomFieldGroups.CustomFieldLayoutId</td><td>The associated field layout's Newforma database ID.</td></tr>
        <tr><td>CustomFieldGroups.GroupName</td><td>The custom field group's name.</td></tr>
        <tr bgcolor="efefef"><td>CustomFieldGroups.GroupOrder</td><td>The custom field group's order within the column.  A value of 0 indicates the group is the top ungrouped collection of fields.  A value of 2147483647 (2<sup>31</sup> - 1) indicates the bottom ungrouped collection of fields.</td></tr>
        <tr><td>CustomFieldGroups.Column</td><td>The custom field group's column.<p>Allowed values:<br />
              ColumnLeft = 1<br />
              ColumnRight = 2</p></td></tr>
        <tr bgcolor="efefef"><td>CustomFieldGroupMembers</td><td>All of the custom field group members in the Newforma database.</td></tr>
        <tr><td>CustomFieldGroupMembers.CustomFieldGroupMemberId</td><td>The custom field group member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>CustomFieldGroupMembers.CustomFieldGroupId</td><td>The custom field group's Newforma database ID.</td></tr>
        <tr><td>CustomFieldGroupMembers.CustomFieldId</td><td>The associated custom field's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>CustomFieldGroupMembers.FieldOrder</td><td>The custom field group member's order within the group.</td></tr>
      </tbody></table><p>
      <a name="GetAllEDMSPluginConfigsRequest"><b>GetAllEDMSPluginConfigsRequest</b></a><br />
      Get all EDMS plugin configuration information.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
      </tbody></table><p>
      <b>GetAllEDMSPluginConfigsResponse</b><br />
      Response to get all EDMS plugin configuration information.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"EDMSPluginConfigs" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Id" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ConfigName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PluginId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>EDMSPluginConfigs</td><td>all EDMS plugin configuration information</td></tr>
        <tr><td>EDMSPluginConfigs.Id</td><td>unique id of the edms plugin configuration</td></tr>
        <tr bgcolor="efefef"><td>EDMSPluginConfigs.ConfigName</td><td>edms plugin configuration name</td></tr>
        <tr><td>EDMSPluginConfigs.PluginId</td><td>plugin id</td></tr>
      </tbody></table><p>
      <a name="GetAllKeywordListsRequest"><b>GetAllKeywordListsRequest</b></a> (Deprecated: use <a href="#GetAllKeywordLists2Request">GetAllKeywordLists2</a> instead.)<br />
      Get all keyword lists in the Newforma database.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
      </tbody></table><p>
      <b>GetAllKeywordListsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Lists" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"KeywordListId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ListName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ListType" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"Definitions" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"KeywordListDefinitionId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"KeywordListId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"KeywordName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"KeywordType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Description" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DisplayOrder" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Lists</td><td>All of the keyword lists in the Newforma database.</td></tr>
        <tr><td>Lists.KeywordListId</td><td>The keyword list's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Lists.ListName</td><td>The keyword list's name.</td></tr>
        <tr><td>Lists.ListType</td><td>The keyword list's type.<p>Allowed values:<br />
              ListTypeTransmittalPurposes = 1<br />
              ListTypeSubmittalActions = 2<br />
              ListTypeRFIActions = 3<br />
              ListTypePhysicalTransferMethods = 4<br />
              ListTypeProjectStatus = 5<br />
              ListTypeDiscipline = 6<br />
              ListTypeKeyword = 7<br />
              ListTypeMarkupStatus = 8<br />
              ListTypePriority = 9<br />
              ListTypeProjectType = 10<br />
              ListTypeSpecSection = 11<br />
              ListTypeActionItemStatus = 12<br />
              ListTypeMarkupSessionStatus = 13<br />
              ListTypeDocumentSetStatus = 14<br />
              ListTypeAddressTypes = 15<br />
              ListTypeDocumentControlTypes = 16<br />
              ListTypePunchListTypes = 17<br />
              ListTypePunchListLocations = 18<br />
              ListTypePunchListPurposes = 19<br />
              ListTypePunchListStatus = 20<br />
              ListTypePunchListKeywords = 21<br />
              ListTypePunchListDiscussionActions = 22<br />
              ListTypeScales = 23<br />
              ListTypeSizes = 24<br />
              ListTypeRecordDocumentRevisionStates = 25<br />
              ListTypeRecordDocumentStatus = 26<br />
              ListTypeProjectPhase = 27<br />
              ListTypeAutoNumberingPrefixes = 28<br />
              ListTypeWorkflowStatus = 64<br />
              ListTypeReasons = 65<br />
              ListTypeASIActions = 66<br />
              ListTypeUACSubmittalActions = 67<br />
              ListTypeContractStatus = 68<br />
              ListTypeContractTypes = 69<br />
              ListTypeContractFunction = 70<br />
              ListTypeRFITypes = 71<br />
              ListTypeUACRFIActions = 72<br />
              ListTypeSketchTypes = 73<br />
              ListTypeSketchStatus = 74<br />
              ListTypeAddendumActions = 75<br />
              ListTypeChangeOrderActions = 76<br />
              ListTypeChangeOrderProposalActions = 77<br />
              ListTypeBulletinActions = 78<br />
              ListTypeBulletinTypes = 79<br />
              ListTypeCOPStatus = 80<br />
              ListTypeCCDSumTypes = 81<br />
              ListTypeProposalRequestActions = 82<br />
              ListTypeCCDActions = 83</p></td></tr>
        <tr bgcolor="efefef"><td>Definitions</td><td>All of the keyword list definitions in the Newforma database.</td></tr>
        <tr><td>Definitions.KeywordListDefinitionId</td><td>The keyword list definition's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Definitions.KeywordListId</td><td>The associated keyword list's Newforma database ID.</td></tr>
        <tr><td>Definitions.KeywordName</td><td>The keyword list definition's name.</td></tr>
        <tr bgcolor="efefef"><td>Definitions.KeywordType</td><td>The keyword list definition's type.<p>Allowed values:<br />
              KeywordTypeGenericKeyword = 0<br />
              KeywordTypePhysicalTransferMethod = 1<br />
              KeywordTypeBasicTransmittalIncoming = 2<br />
              KeywordTypeBasicTransmittalOutgoing = 3<br />
              KeywordTypeSubmittalReceive = 4<br />
              KeywordTypeSubmittalForward = 5<br />
              KeywordTypeSubmittalReviewResponse = 6<br />
              KeywordTypeSubmittalNoActionTaken = 7<br />
              KeywordTypeSubmittalApprove = 8<br />
              KeywordTypeSubmittalResubmit = 9<br />
              KeywordTypeSubmittalReject = 10<br />
              KeywordTypeRFIReceive = 11<br />
              KeywordTypeRFIAssign = 12<br />
              KeywordTypeRFIConsultantAnswer = 13<br />
              KeywordTypeRFIConsultantNoAnswer = 14<br />
              KeywordTypeRFIResponseNoImpact = 15<br />
              KeywordTypeRFIResponsePotentialImpact = 16<br />
              KeywordTypeRFIResponseHasImpact = 17<br />
              KeywordTypeProjectStatusOpportunity = 18<br />
              KeywordTypeProjectStatusActive = 19<br />
              KeywordTypeProjectStatusArchive = 20<br />
              KeywordTypeProjectStatusOffline = 21<br />
              KeywordTypeActionItemStatusOpen = 22<br />
              KeywordTypeActionItemStatusClosed = 23<br />
              KeywordTypeActionItemStatusDeferred = 24<br />
              KeywordTypeMarkupSessionStatusOpen = 25<br />
              KeywordTypeMarkupSessionStatusClosed = 26<br />
              KeywordTypeDocumentSetStatusActive = 27<br />
              KeywordTypeDocumentSetStatusInactive = 28<br />
              KeywordTypeAddressTypeMailing = 29<br />
              KeywordTypeAddressTypeOffice = 30<br />
              KeywordTypeAddressTypeJobSite = 31<br />
              KeywordTypeWorkflowDraft = 32<br />
              KeywordTypeWorkflowExpected = 33<br />
              KeywordTypeWorkflowOpen = 34<br />
              KeywordTypeWorkflowClosed = 35<br />
              KeywordTypeWorkflowPending = 36<br />
              KeywordTypePunchListStatusOpen = 37<br />
              KeywordTypePunchListStatusClosed = 38<br />
              KeywordTypePunchListStatusDraft = 39<br />
              KeywordTypePunchListStatusVoid = 40<br />
              KeywordTypePunchListDiscussionActionCompleted = 41<br />
              KeywordTypePunchListDiscussionActionApproved = 42<br />
              KeywordTypePunchListDiscussionActionRejected = 43<br />
              KeywordTypePunchListDiscussionActionComment = 44<br />
              KeywordTypeUACReceive = 45<br />
              KeywordTypeUACForward = 46<br />
              KeywordTypeUACRecordResponse = 47<br />
              KeywordTypeUACSend = 48<br />
              KeywordTypeUACClose = 49<br />
              KeywordTypeUACReopen = 50<br />
              KeywordTypeUACSendAndClose = 51<br />
              KeywordTypeUACRespondAndCloseNoActionTaken = 52<br />
              KeywordTypeUACRespondAndCloseApprove = 53<br />
              KeywordTypeUACRespondAndCloseRejected = 54<br />
              KeywordTypeUACRespondAndCloseResubmit = 55<br />
              KeywordTypeUACFinalReceive = 56<br />
              KeywordTypeRecordDocumentRevisionStateDraft = 57<br />
              KeywordTypeRecordDocumentRevisionStateIssued = 58<br />
              KeywordTypeContractOpen = 59<br />
              KeywordTypeContractInactive = 60<br />
              KeywordTypeSketchOpen = 61<br />
              KeywordTypeSketchClosed = 62<br />
              KeywordTypeRecordDocumentStatusActive = 63<br />
              KeywordTypeRecordDocumentStatusInactive = 64</p></td></tr>
        <tr><td>Definitions.Description</td><td>The keyword list definition's description.</td></tr>
        <tr bgcolor="efefef"><td>Definitions.DisplayOrder</td><td>The keyword list definition's display order inside UIs.</td></tr>
      </tbody></table><p>
      <a name="GetAllKeywordLists2Request"><b>GetAllKeywordLists2Request</b></a> (Deprecated: use <a href="#GetAllKeywordLists3Request">GetAllKeywordLists3</a> instead.)<br />
      Get all keyword lists in the Newforma database.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
      </tbody></table><p>
      <b>GetAllKeywordLists2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Lists" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"KeywordListId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ListName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ListType" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"Definitions" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"KeywordListDefinitionId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"KeywordListId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"KeywordName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"KeywordType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Description" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DisplayOrder" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Lists</td><td>All of the keyword lists in the Newforma database.</td></tr>
        <tr><td>Lists.KeywordListId</td><td>The keyword list's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Lists.ListName</td><td>The keyword list's name.</td></tr>
        <tr><td>Lists.ListType</td><td>The keyword list's type.<p>Allowed values:<br />
              ListTypeTransmittalPurposes = 1<br />
              ListTypeSubmittalActions = 2<br />
              ListTypeRFIActions = 3<br />
              ListTypePhysicalTransferMethods = 4<br />
              ListTypeProjectStatus = 5<br />
              ListTypeDiscipline = 6<br />
              ListTypeKeyword = 7<br />
              ListTypeMarkupStatus = 8<br />
              ListTypePriority = 9<br />
              ListTypeProjectType = 10<br />
              ListTypeSpecSection = 11<br />
              ListTypeActionItemStatus = 12<br />
              ListTypeMarkupSessionStatus = 13<br />
              ListTypeDocumentSetStatus = 14<br />
              ListTypeAddressTypes = 15<br />
              ListTypeDocumentControlTypes = 16<br />
              ListTypePunchListTypes = 17<br />
              ListTypePunchListLocations = 18<br />
              ListTypePunchListPurposes = 19<br />
              ListTypePunchListStatus = 20<br />
              ListTypePunchListKeywords = 21<br />
              ListTypePunchListDiscussionActions = 22<br />
              ListTypeScales = 23<br />
              ListTypeSizes = 24<br />
              ListTypeRecordDocumentRevisionStates = 25<br />
              ListTypeRecordDocumentStatus = 26<br />
              ListTypeProjectPhase = 27<br />
              ListTypeAutoNumberingPrefixes = 28<br />
              ListTypeWorkflowStatus = 64<br />
              ListTypeReasons = 65<br />
              ListTypeASIActions = 66<br />
              ListTypeUACSubmittalActions = 67<br />
              ListTypeContractStatus = 68<br />
              ListTypeContractTypes = 69<br />
              ListTypeContractFunction = 70<br />
              ListTypeRFITypes = 71<br />
              ListTypeUACRFIActions = 72<br />
              ListTypeSketchTypes = 73<br />
              ListTypeSketchStatus = 74<br />
              ListTypeAddendumActions = 75<br />
              ListTypeChangeOrderActions = 76<br />
              ListTypeChangeOrderProposalActions = 77<br />
              ListTypeBulletinActions = 78<br />
              ListTypeBulletinTypes = 79<br />
              ListTypeCOPStatus = 80<br />
              ListTypeCCDSumTypes = 81<br />
              ListTypeProposalRequestActions = 82<br />
              ListTypeCCDActions = 83<br />
              ListTypeCompanyRole = 29</p></td></tr>
        <tr bgcolor="efefef"><td>Definitions</td><td>All of the keyword list definitions in the Newforma database.</td></tr>
        <tr><td>Definitions.KeywordListDefinitionId</td><td>The keyword list definition's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Definitions.KeywordListId</td><td>The associated keyword list's Newforma database ID.</td></tr>
        <tr><td>Definitions.KeywordName</td><td>The keyword list definition's name.</td></tr>
        <tr bgcolor="efefef"><td>Definitions.KeywordType</td><td>The keyword list definition's type.<p>Allowed values:<br />
              KeywordTypeGenericKeyword = 0<br />
              KeywordTypePhysicalTransferMethod = 1<br />
              KeywordTypeBasicTransmittalIncoming = 2<br />
              KeywordTypeBasicTransmittalOutgoing = 3<br />
              KeywordTypeSubmittalReceive = 4<br />
              KeywordTypeSubmittalForward = 5<br />
              KeywordTypeSubmittalReviewResponse = 6<br />
              KeywordTypeSubmittalNoActionTaken = 7<br />
              KeywordTypeSubmittalApprove = 8<br />
              KeywordTypeSubmittalResubmit = 9<br />
              KeywordTypeSubmittalReject = 10<br />
              KeywordTypeRFIReceive = 11<br />
              KeywordTypeRFIAssign = 12<br />
              KeywordTypeRFIConsultantAnswer = 13<br />
              KeywordTypeRFIConsultantNoAnswer = 14<br />
              KeywordTypeRFIResponseNoImpact = 15<br />
              KeywordTypeRFIResponsePotentialImpact = 16<br />
              KeywordTypeRFIResponseHasImpact = 17<br />
              KeywordTypeProjectStatusOpportunity = 18<br />
              KeywordTypeProjectStatusActive = 19<br />
              KeywordTypeProjectStatusArchive = 20<br />
              KeywordTypeProjectStatusOffline = 21<br />
              KeywordTypeActionItemStatusOpen = 22<br />
              KeywordTypeActionItemStatusClosed = 23<br />
              KeywordTypeActionItemStatusDeferred = 24<br />
              KeywordTypeMarkupSessionStatusOpen = 25<br />
              KeywordTypeMarkupSessionStatusClosed = 26<br />
              KeywordTypeDocumentSetStatusActive = 27<br />
              KeywordTypeDocumentSetStatusInactive = 28<br />
              KeywordTypeAddressTypeMailing = 29<br />
              KeywordTypeAddressTypeOffice = 30<br />
              KeywordTypeAddressTypeJobSite = 31<br />
              KeywordTypeWorkflowDraft = 32<br />
              KeywordTypeWorkflowExpected = 33<br />
              KeywordTypeWorkflowOpen = 34<br />
              KeywordTypeWorkflowClosed = 35<br />
              KeywordTypeWorkflowPending = 36<br />
              KeywordTypePunchListStatusOpen = 37<br />
              KeywordTypePunchListStatusClosed = 38<br />
              KeywordTypePunchListStatusDraft = 39<br />
              KeywordTypePunchListStatusVoid = 40<br />
              KeywordTypePunchListDiscussionActionCompleted = 41<br />
              KeywordTypePunchListDiscussionActionApproved = 42<br />
              KeywordTypePunchListDiscussionActionRejected = 43<br />
              KeywordTypePunchListDiscussionActionComment = 44<br />
              KeywordTypeUACReceive = 45<br />
              KeywordTypeUACForward = 46<br />
              KeywordTypeUACRecordResponse = 47<br />
              KeywordTypeUACSend = 48<br />
              KeywordTypeUACClose = 49<br />
              KeywordTypeUACReopen = 50<br />
              KeywordTypeUACSendAndClose = 51<br />
              KeywordTypeUACRespondAndCloseNoActionTaken = 52<br />
              KeywordTypeUACRespondAndCloseApprove = 53<br />
              KeywordTypeUACRespondAndCloseRejected = 54<br />
              KeywordTypeUACRespondAndCloseResubmit = 55<br />
              KeywordTypeUACFinalReceive = 56<br />
              KeywordTypeRecordDocumentRevisionStateDraft = 57<br />
              KeywordTypeRecordDocumentRevisionStateIssued = 58<br />
              KeywordTypeContractOpen = 59<br />
              KeywordTypeContractInactive = 60<br />
              KeywordTypeSketchOpen = 61<br />
              KeywordTypeSketchClosed = 62<br />
              KeywordTypeRecordDocumentStatusActive = 63<br />
              KeywordTypeRecordDocumentStatusInactive = 64<br />
              KeywordTypeCompanyRoleLeadDesigner = 65<br />
              KeywordTypeCompanyRoleClient = 66<br />
              KeywordTypeCompanyRoleGeneralContractor = 67<br />
              KeywordTypeCompanyRoleContractor = 68<br />
              KeywordTypeCompanyRoleSubContractor = 69<br />
              KeywordTypeCompanyRoleConsultant = 70<br />
              KeywordTypeCompanyRoleAgency = 71<br />
              KeywordTypeCompanyRoleVendor = 72</p></td></tr>
        <tr><td>Definitions.Description</td><td>The keyword list definition's description.</td></tr>
        <tr bgcolor="efefef"><td>Definitions.DisplayOrder</td><td>The keyword list definition's display order inside UIs.</td></tr>
      </tbody></table><p>
      <a name="GetAllKeywordLists3Request"><b>GetAllKeywordLists3Request</b></a><br />
      Get all keyword lists in the Newforma database.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
      </tbody></table><p>
      <b>GetAllKeywordLists3Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Lists" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"KeywordListId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ListName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ListType" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"Definitions" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"KeywordListDefinitionId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"KeywordListId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"KeywordName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"KeywordType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Description" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DisplayOrder" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Lists</td><td>All of the keyword lists in the Newforma database.</td></tr>
        <tr><td>Lists.KeywordListId</td><td>The keyword list's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Lists.ListName</td><td>The keyword list's name.</td></tr>
        <tr><td>Lists.ListType</td><td>The keyword list's type.<p>Allowed values:<br />
              ListTypeTransmittalPurposes = 1<br />
              ListTypeSubmittalActions = 2<br />
              ListTypeRFIActions = 3<br />
              ListTypePhysicalTransferMethods = 4<br />
              ListTypeProjectStatus = 5<br />
              ListTypeDiscipline = 6<br />
              ListTypeKeyword = 7<br />
              ListTypeMarkupStatus = 8<br />
              ListTypePriority = 9<br />
              ListTypeProjectType = 10<br />
              ListTypeSpecSection = 11<br />
              ListTypeActionItemStatus = 12<br />
              ListTypeMarkupSessionStatus = 13<br />
              ListTypeDocumentSetStatus = 14<br />
              ListTypeAddressTypes = 15<br />
              ListTypeDocumentControlTypes = 16<br />
              ListTypePunchListTypes = 17<br />
              ListTypePunchListLocations = 18<br />
              ListTypePunchListPurposes = 19<br />
              ListTypePunchListStatus = 20<br />
              ListTypePunchListKeywords = 21<br />
              ListTypePunchListDiscussionActions = 22<br />
              ListTypeScales = 23<br />
              ListTypeSizes = 24<br />
              ListTypeRecordDocumentRevisionStates = 25<br />
              ListTypeRecordDocumentStatus = 26<br />
              ListTypeProjectPhase = 27<br />
              ListTypeAutoNumberingPrefixes = 28<br />
              ListTypeWorkflowStatus = 64<br />
              ListTypeReasons = 65<br />
              ListTypeASIActions = 66<br />
              ListTypeUACSubmittalActions = 67<br />
              ListTypeContractStatus = 68<br />
              ListTypeContractTypes = 69<br />
              ListTypeContractFunction = 70<br />
              ListTypeRFITypes = 71<br />
              ListTypeUACRFIActions = 72<br />
              ListTypeSketchTypes = 73<br />
              ListTypeSketchStatus = 74<br />
              ListTypeAddendumActions = 75<br />
              ListTypeChangeOrderActions = 76<br />
              ListTypeChangeOrderProposalActions = 77<br />
              ListTypeBulletinActions = 78<br />
              ListTypeBulletinTypes = 79<br />
              ListTypeCOPStatus = 80<br />
              ListTypeCCDSumTypes = 81<br />
              ListTypeProposalRequestActions = 82<br />
              ListTypeCCDActions = 83<br />
              ListTypeCompanyRole = 29<br />
              ListTypeFormLetterType = 30<br />
              ListTypeCompanyType = 31<br />
              ListTypeContactRole = 32<br />
              ListTypeUACReportStatus = 84<br />
              ListTypeDailyReportObservationsCategory = 85<br />
              ListTypeSiteVisitType = 86<br />
              ListTypeSiteVisitObservationsCategory = 87<br />
              ListTypeContractTerms = 88<br />
              ListTypeContractActions = 89<br />
              ListTypeContractTypesContractor = 90<br />
              ListTypePCOTypes = 91<br />
              ListTypePCOStatus = 92<br />
              ListTypeDailyReportEquipment = 93<br />
              ListTypeSiteVisitStatus = 94</p></td></tr>
        <tr bgcolor="efefef"><td>Definitions</td><td>All of the keyword list definitions in the Newforma database.</td></tr>
        <tr><td>Definitions.KeywordListDefinitionId</td><td>The keyword list definition's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Definitions.KeywordListId</td><td>The associated keyword list's Newforma database ID.</td></tr>
        <tr><td>Definitions.KeywordName</td><td>The keyword list definition's name.</td></tr>
        <tr bgcolor="efefef"><td>Definitions.KeywordType</td><td>The keyword list definition's type.<p>Allowed values:<br />
              KeywordTypeGenericKeyword = 0<br />
              KeywordTypePhysicalTransferMethod = 1<br />
              KeywordTypeBasicTransmittalIncoming = 2<br />
              KeywordTypeBasicTransmittalOutgoing = 3<br />
              KeywordTypeSubmittalReceive = 4<br />
              KeywordTypeSubmittalForward = 5<br />
              KeywordTypeSubmittalReviewResponse = 6<br />
              KeywordTypeSubmittalNoActionTaken = 7<br />
              KeywordTypeSubmittalApprove = 8<br />
              KeywordTypeSubmittalResubmit = 9<br />
              KeywordTypeSubmittalReject = 10<br />
              KeywordTypeRFIReceive = 11<br />
              KeywordTypeRFIAssign = 12<br />
              KeywordTypeRFIConsultantAnswer = 13<br />
              KeywordTypeRFIConsultantNoAnswer = 14<br />
              KeywordTypeRFIResponseNoImpact = 15<br />
              KeywordTypeRFIResponsePotentialImpact = 16<br />
              KeywordTypeRFIResponseHasImpact = 17<br />
              KeywordTypeProjectStatusOpportunity = 18<br />
              KeywordTypeProjectStatusActive = 19<br />
              KeywordTypeProjectStatusArchive = 20<br />
              KeywordTypeProjectStatusOffline = 21<br />
              KeywordTypeActionItemStatusOpen = 22<br />
              KeywordTypeActionItemStatusClosed = 23<br />
              KeywordTypeActionItemStatusDeferred = 24<br />
              KeywordTypeMarkupSessionStatusOpen = 25<br />
              KeywordTypeMarkupSessionStatusClosed = 26<br />
              KeywordTypeDocumentSetStatusActive = 27<br />
              KeywordTypeDocumentSetStatusInactive = 28<br />
              KeywordTypeAddressTypeMailing = 29<br />
              KeywordTypeAddressTypeOffice = 30<br />
              KeywordTypeAddressTypeJobSite = 31<br />
              KeywordTypeWorkflowDraft = 32<br />
              KeywordTypeWorkflowExpected = 33<br />
              KeywordTypeWorkflowOpen = 34<br />
              KeywordTypeWorkflowClosed = 35<br />
              KeywordTypeWorkflowPending = 36<br />
              KeywordTypePunchListStatusOpen = 37<br />
              KeywordTypePunchListStatusClosed = 38<br />
              KeywordTypePunchListStatusDraft = 39<br />
              KeywordTypePunchListStatusVoid = 40<br />
              KeywordTypePunchListDiscussionActionCompleted = 41<br />
              KeywordTypePunchListDiscussionActionApproved = 42<br />
              KeywordTypePunchListDiscussionActionRejected = 43<br />
              KeywordTypePunchListDiscussionActionComment = 44<br />
              KeywordTypeUACReceive = 45<br />
              KeywordTypeUACForward = 46<br />
              KeywordTypeUACRecordResponse = 47<br />
              KeywordTypeUACSend = 48<br />
              KeywordTypeUACClose = 49<br />
              KeywordTypeUACReopen = 50<br />
              KeywordTypeUACSendAndClose = 51<br />
              KeywordTypeUACRespondAndCloseNoActionTaken = 52<br />
              KeywordTypeUACRespondAndCloseApprove = 53<br />
              KeywordTypeUACRespondAndCloseRejected = 54<br />
              KeywordTypeUACRespondAndCloseResubmit = 55<br />
              KeywordTypeUACFinalReceive = 56<br />
              KeywordTypeRecordDocumentRevisionStateDraft = 57<br />
              KeywordTypeRecordDocumentRevisionStateIssued = 58<br />
              KeywordTypeContractOpen = 59<br />
              KeywordTypeContractInactive = 60<br />
              KeywordTypeSketchOpen = 61<br />
              KeywordTypeSketchClosed = 62<br />
              KeywordTypeRecordDocumentStatusActive = 63<br />
              KeywordTypeRecordDocumentStatusInactive = 64<br />
              KeywordTypeCompanyRoleLeadDesigner = 65<br />
              KeywordTypeCompanyRoleClient = 66<br />
              KeywordTypeCompanyRoleGeneralContractor = 67<br />
              KeywordTypeCompanyRoleContractor = 68<br />
              KeywordTypeCompanyRoleSubContractor = 69<br />
              KeywordTypeCompanyRoleConsultant = 70<br />
              KeywordTypeCompanyRoleAgency = 71<br />
              KeywordTypeCompanyRoleVendor = 72<br />
              KeywordTypeUACFinalizableDraft = 73<br />
              KeywordTypeUACFinalizableFinal = 74<br />
              KeywordTypeUACSiteVisitSafety = 75<br />
              KeywordTypeUACSiteVisitQuality = 76<br />
              KeywordTypeUACSiteVisitDesign = 77<br />
              KeywordTypeUACSiteVisitOther = 78<br />
              KeywordTypeUACCost = 79<br />
              KeywordTypeUACBudget = 80<br />
              KeywordTypeUACPCOOpen = 81<br />
              KeywordTypeUACPCOPricingComplete = 82<br />
              KeywordTypeUACPCOClosed = 83<br />
              KeywordTypeUACPCOVoid = 84<br />
              KeywordTypeUACPCODraft = 85<br />
              KeywordTypeUACCloseApprove = 86<br />
              KeywordTypeUACSendAndCloseApprove = 87<br />
              KeywordTypeUACCloseNoActionTaken = 88<br />
              KeywordTypeUACCloseRejected = 89</p></td></tr>
        <tr><td>Definitions.Description</td><td>The keyword list definition's description.</td></tr>
        <tr bgcolor="efefef"><td>Definitions.DisplayOrder</td><td>The keyword list definition's display order inside UIs.</td></tr>
      </tbody></table><p>
      <a name="GetAllPermissionSetsRequest"><b>GetAllPermissionSetsRequest</b></a> (Deprecated: use <a href="#GetAllPermissionSets2Request">GetAllPermissionSets2</a> instead.)<br />
      Get all permission sets in the Newforma database.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
      </tbody></table><p>
      <b>GetAllPermissionSetsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Sets" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PermissionSetId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PermissionSetName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Description" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SetType" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"Definitions" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PermissionSetDefinitionId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PermissionSetId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ActivityCenterId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DefinitionType" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"ActivityCenters" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ActivityCenterId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ActivityCenterName" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Sets</td><td>All of the permission sets in the Newforma database.</td></tr>
        <tr><td>Sets.PermissionSetId</td><td>The permission set's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Sets.PermissionSetName</td><td>The permission set's name.</td></tr>
        <tr><td>Sets.Description</td><td>The permission set's description.</td></tr>
        <tr bgcolor="efefef"><td>Sets.SetType</td><td>The permission set's type.<p>Allowed values:<br />
              SetTypeNotDefault = 0<br />
              SetTypeInternalUserDefault = 1<br />
              SetTypeExternalUserDefault = 2<br />
              SetTypeInternalExternalUserDefault = 3</p></td></tr>
        <tr bgcolor="efefef"><td>Definitions</td><td>All of the permission set definitions in the Newforma database.</td></tr>
        <tr><td>Definitions.PermissionSetDefinitionId</td><td>The permission set definition's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Definitions.PermissionSetId</td><td>The associated permission set's Newforma database ID.</td></tr>
        <tr><td>Definitions.ActivityCenterId</td><td>The associated activity center's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Definitions.DefinitionType</td><td>The permission set definition's type.<p>Allowed values:<br />
              DefinitionTypeNone = 0<br />
              DefinitionTypeShowAll = 1<br />
              DefinitionTypeOnlyShowItemsMemberIsOn = 2<br />
              DefinitionTypeDoNotShow = 4<br />
              DefinitionTypeShowItemsCompanyIsOn = 8<br />
              DefinitionTypeAllowAdd = 16</p></td></tr>
        <tr><td>ActivityCenters</td><td>All of the activity centers associated with permission set definitions in the Newforma database.</td></tr>
        <tr><td>ActivityCenters.ActivityCenterId</td><td>The activity center's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>ActivityCenters.ActivityCenterName</td><td>The activity center's name.</td></tr>
      </tbody></table><p>
      <a name="GetAllPermissionSets2Request"><b>GetAllPermissionSets2Request</b></a><br />
      Get all permission sets in the Newforma database.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
      </tbody></table><p>
      <b>GetAllPermissionSets2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Sets" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PermissionSetId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PermissionSetName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Description" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SetType" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"Definitions" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PermissionSetDefinitionId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PermissionSetId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ActivityCenterId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DefinitionType" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"ActivityCenters" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ActivityCenterId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ActivityCenterName" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Sets</td><td>All of the permission sets in the Newforma database.</td></tr>
        <tr><td>Sets.PermissionSetId</td><td>The permission set's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Sets.PermissionSetName</td><td>The permission set's name.</td></tr>
        <tr><td>Sets.Description</td><td>The permission set's description.</td></tr>
        <tr bgcolor="efefef"><td>Sets.SetType</td><td>The permission set's type.<p>Allowed values:<br />
              SetTypeNotDefault = 0<br />
              SetTypeInternalUserDefault = 1<br />
              SetTypeExternalUserDefault = 2<br />
              SetTypeInternalExternalUserDefault = 3</p></td></tr>
        <tr bgcolor="efefef"><td>Definitions</td><td>All of the permission set definitions in the Newforma database.</td></tr>
        <tr><td>Definitions.PermissionSetDefinitionId</td><td>The permission set definition's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Definitions.PermissionSetId</td><td>The associated permission set's Newforma database ID.</td></tr>
        <tr><td>Definitions.ActivityCenterId</td><td>The associated activity center's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Definitions.DefinitionType</td><td>The permission set definition's type.<p>Allowed values:<br />
              DefinitionTypeNone = 0<br />
              DefinitionTypeShowAll = 1<br />
              DefinitionTypeOnlyShowItemsMemberIsOn = 2<br />
              DefinitionTypeDoNotShow = 4<br />
              DefinitionTypeShowItemsCompanyIsOn = 8<br />
              DefinitionTypeAllowAdd = 16<br />
              DefinitionTypeAllowCloudDelivery = 32<br />
              DefinitionTypeAllowCloudAutoDelivery = 64<br />
              DefinitionTypeAllowCloudUpload = 128</p></td></tr>
        <tr><td>ActivityCenters</td><td>All of the activity centers associated with permission set definitions in the Newforma database.</td></tr>
        <tr><td>ActivityCenters.ActivityCenterId</td><td>The activity center's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>ActivityCenters.ActivityCenterName</td><td>The activity center's name.</td></tr>
      </tbody></table><p>
      <a name="GetAllProjectDescriptorsRequest"><b>GetAllProjectDescriptorsRequest</b></a> (Deprecated: use <a href="#GetAllProjectDescriptors2Request">GetAllProjectDescriptors2</a> instead.)<br />
      Get descriptor information about all projects in the Newforma database.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
      </tbody></table><p>
      <b>GetAllProjectDescriptorsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Descriptors" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Descriptors</td><td>Descriptor information for all projects in the Newforma database.</td></tr>
        <tr><td>Descriptors.ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.Number</td><td>The project's number.</td></tr>
        <tr><td>Descriptors.SourceDescriptor</td><td>The name of the original datasource that the project was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.SourcePrimaryKey</td><td>The projec's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <a name="GetAllProjectDescriptors2Request"><b>GetAllProjectDescriptors2Request</b></a><br />
      Get descriptor information about all projects in the Newforma database.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
      </tbody></table><p>
      <b>GetAllProjectDescriptors2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Descriptors" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectName" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Descriptors</td><td>Descriptor information for all projects in the Newforma database.</td></tr>
        <tr><td>Descriptors.ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.Number</td><td>The project's number.</td></tr>
        <tr><td>Descriptors.SourceDescriptor</td><td>The name of the original datasource that the project was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.SourcePrimaryKey</td><td>The projec's primary key in its original datasource.</td></tr>
        <tr><td>Descriptors.ProjectName</td><td>The project's name.</td></tr>
      </tbody></table><p>
      <a name="GetAllSourceDescriptorsRequest"><b>GetAllSourceDescriptorsRequest</b></a> (Deprecated: use <a href="#GetAllSourceDescriptors2Request">GetAllSourceDescriptors2</a> instead.)<br />
      Get all source descriptors in the Newforma database.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
      </tbody></table><p>
      <b>GetAllSourceDescriptorsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"SourceDescriptors" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptorId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DescriptorName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DescriptorType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FieldType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"IsEditable" : <i>boolean</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>SourceDescriptors</td><td>All of the source descriptors in the Newforma database.</td></tr>
        <tr><td>SourceDescriptors.SourceDescriptorId</td><td>The source descriptor's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptors.DescriptorName</td><td>The source descriptor's name.</td></tr>
        <tr><td>SourceDescriptors.DescriptorType</td><td>The source descriptor's object type.<p>Allowed values:<br />
              DescriptorTypeContact = 1<br />
              DescriptorTypeCompany = 4<br />
              DescriptorTypeOfficeLocation = 6</p></td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptors.FieldType</td><td>The source descriptor's field type.<p>Allowed values:<br />
              FieldTypeContactEmailAddress = 100<br />
              FieldTypeContactFirstName = 101<br />
              FieldTypeContactLastName = 102<br />
              FieldTypeContactCompany = 103<br />
              FieldTypeContactDepartmentName = 104<br />
              FieldTypeContactJobTitle = 105<br />
              FieldTypeContactDiscipline = 106<br />
              FieldTypeContactPhoneNumberWork = 107<br />
              FieldTypeContactPhoneNumberMobile = 108<br />
              FieldTypeContactPhoneNumberHome = 109<br />
              FieldTypeContactFaxNumber = 110<br />
              FieldTypeContactStreetAddress = 111<br />
              FieldTypeContactNoteText = 112<br />
              FieldTypeContactActiveUser = 113<br />
              FieldTypeCompanyCompanyName = 311<br />
              FieldTypeCompanyWebUrl = 312<br />
              FieldTypeCompanyDisciplineList = 313<br />
              FieldTypeCompanySpecSectionList = 314<br />
              FieldTypeCompanyMainContact = 315<br />
              FieldTypeCompanyNoteText = 316<br />
              FieldTypeOfficeLocationLocationName = 600<br />
              FieldTypeOfficeLocationStreetAddress = 601<br />
              FieldTypeOfficeLocationAddressType = 606<br />
              FieldTypeOfficeLocationPhoneNumber = 607<br />
              FieldTypeOfficeLocationFaxNumber = 608</p></td></tr>
        <tr><td>SourceDescriptors.IsEditable</td><td>Is the field editable in Newforma?</td></tr>
      </tbody></table><p>
      <a name="GetAllSourceDescriptors2Request"><b>GetAllSourceDescriptors2Request</b></a> (Deprecated: use <a href="#GetAllSourceDescriptors3Request">GetAllSourceDescriptors3</a> instead.)<br />
      Get all source descriptors in the Newforma database.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
      </tbody></table><p>
      <b>GetAllSourceDescriptors2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"SourceDescriptors" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptorId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DescriptorName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DescriptorType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FieldType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"IsEditable" : <i>boolean</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>SourceDescriptors</td><td>All of the source descriptors in the Newforma database.</td></tr>
        <tr><td>SourceDescriptors.SourceDescriptorId</td><td>The source descriptor's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptors.DescriptorName</td><td>The source descriptor's name.</td></tr>
        <tr><td>SourceDescriptors.DescriptorType</td><td>The source descriptor's object type.<p>Allowed values:<br />
              DescriptorTypeContact = 1<br />
              DescriptorTypeCompany = 4<br />
              DescriptorTypeOfficeLocation = 6</p></td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptors.FieldType</td><td>The source descriptor's field type.<p>Allowed values:<br />
              FieldTypeContactEmailAddress = 100<br />
              FieldTypeContactFirstName = 101<br />
              FieldTypeContactLastName = 102<br />
              FieldTypeContactCompany = 103<br />
              FieldTypeContactDepartmentName = 104<br />
              FieldTypeContactJobTitle = 105<br />
              FieldTypeContactDiscipline = 106<br />
              FieldTypeContactPhoneNumberWork = 107<br />
              FieldTypeContactPhoneNumberMobile = 108<br />
              FieldTypeContactPhoneNumberHome = 109<br />
              FieldTypeContactFaxNumber = 110<br />
              FieldTypeContactStreetAddress = 111<br />
              FieldTypeContactNoteText = 112<br />
              FieldTypeContactActiveUser = 113<br />
              FieldTypeCompanyCompanyName = 311<br />
              FieldTypeCompanyWebUrl = 312<br />
              FieldTypeCompanyDisciplineList = 313<br />
              FieldTypeCompanySpecSectionList = 314<br />
              FieldTypeCompanyMainContact = 315<br />
              FieldTypeCompanyNoteText = 316<br />
              FieldTypeOfficeLocationLocationName = 600<br />
              FieldTypeOfficeLocationStreetAddress = 601<br />
              FieldTypeOfficeLocationAddressType = 606<br />
              FieldTypeOfficeLocationPhoneNumber = 607<br />
              FieldTypeOfficeLocationFaxNumber = 608<br />
              FieldTypeContactOfficeLocation = 114<br />
              FieldTypeContactAddressType = 115<br />
              FieldTypeContactUseOfficeAddress = 116<br />
              FieldTypeOfficeLocationIsPrimary = 609</p></td></tr>
        <tr><td>SourceDescriptors.IsEditable</td><td>Is the field editable in Newforma?</td></tr>
      </tbody></table><p>
      <a name="GetAllSourceDescriptors3Request"><b>GetAllSourceDescriptors3Request</b></a><br />
      Get all source descriptors in the Newforma database.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
      </tbody></table><p>
      <b>GetAllSourceDescriptors3Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"SourceDescriptors" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptorId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DescriptorName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DescriptorType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FieldType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"IsEditable" : <i>boolean</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>SourceDescriptors</td><td>All of the source descriptors in the Newforma database.</td></tr>
        <tr><td>SourceDescriptors.SourceDescriptorId</td><td>The source descriptor's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptors.DescriptorName</td><td>The source descriptor's name.</td></tr>
        <tr><td>SourceDescriptors.DescriptorType</td><td>The source descriptor's object type.<p>Allowed values:<br />
              DescriptorTypeContact = 1<br />
              DescriptorTypeCompany = 4<br />
              DescriptorTypeOfficeLocation = 6</p></td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptors.FieldType</td><td>The source descriptor's field type.<p>Allowed values:<br />
              FieldTypeContactEmailAddress = 100<br />
              FieldTypeContactFirstName = 101<br />
              FieldTypeContactLastName = 102<br />
              FieldTypeContactCompany = 103<br />
              FieldTypeContactDepartmentName = 104<br />
              FieldTypeContactJobTitle = 105<br />
              FieldTypeContactDiscipline = 106<br />
              FieldTypeContactPhoneNumberWork = 107<br />
              FieldTypeContactPhoneNumberMobile = 108<br />
              FieldTypeContactPhoneNumberHome = 109<br />
              FieldTypeContactFaxNumber = 110<br />
              FieldTypeContactStreetAddress = 111<br />
              FieldTypeContactNoteText = 112<br />
              FieldTypeContactActiveUser = 113<br />
              FieldTypeCompanyCompanyName = 311<br />
              FieldTypeCompanyWebUrl = 312<br />
              FieldTypeCompanyDisciplineList = 313<br />
              FieldTypeCompanySpecSectionList = 314<br />
              FieldTypeCompanyMainContact = 315<br />
              FieldTypeCompanyNoteText = 316<br />
              FieldTypeOfficeLocationLocationName = 600<br />
              FieldTypeOfficeLocationStreetAddress = 601<br />
              FieldTypeOfficeLocationAddressType = 606<br />
              FieldTypeOfficeLocationPhoneNumber = 607<br />
              FieldTypeOfficeLocationFaxNumber = 608<br />
              FieldTypeContactOfficeLocation = 114<br />
              FieldTypeContactAddressType = 115<br />
              FieldTypeContactUseOfficeAddress = 116<br />
              FieldTypeOfficeLocationIsPrimary = 609<br />
              FieldTypeContactRoles = 117</p></td></tr>
        <tr><td>SourceDescriptors.IsEditable</td><td>Is the field editable in Newforma?</td></tr>
      </tbody></table><p>
      <a name="GetAllUserNamesRequest"><b>GetAllUserNamesRequest</b></a><br />
      Get user names for all users in the Newforma database.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
      </tbody></table><p>
      <b>GetAllUserNamesResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"UserNames" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>UserNames</td><td>User names for all users in the Newforma database.</td></tr>
      </tbody></table><p>
      <a name="GetCalendarItemSummaryRequest"><b>GetCalendarItemSummaryRequest</b></a><br />
      Get Calendar Item summaries from a project matching a category filter.</p><p>
      It is an error to retrieve project items for a project that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"CategoryFilter" : <i>int</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>CategoryFilter</td><td>The category of project items to return.  To return all project items use the CategoryFilterAll filter.<p>Allowed values:<br />
              CategoryFilterAll = 1<br />
              CategoryFilterCalendar = 2<br />
              CategoryFilterJournal = 4<br />
              CategoryFilterMeeting = 8<br />
              CategoryFilterHoliday = 16<br />
              CategoryFilterMilestone = 32<br />
              CategoryFilterPhase = 64<br />
              CategoryFilterOpenItems = 128<br />
              CategoryFilterMeetingSeries = 256<br />
              CategoryFilterTimelineLog = 512<br />
              CategoryFilterHasAgenda = 2048<br />
              CategoryFilterHasMinutes = 4096</p></td></tr>
      </tbody></table><p>
      <b>GetCalendarItemSummaryResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Summaries" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Name" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Summaries</td><td>The Calendar Item summaries matching the category filter.</td></tr>
        <tr><td>Summaries.ProjectItemId</td><td>The project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>Summaries.Name</td><td>The project item's name.</td></tr>
        <tr><td>Summaries.Number</td><td>The project item's number.</td></tr>
      </tbody></table><p>
      <a name="GetCalendarItemsRequest"><b>GetCalendarItemsRequest</b></a><br />
      Get Calendar Items from a project for a set of project item IDs.</p><p>
      It is an error to retrieve project items for a project that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectItemIds" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>ProjectItemIds</td><td>The project items' Newforma database IDs.</td></tr>
      </tbody></table><p>
      <b>GetCalendarItemsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"CalendarItems" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Name" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Keywords" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SupportingDocuments" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EmailLog" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"MemberContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CCContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ActualAttendeeContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RelatedAgendaItems" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemType" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RelatedMeetingMinuteItems" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemType" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AccessType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CalendarItemType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EventType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AllDayEvent" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Color" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Location" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StartDate" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EndDate" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RecurrenceStart" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RecurrenceEnd" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RecurrenceType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RecurrenceRange" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"WeekDays" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Periodicity" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DayNumber" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"WeekOfMonth" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Month" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"OccurenceCount" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"OccurenceIndex" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ParentOcurrenceCalendarItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"IsChangedOccurrence" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"IsDeletedOccurrence" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Comments" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Agenda" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"MeetingMinutes" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ActualStartTime" : <i>datetime</i> <sup>1</sup><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>CalendarItems</td><td>The Calendar Items matching the project item IDs.</td></tr>
        <tr><td>CalendarItems.ProjectItemId</td><td>The project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.Name</td><td>The project item's name.</td></tr>
        <tr><td>CalendarItems.Number</td><td>The project item's number.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.Keywords</td><td>The project item's keywords.</td></tr>
        <tr><td>CalendarItems.SupportingDocuments</td><td>The project item's supporting documents as a collection of UNC paths.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.EmailLog</td><td>The project item's email log as a collection of UNC paths.</td></tr>
        <tr><td>CalendarItems.MemberContactIds</td><td>The Newforma database IDs of the contacts who are members on the Calendar Item.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.CCContactIds</td><td>The Newforma database IDs of the contacts who are CCed on the Calendar Item.</td></tr>
        <tr><td>CalendarItems.ActualAttendeeContactIds</td><td>The Newforma database IDs of the contacts that actually attended the meeting.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.RelatedAgendaItems</td><td>The meeting's related agenda items.</td></tr>
        <tr><td>CalendarItems.RelatedAgendaItems.ProjectItemId</td><td>The related project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.RelatedAgendaItems.ProjectItemType</td><td>The related project item's type.<p>Allowed values:<br />
              ProjectItemTypeDocumentSet = 1<br />
              ProjectItemTypeActionItem = 2<br />
              ProjectItemTypeCalendarItem = 8<br />
              ProjectItemTypeRecordDocument = 18</p></td></tr>
        <tr><td>CalendarItems.RelatedMeetingMinuteItems</td><td>The meeting's related meeting minute items.</td></tr>
        <tr><td>CalendarItems.RelatedMeetingMinuteItems.ProjectItemId</td><td>The related project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.RelatedMeetingMinuteItems.ProjectItemType</td><td>The related project item's type.<p>Allowed values:<br />
              ProjectItemTypeDocumentSet = 1<br />
              ProjectItemTypeActionItem = 2<br />
              ProjectItemTypeCalendarItem = 8<br />
              ProjectItemTypeRecordDocument = 18</p></td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.AccessType</td><td>The Calendar Item's access type.<p>Allowed values:<br />
              AccessTypeRecipients = 2<br />
              AccessTypeEntireProjectTeam = 4<br />
              AccessTypeInternalProjectTeam = 5</p></td></tr>
        <tr><td>CalendarItems.CalendarItemType</td><td>The Calendar Item's type.<p>Allowed values:<br />
              CalendarItemTypeMilestone = 1<br />
              CalendarItemTypeEvent = 2<br />
              CalendarItemTypePhase = 3<br />
              CalendarItemTypeHoliday = 4</p></td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.EventType</td><td>If the Calendar Item is an event, the event type's name.</td></tr>
        <tr><td>CalendarItems.AllDayEvent</td><td>Is this item an all day event?</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.Color</td><td>The 24-bit RGB color of the event in the calendar.</td></tr>
        <tr><td>CalendarItems.Location</td><td>The location that the event took place.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.StartDate</td><td>The item's start date.  For milestones this is also the deadline.</td></tr>
        <tr><td>CalendarItems.EndDate</td><td>The item's end date.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.RecurrenceStart</td><td>The event's recurrence start date.</td></tr>
        <tr><td>CalendarItems.RecurrenceEnd</td><td>The event's recurrence end date.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.RecurrenceType</td><td>The frequency of the event's recurrence.<p>Allowed values:<br />
              RecurrenceTypeNone = 0<br />
              RecurrenceTypeDaily = 1<br />
              RecurrenceTypeWeekly = 2<br />
              RecurrenceTypeMonthly = 3<br />
              RecurrenceTypeYearly = 4</p></td></tr>
        <tr><td>CalendarItems.RecurrenceRange</td><td>The period of the event's recurrence.<p>Allowed values:<br />
              RecurrenceRangeNone = 0<br />
              RecurrenceRangeEndByDate = 1<br />
              RecurrenceRangeNoEndDate = 2<br />
              RecurrenceRangeOccurrenceCount = 3</p></td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.WeekDays</td><td>The bit mask of week day(s) the recurrence is on.<p>Allowed values:<br />
              WeekDaysNone = 0<br />
              WeekDaysSunday = 1<br />
              WeekDaysMonday = 2<br />
              WeekDaysTuesday = 4<br />
              WeekDaysWednesday = 8<br />
              WeekDaysThursday = 16<br />
              WeekDaysFriday = 32<br />
              WeekDaysSaturday = 64<br />
              WeekDaysEveryDay = 128<br />
              WeekDaysWeekendDays = 256<br />
              WeekDaysWorkDays = 512</p></td></tr>
        <tr><td>CalendarItems.Periodicity</td><td>Indicates the number of times the event will occur.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.DayNumber</td><td>The day of the month the recurrence is on between one and 31.</td></tr>
        <tr><td>CalendarItems.WeekOfMonth</td><td>The week of the month that the recurrence is on.<p>Allowed values:<br />
              WeekOfMonthNone = 1<br />
              WeekOfMonthFirst = 2<br />
              WeekOfMonthSecond = 3<br />
              WeekOfMonthThird = 4<br />
              WeekOfMonthFourth = 5<br />
              WeekOfMonthLast = 6</p></td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.Month</td><td>--</td></tr>
        <tr><td>CalendarItems.OccurenceCount</td><td>--</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.OccurenceIndex</td><td>--</td></tr>
        <tr><td>CalendarItems.ParentOcurrenceCalendarItemId</td><td>The Newforma database ID of the parent Calendar Item if this item if this event has changed or been deleted.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.IsChangedOccurrence</td><td>Is this occurence changed from the parent Calendar Item?</td></tr>
        <tr><td>CalendarItems.IsDeletedOccurrence</td><td>Is this occurence deleted from the parent Calendar Item?</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.Comments</td><td>The Calendar Item's comments.</td></tr>
        <tr><td>CalendarItems.Agenda</td><td>The meeting's agenda.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.MeetingMinutes</td><td>The meeting's meeting minutes.</td></tr>
        <tr><td>CalendarItems.ActualStartTime</td><td>The meeting's actual start time.</td></tr>
      </tbody></table><p>
      <a name="GetCalendarItems2Request"><b>GetCalendarItems2Request</b></a><br />
      Get Calendar Items from a project for a set of project item IDs.</p><p>
      It is an error to retrieve project items for a project that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectItemIds" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>ProjectItemIds</td><td>The project items' Newforma database IDs.</td></tr>
      </tbody></table><p>
      <b>GetCalendarItems2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"CalendarItems" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Name" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Keywords" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SupportingDocuments" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProviderId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"VersionNumber" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EmailLog" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProviderId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"MemberContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CCContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ActualAttendeeContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RelatedAgendaItems" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemType" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RelatedMeetingMinuteItems" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemType" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AccessType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CalendarItemType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EventType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AllDayEvent" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Color" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Location" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StartDate" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EndDate" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RecurrenceStart" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RecurrenceEnd" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RecurrenceType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RecurrenceRange" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"WeekDays" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Periodicity" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DayNumber" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"WeekOfMonth" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Month" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"OccurenceCount" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"OccurenceIndex" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ParentOcurrenceCalendarItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"IsChangedOccurrence" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"IsDeletedOccurrence" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Comments" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Agenda" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"MeetingMinutes" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ActualStartTime" : <i>datetime</i> <sup>1</sup><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>CalendarItems</td><td>The Calendar Items matching the project item IDs.</td></tr>
        <tr><td>CalendarItems.ProjectItemId</td><td>The project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.Name</td><td>The project item's name.</td></tr>
        <tr><td>CalendarItems.Number</td><td>The project item's number.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.Keywords</td><td>The project item's keywords.</td></tr>
        <tr><td>CalendarItems.SupportingDocuments</td><td>--</td></tr>
        <tr><td>CalendarItems.SupportingDocuments.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.SupportingDocuments.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr><td>CalendarItems.SupportingDocuments.ProviderId</td><td>File's EDMS plugin's provider id</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.SupportingDocuments.VersionNumber</td><td>File's version number</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.EmailLog</td><td>--</td></tr>
        <tr><td>CalendarItems.EmailLog.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.EmailLog.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr><td>CalendarItems.EmailLog.ProviderId</td><td>File's EDMS plugin's provider id</td></tr>
        <tr><td>CalendarItems.MemberContactIds</td><td>The Newforma database IDs of the contacts who are members on the Calendar Item.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.CCContactIds</td><td>The Newforma database IDs of the contacts who are CCed on the Calendar Item.</td></tr>
        <tr><td>CalendarItems.ActualAttendeeContactIds</td><td>The Newforma database IDs of the contacts that actually attended the meeting.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.RelatedAgendaItems</td><td>The meeting's related agenda items.</td></tr>
        <tr><td>CalendarItems.RelatedAgendaItems.ProjectItemId</td><td>The related project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.RelatedAgendaItems.ProjectItemType</td><td>The related project item's type.<p>Allowed values:<br />
              ProjectItemTypeDocumentSet = 1<br />
              ProjectItemTypeActionItem = 2<br />
              ProjectItemTypeCalendarItem = 8<br />
              ProjectItemTypeRecordDocument = 18</p></td></tr>
        <tr><td>CalendarItems.RelatedMeetingMinuteItems</td><td>The meeting's related meeting minute items.</td></tr>
        <tr><td>CalendarItems.RelatedMeetingMinuteItems.ProjectItemId</td><td>The related project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.RelatedMeetingMinuteItems.ProjectItemType</td><td>The related project item's type.<p>Allowed values:<br />
              ProjectItemTypeDocumentSet = 1<br />
              ProjectItemTypeActionItem = 2<br />
              ProjectItemTypeCalendarItem = 8<br />
              ProjectItemTypeRecordDocument = 18</p></td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.AccessType</td><td>The Calendar Item's access type.<p>Allowed values:<br />
              AccessTypeRecipients = 2<br />
              AccessTypeEntireProjectTeam = 4<br />
              AccessTypeInternalProjectTeam = 5</p></td></tr>
        <tr><td>CalendarItems.CalendarItemType</td><td>The Calendar Item's type.<p>Allowed values:<br />
              CalendarItemTypeMilestone = 1<br />
              CalendarItemTypeEvent = 2<br />
              CalendarItemTypePhase = 3<br />
              CalendarItemTypeHoliday = 4</p></td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.EventType</td><td>If the Calendar Item is an event, the event type's name.</td></tr>
        <tr><td>CalendarItems.AllDayEvent</td><td>Is this item an all day event?</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.Color</td><td>The 24-bit RGB color of the event in the calendar.</td></tr>
        <tr><td>CalendarItems.Location</td><td>The location that the event took place.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.StartDate</td><td>The item's start date.  For milestones this is also the deadline.</td></tr>
        <tr><td>CalendarItems.EndDate</td><td>The item's end date.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.RecurrenceStart</td><td>The event's recurrence start date.</td></tr>
        <tr><td>CalendarItems.RecurrenceEnd</td><td>The event's recurrence end date.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.RecurrenceType</td><td>The frequency of the event's recurrence.<p>Allowed values:<br />
              RecurrenceTypeNone = 0<br />
              RecurrenceTypeDaily = 1<br />
              RecurrenceTypeWeekly = 2<br />
              RecurrenceTypeMonthly = 3<br />
              RecurrenceTypeYearly = 4</p></td></tr>
        <tr><td>CalendarItems.RecurrenceRange</td><td>The period of the event's recurrence.<p>Allowed values:<br />
              RecurrenceRangeNone = 0<br />
              RecurrenceRangeEndByDate = 1<br />
              RecurrenceRangeNoEndDate = 2<br />
              RecurrenceRangeOccurrenceCount = 3</p></td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.WeekDays</td><td>The bit mask of week day(s) the recurrence is on.<p>Allowed values:<br />
              WeekDaysNone = 0<br />
              WeekDaysSunday = 1<br />
              WeekDaysMonday = 2<br />
              WeekDaysTuesday = 4<br />
              WeekDaysWednesday = 8<br />
              WeekDaysThursday = 16<br />
              WeekDaysFriday = 32<br />
              WeekDaysSaturday = 64<br />
              WeekDaysEveryDay = 128<br />
              WeekDaysWeekendDays = 256<br />
              WeekDaysWorkDays = 512</p></td></tr>
        <tr><td>CalendarItems.Periodicity</td><td>Indicates the number of times the event will occur.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.DayNumber</td><td>The day of the month the recurrence is on between one and 31.</td></tr>
        <tr><td>CalendarItems.WeekOfMonth</td><td>The week of the month that the recurrence is on.<p>Allowed values:<br />
              WeekOfMonthNone = 1<br />
              WeekOfMonthFirst = 2<br />
              WeekOfMonthSecond = 3<br />
              WeekOfMonthThird = 4<br />
              WeekOfMonthFourth = 5<br />
              WeekOfMonthLast = 6</p></td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.Month</td><td>--</td></tr>
        <tr><td>CalendarItems.OccurenceCount</td><td>--</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.OccurenceIndex</td><td>--</td></tr>
        <tr><td>CalendarItems.ParentOcurrenceCalendarItemId</td><td>The Newforma database ID of the parent Calendar Item if this item if this event has changed or been deleted.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.IsChangedOccurrence</td><td>Is this occurence changed from the parent Calendar Item?</td></tr>
        <tr><td>CalendarItems.IsDeletedOccurrence</td><td>Is this occurence deleted from the parent Calendar Item?</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.Comments</td><td>The Calendar Item's comments.</td></tr>
        <tr><td>CalendarItems.Agenda</td><td>The meeting's agenda.</td></tr>
        <tr bgcolor="efefef"><td>CalendarItems.MeetingMinutes</td><td>The meeting's meeting minutes.</td></tr>
        <tr><td>CalendarItems.ActualStartTime</td><td>The meeting's actual start time.</td></tr>
      </tbody></table><p>
      <a name="GetCompaniesForIdsRequest"><b>GetCompaniesForIdsRequest</b></a> (Deprecated: use <a href="#GetCompaniesForIds2Request">GetCompaniesForIds2</a> instead.)<br />
      Get companies for a set of Newforma database IDs.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"CompanyIds" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>CompanyIds</td><td>The Newforma database IDs to retrieve companies for.</td></tr>
      </tbody></table><p>
      <b>GetCompaniesForIdsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Companies" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"MainContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DisciplineList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SpecSectionList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"WebUrl" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NoteText" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Companies</td><td>The set of companies matching the requested Newforma database IDs.</td></tr>
        <tr><td>Companies.CompanyId</td><td>The company's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Companies.MainContactId</td><td>The contact's associated main contact's Newforma database ID.</td></tr>
        <tr><td>Companies.CompanyName</td><td>The company's name.</td></tr>
        <tr bgcolor="efefef"><td>Companies.DisciplineList</td><td>The company's discipline list.</td></tr>
        <tr><td>Companies.SpecSectionList</td><td>The company's spec section list.</td></tr>
        <tr bgcolor="efefef"><td>Companies.WebUrl</td><td>The company's website URL.</td></tr>
        <tr><td>Companies.NoteText</td><td>The company's HTML note text.</td></tr>
        <tr bgcolor="efefef"><td>Companies.SourceDescriptor</td><td>The name of the original datasource that the company was imported from.</td></tr>
        <tr><td>Companies.SourcePrimaryKey</td><td>The company's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <a name="GetCompaniesForIds2Request"><b>GetCompaniesForIds2Request</b></a><br />
      Get companies for a set of Newforma database IDs.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"CompanyIds" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>CompanyIds</td><td>The Newforma database IDs to retrieve companies for.</td></tr>
      </tbody></table><p>
      <b>GetCompaniesForIds2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Companies" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"MainContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DisciplineList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SpecSectionList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"WebUrl" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NoteText" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Rating" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFields" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Companies</td><td>The set of companies matching the requested Newforma database IDs.</td></tr>
        <tr><td>Companies.CompanyId</td><td>The company's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Companies.MainContactId</td><td>The contact's associated main contact's Newforma database ID.</td></tr>
        <tr><td>Companies.CompanyName</td><td>The company's name.</td></tr>
        <tr bgcolor="efefef"><td>Companies.DisciplineList</td><td>The company's discipline list.</td></tr>
        <tr><td>Companies.SpecSectionList</td><td>The company's spec section list.</td></tr>
        <tr bgcolor="efefef"><td>Companies.WebUrl</td><td>The company's website URL.</td></tr>
        <tr><td>Companies.NoteText</td><td>The company's HTML note text.</td></tr>
        <tr bgcolor="efefef"><td>Companies.SourceDescriptor</td><td>The name of the original datasource that the company was imported from.</td></tr>
        <tr><td>Companies.SourcePrimaryKey</td><td>The company's primary key in its original datasource.</td></tr>
        <tr bgcolor="efefef"><td>Companies.Rating</td><td>The company's rating in the range 0 - 5.</td></tr>
        <tr><td>Companies.CompanyType</td><td>The company's type.</td></tr>
        <tr bgcolor="efefef"><td>Companies.CustomFields</td><td>The company's custom fields.</td></tr>
        <tr><td>Companies.CustomFields.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>Companies.CustomFields.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>Companies.CustomFields.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>Companies.CustomFields.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>Companies.CustomFields.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>Companies.CustomFields.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>Companies.CustomFields.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>Companies.CustomFields.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>Companies.CustomFields.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>Companies.CustomFields.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>Companies.CustomFields.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>Companies.CustomFields.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Companies.CustomFields.CompanyId</td><td>The company's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="GetCompaniesForNamesRequest"><b>GetCompaniesForNamesRequest</b></a> (Deprecated: use <a href="#GetCompanyDescriptorsForNamesRequest">GetCompanyDescriptorsForNames</a> instead.)<br />
      Get companies for a set of company names.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"CompanyNames" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>CompanyNames</td><td>The company names to retrieve companies for.</td></tr>
      </tbody></table><p>
      <b>GetCompaniesForNamesResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Companies" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"MainContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DisciplineList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SpecSectionList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"WebUrl" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NoteText" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Companies</td><td>The set of companies matching the requested company names.</td></tr>
        <tr><td>Companies.CompanyId</td><td>The company's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Companies.MainContactId</td><td>The contact's associated main contact's Newforma database ID.</td></tr>
        <tr><td>Companies.CompanyName</td><td>The company's name.</td></tr>
        <tr bgcolor="efefef"><td>Companies.DisciplineList</td><td>The company's discipline list.</td></tr>
        <tr><td>Companies.SpecSectionList</td><td>The company's spec section list.</td></tr>
        <tr bgcolor="efefef"><td>Companies.WebUrl</td><td>The company's website URL.</td></tr>
        <tr><td>Companies.NoteText</td><td>The company's HTML note text.</td></tr>
        <tr bgcolor="efefef"><td>Companies.SourceDescriptor</td><td>The name of the original datasource that the company was imported from.</td></tr>
        <tr><td>Companies.SourcePrimaryKey</td><td>The company's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <a name="GetCompaniesForSourceDescriptorsRequest"><b>GetCompaniesForSourceDescriptorsRequest</b></a> (Deprecated: use <a href="#GetCompanyDescriptorsForSourceDescriptorsRequest">GetCompanyDescriptorsForSourceDescriptors</a> instead.)<br />
      Get companies for a set of source descriptors.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"SourceDescriptors" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptors</td><td>The source descriptors to retrieve companies for.</td></tr>
        <tr><td>SourceDescriptors.SourceDescriptor</td><td>The name of the original datasource that the item was imported from.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptors.SourcePrimaryKey</td><td>The item's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <b>GetCompaniesForSourceDescriptorsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Companies" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"MainContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DisciplineList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SpecSectionList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"WebUrl" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NoteText" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Companies</td><td>The set of companies matching the requested source descriptors.</td></tr>
        <tr><td>Companies.CompanyId</td><td>The company's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Companies.MainContactId</td><td>The contact's associated main contact's Newforma database ID.</td></tr>
        <tr><td>Companies.CompanyName</td><td>The company's name.</td></tr>
        <tr bgcolor="efefef"><td>Companies.DisciplineList</td><td>The company's discipline list.</td></tr>
        <tr><td>Companies.SpecSectionList</td><td>The company's spec section list.</td></tr>
        <tr bgcolor="efefef"><td>Companies.WebUrl</td><td>The company's website URL.</td></tr>
        <tr><td>Companies.NoteText</td><td>The company's HTML note text.</td></tr>
        <tr bgcolor="efefef"><td>Companies.SourceDescriptor</td><td>The name of the original datasource that the company was imported from.</td></tr>
        <tr><td>Companies.SourcePrimaryKey</td><td>The company's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <a name="GetCompanyDescriptorsForNamesRequest"><b>GetCompanyDescriptorsForNamesRequest</b></a><br />
      Get company descriptors for a set of company names.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"CompanyNames" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>CompanyNames</td><td>The company names to retrieve company descriptors for.</td></tr>
      </tbody></table><p>
      <b>GetCompanyDescriptorsForNamesResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Descriptors" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Descriptors</td><td>The set of company descriptors matching the requested company names.</td></tr>
        <tr><td>Descriptors.CompanyId</td><td>The company's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.CompanyName</td><td>The company's name.</td></tr>
        <tr><td>Descriptors.SourceDescriptor</td><td>The name of the original datasource that the company was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.SourcePrimaryKey</td><td>The company's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <a name="GetCompanyDescriptorsForSourceDescriptorsRequest"><b>GetCompanyDescriptorsForSourceDescriptorsRequest</b></a><br />
      Get company descriptors for a set of source descriptors.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"SourceDescriptors" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptors</td><td>The source descriptors to retrieve company descriptors for.</td></tr>
        <tr><td>SourceDescriptors.SourceDescriptor</td><td>The name of the original datasource that the item was imported from.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptors.SourcePrimaryKey</td><td>The item's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <b>GetCompanyDescriptorsForSourceDescriptorsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Descriptors" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Descriptors</td><td>The set of company descriptors matching the requested source descriptors.</td></tr>
        <tr><td>Descriptors.CompanyId</td><td>The company's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.CompanyName</td><td>The company's name.</td></tr>
        <tr><td>Descriptors.SourceDescriptor</td><td>The name of the original datasource that the company was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.SourcePrimaryKey</td><td>The company's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <a name="GetContactDescriptorsForEmailAddressesRequest"><b>GetContactDescriptorsForEmailAddressesRequest</b></a><br />
      Get contact descriptors for a set of email addresses.  In Tenth Edition this request relaces <code>GetContactsForEmailAddressesRequest</code> providing a generalized implementation that will result in fewer API changes in the future.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"EmailAddresses" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>EmailAddresses</td><td>The email addresses to retrieve contact descriptors for.</td></tr>
      </tbody></table><p>
      <b>GetContactDescriptorsForEmailAddressesResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Descriptors" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EmailAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Descriptors</td><td>The set of contact descriptors matching the requested email addresses.</td></tr>
        <tr><td>Descriptors.ContactId</td><td>The contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.EmailAddress</td><td>The contact's email address.</td></tr>
        <tr><td>Descriptors.SourceDescriptor</td><td>The name of the original datasource that the contact was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.SourcePrimaryKey</td><td>The contact's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <a name="GetContactDescriptorsForSourceDescriptorsRequest"><b>GetContactDescriptorsForSourceDescriptorsRequest</b></a><br />
      Get contact descriptors for a set of source descriptors.  In Tenth Edition this request relaces <code>GetContactDescriptorsForSourceDescriptorsRequest</code> providing a generalized implementation that will result in fewer API changes in the future.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"SourceDescriptors" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptors</td><td>The source descriptors to retrieve contact desciptors for.</td></tr>
        <tr><td>SourceDescriptors.SourceDescriptor</td><td>The name of the original datasource that the item was imported from.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptors.SourcePrimaryKey</td><td>The item's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <b>GetContactDescriptorsForSourceDescriptorsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Descriptors" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EmailAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Descriptors</td><td>The set of contact descriptors matching the requested source descriptors.</td></tr>
        <tr><td>Descriptors.ContactId</td><td>The contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.EmailAddress</td><td>The contact's email address.</td></tr>
        <tr><td>Descriptors.SourceDescriptor</td><td>The name of the original datasource that the contact was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.SourcePrimaryKey</td><td>The contact's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <a name="GetContactsForEmailAddressesRequest"><b>GetContactsForEmailAddressesRequest</b></a> (Deprecated: use <a href="#GetContactDescriptorsForEmailAddressesRequest">GetContactDescriptorsForEmailAddresses</a> instead.)<br />
      Get contacts for a set of email addresses.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"EmailAddresses" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>EmailAddresses</td><td>The email addresses to retrieve contacts for.</td></tr>
      </tbody></table><p>
      <b>GetContactsForEmailAddressesResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Contacts" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"OfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EmailAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FirstName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"LastName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DepartmentName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"JobTitle" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DisciplineList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberWork" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberMobile" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberHome" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FaxNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NoteText" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ActiveUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AddressType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"UseOfficeAddress" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Contacts</td><td>The set of contacts matching the requested email addresses.</td></tr>
        <tr><td>Contacts.ContactId</td><td>The contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.CompanyId</td><td>The contact's associated company's Newforma database ID.</td></tr>
        <tr><td>Contacts.OfficeLocationId</td><td>The contact's associated office location's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.EmailAddress</td><td>The contact's email address.</td></tr>
        <tr><td>Contacts.FirstName</td><td>The contact's first name.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.LastName</td><td>The contact's last name.</td></tr>
        <tr><td>Contacts.DepartmentName</td><td>The contact's department name.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.JobTitle</td><td>The contact's job title.</td></tr>
        <tr><td>Contacts.DisciplineList</td><td>The contact's discipline list.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.PhoneNumberWork</td><td>The contact's work phone number.</td></tr>
        <tr><td>Contacts.PhoneNumberMobile</td><td>The contact's mobile phone number.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.PhoneNumberHome</td><td>The contact's home phone number.</td></tr>
        <tr><td>Contacts.FaxNumber</td><td>The contact's fax number.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.StreetAddress</td><td>The contact's street address.  The format of a street address is either five
            fields (address│city│state│zip│country) separated
            by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>Contacts.NoteText</td><td>The contact's HTML note text.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.ActiveUser</td><td>Is the contact an active Newforma user?</td></tr>
        <tr><td>Contacts.NixUser</td><td>Does the contact have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Contacts.AcceptedDisclaimer</td><td>Has the contact accepted the Terms and Conditions on NIX?</td></tr>
        <tr><td>Contacts.AddressType</td><td>The contact's address type.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.UseOfficeAddress</td><td>Should the contact use their associated office location's address?</td></tr>
        <tr><td>Contacts.SourceDescriptor</td><td>The name of the original datasource that the contact was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.SourcePrimaryKey</td><td>The contact's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <a name="GetContactsForIdsRequest"><b>GetContactsForIdsRequest</b></a> (Deprecated: use <a href="#GetContactsForIds3Request">GetContactsForIds3</a> instead.)<br />
      Get contacts for a set of Newforma database IDs.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ContactIds" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ContactIds</td><td>The Newforma database IDs to retrieve contacts for.</td></tr>
      </tbody></table><p>
      <b>GetContactsForIdsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Contacts" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"OfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EmailAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FirstName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"LastName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DepartmentName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"JobTitle" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DisciplineList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberWork" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberMobile" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberHome" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FaxNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NoteText" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ActiveUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AddressType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"UseOfficeAddress" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Contacts</td><td>The set of contacts matching the requested Newforma database IDs.</td></tr>
        <tr><td>Contacts.ContactId</td><td>The contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.CompanyId</td><td>The contact's associated company's Newforma database ID.</td></tr>
        <tr><td>Contacts.OfficeLocationId</td><td>The contact's associated office location's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.EmailAddress</td><td>The contact's email address.</td></tr>
        <tr><td>Contacts.FirstName</td><td>The contact's first name.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.LastName</td><td>The contact's last name.</td></tr>
        <tr><td>Contacts.DepartmentName</td><td>The contact's department name.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.JobTitle</td><td>The contact's job title.</td></tr>
        <tr><td>Contacts.DisciplineList</td><td>The contact's discipline list.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.PhoneNumberWork</td><td>The contact's work phone number.</td></tr>
        <tr><td>Contacts.PhoneNumberMobile</td><td>The contact's mobile phone number.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.PhoneNumberHome</td><td>The contact's home phone number.</td></tr>
        <tr><td>Contacts.FaxNumber</td><td>The contact's fax number.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.StreetAddress</td><td>The contact's street address.  The format of a street address is either five
            fields (address│city│state│zip│country) separated
            by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>Contacts.NoteText</td><td>The contact's HTML note text.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.ActiveUser</td><td>Is the contact an active Newforma user?</td></tr>
        <tr><td>Contacts.NixUser</td><td>Does the contact have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Contacts.AcceptedDisclaimer</td><td>Has the contact accepted the Terms and Conditions on NIX?</td></tr>
        <tr><td>Contacts.AddressType</td><td>The contact's address type.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.UseOfficeAddress</td><td>Should the contact use their associated office location's address?</td></tr>
        <tr><td>Contacts.SourceDescriptor</td><td>The name of the original datasource that the contact was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.SourcePrimaryKey</td><td>The contact's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <a name="GetContactsForIds2Request"><b>GetContactsForIds2Request</b></a><br />
      Get contacts for a set of Newforma database IDs.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ContactIds" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ContactIds</td><td>The Newforma database IDs to retrieve contacts for.</td></tr>
      </tbody></table><p>
      <b>GetContactsForIds2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Contacts" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"OfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EmailAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FirstName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"LastName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DepartmentName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"JobTitle" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DisciplineList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberWork" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberMobile" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberHome" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FaxNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NoteText" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ActiveUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AddressType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"UseOfficeAddress" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Roles" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFields" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Contacts</td><td>The set of contacts matching the requested Newforma database IDs.</td></tr>
        <tr><td>Contacts.ContactId</td><td>The contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.CompanyId</td><td>The contact's associated company's Newforma database ID.</td></tr>
        <tr><td>Contacts.OfficeLocationId</td><td>The contact's associated office location's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.EmailAddress</td><td>The contact's email address.</td></tr>
        <tr><td>Contacts.FirstName</td><td>The contact's first name.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.LastName</td><td>The contact's last name.</td></tr>
        <tr><td>Contacts.DepartmentName</td><td>The contact's department name.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.JobTitle</td><td>The contact's job title.</td></tr>
        <tr><td>Contacts.DisciplineList</td><td>The contact's discipline list.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.PhoneNumberWork</td><td>The contact's work phone number.</td></tr>
        <tr><td>Contacts.PhoneNumberMobile</td><td>The contact's mobile phone number.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.PhoneNumberHome</td><td>The contact's home phone number.</td></tr>
        <tr><td>Contacts.FaxNumber</td><td>The contact's fax number.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.StreetAddress</td><td>The contact's street address.  The format of a street address is either five
            fields (address│city│state│zip│country) separated
            by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>Contacts.NoteText</td><td>The contact's HTML note text.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.ActiveUser</td><td>Is the contact an active Newforma user?</td></tr>
        <tr><td>Contacts.NixUser</td><td>Does the contact have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Contacts.AcceptedDisclaimer</td><td>Has the contact accepted the Terms and Conditions on NIX?</td></tr>
        <tr><td>Contacts.AddressType</td><td>The contact's address type.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.UseOfficeAddress</td><td>Should the contact use their associated office location's address?</td></tr>
        <tr><td>Contacts.SourceDescriptor</td><td>The name of the original datasource that the contact was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.SourcePrimaryKey</td><td>The contact's primary key in its original datasource.</td></tr>
        <tr><td>Contacts.Roles</td><td>The contact's roles.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.CustomFields</td><td>The contact's custom fields.</td></tr>
        <tr><td>Contacts.CustomFields.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.CustomFields.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>Contacts.CustomFields.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>Contacts.CustomFields.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.CustomFields.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>Contacts.CustomFields.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.CustomFields.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>Contacts.CustomFields.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.CustomFields.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>Contacts.CustomFields.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.CustomFields.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>Contacts.CustomFields.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.CustomFields.ContactId</td><td>The contact's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="GetContactsForIds3Request"><b>GetContactsForIds3Request</b></a><br />
      Get contacts for a set of Newforma database IDs.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ContactIds" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ContactIds</td><td>The Newforma database IDs to retrieve contacts for.</td></tr>
      </tbody></table><p>
      <b>GetContactsForIds3Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Contacts" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"OfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EmailAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FirstName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"LastName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DepartmentName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"JobTitle" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DisciplineList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberWork" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberMobile" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberHome" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FaxNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NoteText" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ActiveUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AddressType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"UseOfficeAddress" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Roles" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFields" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Contacts</td><td>The set of contacts matching the requested Newforma database IDs.</td></tr>
        <tr><td>Contacts.ContactId</td><td>The contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.CompanyId</td><td>The contact's associated company's Newforma database ID.</td></tr>
        <tr><td>Contacts.OfficeLocationId</td><td>The contact's associated office location's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.EmailAddress</td><td>The contact's email address.</td></tr>
        <tr><td>Contacts.FirstName</td><td>The contact's first name.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.LastName</td><td>The contact's last name.</td></tr>
        <tr><td>Contacts.DepartmentName</td><td>The contact's department name.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.JobTitle</td><td>The contact's job title.</td></tr>
        <tr><td>Contacts.DisciplineList</td><td>The contact's discipline list.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.PhoneNumberWork</td><td>The contact's work phone number.</td></tr>
        <tr><td>Contacts.PhoneNumberMobile</td><td>The contact's mobile phone number.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.PhoneNumberHome</td><td>The contact's home phone number.</td></tr>
        <tr><td>Contacts.FaxNumber</td><td>The contact's fax number.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.StreetAddress</td><td>The contact's street address.  The format of a street address is either five
            fields (address│city│state│zip│country) separated
            by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>Contacts.NoteText</td><td>The contact's HTML note text.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.ActiveUser</td><td>Is the contact an active Newforma user?</td></tr>
        <tr><td>Contacts.NixUser</td><td>Does the contact have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Contacts.AcceptedDisclaimer</td><td>Has the contact accepted the Terms and Conditions on NIX?</td></tr>
        <tr><td>Contacts.AddressType</td><td>The contact's address type.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.UseOfficeAddress</td><td>Should the contact use their associated office location's address?</td></tr>
        <tr><td>Contacts.SourceDescriptor</td><td>The name of the original datasource that the contact was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.SourcePrimaryKey</td><td>The contact's primary key in its original datasource.</td></tr>
        <tr><td>Contacts.Roles</td><td>The contact's roles.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.CustomFields</td><td>The contact's custom fields.</td></tr>
        <tr><td>Contacts.CustomFields.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.CustomFields.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>Contacts.CustomFields.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>Contacts.CustomFields.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.CustomFields.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>Contacts.CustomFields.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.CustomFields.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>Contacts.CustomFields.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.CustomFields.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>Contacts.CustomFields.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.CustomFields.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>Contacts.CustomFields.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.CustomFields.ContactId</td><td>The contact's Newforma database ID.</td></tr>
        <tr><td>Contacts.Culture</td><td>The contact's culture for notifications without a project context.</td></tr>
      </tbody></table><p>
      <a name="GetContactsForSourceDescriptorsRequest"><b>GetContactsForSourceDescriptorsRequest</b></a> (Deprecated: use <a href="#GetContactDescriptorsForSourceDescriptorsRequest">GetContactDescriptorsForSourceDescriptors</a> instead.)<br />
      Get contacts for a set of source descriptors.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"SourceDescriptors" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptors</td><td>The source descriptors to retrieve contacts for.</td></tr>
        <tr><td>SourceDescriptors.SourceDescriptor</td><td>The name of the original datasource that the item was imported from.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptors.SourcePrimaryKey</td><td>The item's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <b>GetContactsForSourceDescriptorsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Contacts" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"OfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EmailAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FirstName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"LastName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DepartmentName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"JobTitle" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DisciplineList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberWork" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberMobile" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberHome" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FaxNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NoteText" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ActiveUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AddressType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"UseOfficeAddress" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Contacts</td><td>The set of contacts matching the requested source descriptors.</td></tr>
        <tr><td>Contacts.ContactId</td><td>The contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.CompanyId</td><td>The contact's associated company's Newforma database ID.</td></tr>
        <tr><td>Contacts.OfficeLocationId</td><td>The contact's associated office location's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.EmailAddress</td><td>The contact's email address.</td></tr>
        <tr><td>Contacts.FirstName</td><td>The contact's first name.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.LastName</td><td>The contact's last name.</td></tr>
        <tr><td>Contacts.DepartmentName</td><td>The contact's department name.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.JobTitle</td><td>The contact's job title.</td></tr>
        <tr><td>Contacts.DisciplineList</td><td>The contact's discipline list.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.PhoneNumberWork</td><td>The contact's work phone number.</td></tr>
        <tr><td>Contacts.PhoneNumberMobile</td><td>The contact's mobile phone number.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.PhoneNumberHome</td><td>The contact's home phone number.</td></tr>
        <tr><td>Contacts.FaxNumber</td><td>The contact's fax number.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.StreetAddress</td><td>The contact's street address.  The format of a street address is either five
            fields (address│city│state│zip│country) separated
            by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>Contacts.NoteText</td><td>The contact's HTML note text.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.ActiveUser</td><td>Is the contact an active Newforma user?</td></tr>
        <tr><td>Contacts.NixUser</td><td>Does the contact have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Contacts.AcceptedDisclaimer</td><td>Has the contact accepted the Terms and Conditions on NIX?</td></tr>
        <tr><td>Contacts.AddressType</td><td>The contact's address type.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.UseOfficeAddress</td><td>Should the contact use their associated office location's address?</td></tr>
        <tr><td>Contacts.SourceDescriptor</td><td>The name of the original datasource that the contact was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Contacts.SourcePrimaryKey</td><td>The contact's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <a name="GetDocumentSetSummaryRequest"><b>GetDocumentSetSummaryRequest</b></a><br />
      Get Document Set summaries from a project matching a category filter.</p><p>
      It is an error to retrieve project items for a project that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"CategoryFilter" : <i>int</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>CategoryFilter</td><td>The category of project items to return.  To return all project items use the CategoryFilterAll filter.<p>Allowed values:<br />
              CategoryFilterAll = 1<br />
              CategoryFilterActive = 2<br />
              CategoryFilterInactive = 4<br />
              CategoryFilterImageGallery = 8</p></td></tr>
      </tbody></table><p>
      <b>GetDocumentSetSummaryResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Summaries" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Name" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Summaries</td><td>The Document Set summaries matching the category filter.</td></tr>
        <tr><td>Summaries.ProjectItemId</td><td>The project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>Summaries.Name</td><td>The project item's name.</td></tr>
        <tr><td>Summaries.Number</td><td>The project item's number.</td></tr>
      </tbody></table><p>
      <a name="GetDocumentSetsRequest"><b>GetDocumentSetsRequest</b></a><br />
      Get Document Sets from a project for a set of project item IDs.</p><p>
      It is an error to retrieve project items for a project that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectItemIds" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>ProjectItemIds</td><td>The project items' Newforma database IDs.</td></tr>
      </tbody></table><p>
      <b>GetDocumentSetsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"DocumentSets" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Name" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Keywords" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SupportingDocuments" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EmailLog" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ParentDocumentSetProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ChildDocumentSetProjectItemIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"MembersContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StatusLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ImageGallery" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Description" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"LiveFolders" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"IncludeMask" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ExcludeMask" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Path" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>DocumentSets</td><td>The Document Sets matching the project item IDs.</td></tr>
        <tr><td>DocumentSets.ProjectItemId</td><td>The project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>DocumentSets.Name</td><td>The project item's name.</td></tr>
        <tr><td>DocumentSets.Number</td><td>The project item's number.</td></tr>
        <tr bgcolor="efefef"><td>DocumentSets.Keywords</td><td>The project item's keywords.</td></tr>
        <tr><td>DocumentSets.SupportingDocuments</td><td>The project item's supporting documents as a collection of UNC paths.</td></tr>
        <tr bgcolor="efefef"><td>DocumentSets.EmailLog</td><td>The project item's email log as a collection of UNC paths.</td></tr>
        <tr><td>DocumentSets.ParentDocumentSetProjectItemId</td><td>The Document Set's parent Document Set Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>DocumentSets.ChildDocumentSetProjectItemIds</td><td>The Document Set's child Document Set Newforma database IDs.</td></tr>
        <tr><td>DocumentSets.MembersContactIds</td><td>The Newforma database IDs of the contacts who are members on the Document Set.</td></tr>
        <tr bgcolor="efefef"><td>DocumentSets.Status</td><td>The Document Set's status.<p>Allowed values:<br />
              StatusActive = 1<br />
              StatusInactive = 2</p></td></tr>
        <tr><td>DocumentSets.StatusLabel</td><td>The Document Set's status label.</td></tr>
        <tr bgcolor="efefef"><td>DocumentSets.ImageGallery</td><td>The Document Set's image gallery number.</td></tr>
        <tr><td>DocumentSets.Description</td><td>The Document Set's description.</td></tr>
        <tr bgcolor="efefef"><td>DocumentSets.LiveFolders</td><td>The Document Set's live folders.</td></tr>
        <tr><td>DocumentSets.LiveFolders.IncludeMask</td><td>The search phrase used to specify files that will be included in the live folder.</td></tr>
        <tr bgcolor="efefef"><td>DocumentSets.LiveFolders.ExcludeMask</td><td>The search phrase used to specify files that will be excluded from the live folder.</td></tr>
        <tr><td>DocumentSets.LiveFolders.Path</td><td>The UNC path of the live folder's directory.</td></tr>
      </tbody></table><p>
      <a name="GetDocumentSets2Request"><b>GetDocumentSets2Request</b></a><br />
      Get Document Sets from a project for a set of project item IDs.</p><p>
      It is an error to retrieve project items for a project that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectItemIds" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>ProjectItemIds</td><td>The project items' Newforma database IDs.</td></tr>
      </tbody></table><p>
      <b>GetDocumentSets2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"DocumentSets" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Name" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Keywords" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SupportingDocuments" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProviderId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"VersionNumber" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EmailLog" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProviderId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ParentDocumentSetProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ChildDocumentSetProjectItemIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"MembersContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StatusLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ImageGallery" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Description" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"LiveFolders" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"IncludeMask" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ExcludeMask" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FolderInfo" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>DocumentSets</td><td>The Document Sets matching the project item IDs.</td></tr>
        <tr><td>DocumentSets.ProjectItemId</td><td>The project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>DocumentSets.Name</td><td>The project item's name.</td></tr>
        <tr><td>DocumentSets.Number</td><td>The project item's number.</td></tr>
        <tr bgcolor="efefef"><td>DocumentSets.Keywords</td><td>The project item's keywords.</td></tr>
        <tr><td>DocumentSets.SupportingDocuments</td><td>--</td></tr>
        <tr><td>DocumentSets.SupportingDocuments.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>DocumentSets.SupportingDocuments.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr><td>DocumentSets.SupportingDocuments.ProviderId</td><td>File's EDMS plugin's provider id</td></tr>
        <tr bgcolor="efefef"><td>DocumentSets.SupportingDocuments.VersionNumber</td><td>File's version number</td></tr>
        <tr bgcolor="efefef"><td>DocumentSets.EmailLog</td><td>--</td></tr>
        <tr><td>DocumentSets.EmailLog.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>DocumentSets.EmailLog.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr><td>DocumentSets.EmailLog.ProviderId</td><td>File's EDMS plugin's provider id</td></tr>
        <tr><td>DocumentSets.ParentDocumentSetProjectItemId</td><td>The Document Set's parent Document Set Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>DocumentSets.ChildDocumentSetProjectItemIds</td><td>The Document Set's child Document Set Newforma database IDs.</td></tr>
        <tr><td>DocumentSets.MembersContactIds</td><td>The Newforma database IDs of the contacts who are members on the Document Set.</td></tr>
        <tr bgcolor="efefef"><td>DocumentSets.Status</td><td>The Document Set's status.<p>Allowed values:<br />
              StatusActive = 1<br />
              StatusInactive = 2</p></td></tr>
        <tr><td>DocumentSets.StatusLabel</td><td>The Document Set's status label.</td></tr>
        <tr bgcolor="efefef"><td>DocumentSets.ImageGallery</td><td>The Document Set's image gallery number.</td></tr>
        <tr><td>DocumentSets.Description</td><td>The Document Set's description.</td></tr>
        <tr bgcolor="efefef"><td>DocumentSets.LiveFolders</td><td>The Document Set's live folders.</td></tr>
        <tr><td>DocumentSets.LiveFolders.IncludeMask</td><td>The search phrase used to specify files that will be included in the live folder.</td></tr>
        <tr bgcolor="efefef"><td>DocumentSets.LiveFolders.ExcludeMask</td><td>The search phrase used to specify files that will be excluded from the live folder.</td></tr>
        <tr><td>DocumentSets.LiveFolders.FolderInfo</td><td>Live folder's directory's info</td></tr>
        <tr><td>DocumentSets.LiveFolders.FolderInfo.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>DocumentSets.LiveFolders.FolderInfo.FullPath</td><td>Full path of the file/folder</td></tr>
      </tbody></table><p>
      <a name="GetKeywordsForAllProjectFilesRequest"><b>GetKeywordsForAllProjectFilesRequest</b></a><br />
      Get keywords for all Project Files for a project ID.</p><p>
      It is an error to retrieve keywords for a project that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>GetKeywordsForAllProjectFilesResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"FileKeywords" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSObjectInfo" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProviderId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Keywords" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>FileKeywords</td><td>The collection of file / keyword pairs returned from the database.</td></tr>
        <tr><td>FileKeywords.EDMSObjectInfo</td><td>EDMS information referring to a specific project file.</td></tr>
        <tr><td>FileKeywords.EDMSObjectInfo.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>FileKeywords.EDMSObjectInfo.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr><td>FileKeywords.EDMSObjectInfo.ProviderId</td><td>Provider-specific ID for files to differentiate non-unique filenames within the same container.</td></tr>
        <tr bgcolor="efefef"><td>FileKeywords.Keywords</td><td>The keywords to assign to a project file. Use a blank string to clear.</td></tr>
      </tbody></table><p>
      <a name="GetKeywordsForProjectFilesRequest"><b>GetKeywordsForProjectFilesRequest</b></a><br />
      Get keywords for specified Project Files.</p><p>
      It is an error to retrieve keywords for a project that does not exist or to not provide a list of files.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"EDMSObjectInfo" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProviderId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>EDMSObjectInfo</td><td>The files to fetch keyword information for.</td></tr>
        <tr><td>EDMSObjectInfo.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>EDMSObjectInfo.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr><td>EDMSObjectInfo.ProviderId</td><td>Provider-specific ID for files to differentiate non-unique filenames within the same container.</td></tr>
      </tbody></table><p>
      <b>GetKeywordsForProjectFilesResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"FileKeywords" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSObjectInfo" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProviderId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Keywords" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>FileKeywords</td><td>The collection of file / keyword pairs returned from the database.</td></tr>
        <tr><td>FileKeywords.EDMSObjectInfo</td><td>EDMS information referring to a specific project file.</td></tr>
        <tr><td>FileKeywords.EDMSObjectInfo.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>FileKeywords.EDMSObjectInfo.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr><td>FileKeywords.EDMSObjectInfo.ProviderId</td><td>Provider-specific ID for files to differentiate non-unique filenames within the same container.</td></tr>
        <tr bgcolor="efefef"><td>FileKeywords.Keywords</td><td>The keywords to assign to a project file. Use a blank string to clear.</td></tr>
      </tbody></table><p>
      <a name="GetLiteProjectItemsRequest"><b>GetLiteProjectItemsRequest</b></a><br />
      retrieve lite project items info
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectItemTypes" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>int</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>the project's Newforma datababase ID.</td></tr>
        <tr><td>ProjectItemTypes</td><td>one or more project item types of lite project items info to retrieve. Available types:
            <ul>
              <li>DocumentSet =1
              </li><li>ActionItem = 2
              </li><li>NixTransfer = 3
              </li><li>Transmittal = 4
              </li><li>MarkupSession =7
              </li><li>CalendarItem = 8
              </li><li>RecordCopy = 9
              </li><li>BimItem = 14
              </li><li>Space = 16
              </li><li>PunchlistItem = 17
              </li><li>RecordDocument = 18
              </li><li>Contracts = 64
              </li><li>Asi = 65
              </li><li>Submittals = 66
              </li><li>RFIs = 67
              </li><li>SketchLog = 68
              </li><li>Addendums = 69
              </li><li>ChangeOrders = 70
              </li><li>ChangeOrderProposals = 71
              </li><li>Bulletins = 72
              </li><li>ProposalRequests = 73
              </li><li>Ccds = 74
              </li><li>FieldNotes = 75
              </li><li>CostCodeUAC = 77
              </li><li>DailyReports = 78
              </li><li>SiteVisits = 80
              </li><li>PotentialChangeOrders = 83
              </li></ul></td></tr>
      </tbody></table><p>
      <b>GetLiteProjectItemsResponse</b><br />
      response to retrieving lite project items
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"LiteProjectItems" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Type" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Id" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Name" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>LiteProjectItems</td><td>zero or more lite project items</td></tr>
        <tr><td>LiteProjectItems.Type</td><td>project item type</td></tr>
        <tr bgcolor="efefef"><td>LiteProjectItems.Id</td><td>project item's newforma database id</td></tr>
        <tr><td>LiteProjectItems.Name</td><td>project item's name</td></tr>
        <tr bgcolor="efefef"><td>LiteProjectItems.Number</td><td>project item's number</td></tr>
      </tbody></table><p>
      <a name="GetMyProjectsRequest"><b>GetMyProjectsRequest</b></a><br />
      Get my-projects for a contact in the Newforma database.</p><p>
      It is an error to retrieve my-projects for a contact that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ContactId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ContactId</td><td>The contact's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>GetMyProjectsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"MyProjects" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"MyProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DisplayOrder" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>MyProjects</td><td>The contact's my-projects list.</td></tr>
        <tr><td>MyProjects.MyProjectId</td><td>The my-project's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>MyProjects.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>MyProjects.ContactId</td><td>The associated contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>MyProjects.DisplayOrder</td><td>The my-project's display order within UIs.</td></tr>
      </tbody></table><p>
      <a name="GetOfficeLocationsRequest"><b>GetOfficeLocationsRequest</b></a> (Deprecated: use <a href="#GetOfficeLocations2Request">GetOfficeLocations2</a> instead.)<br />
      Get all office locations for a company's Newforma database ID.</p><p>
      It is an error to retrieve office locations for a company that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"CompanyId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>CompanyId</td><td>The company's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>GetOfficeLocationsResponse</b><br />
      Returns all office locations for a company's Newforma database ID.  If the company does not exist, the response status will indicate an error.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"OfficeLocations" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"OfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"LocationName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FaxNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AddressType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>OfficeLocations</td><td>All office locations associated with the company in the Newforma database.</td></tr>
        <tr><td>OfficeLocations.OfficeLocationId</td><td>The office location's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocations.CompanyId</td><td>The office location's associated company's Newforma database ID.</td></tr>
        <tr><td>OfficeLocations.LocationName</td><td>The office location's name.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocations.StreetAddress</td><td>The office location's street address.  The format of a street address is either
            five fields (address│city│state│zip│country)
            separated by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>OfficeLocations.PhoneNumber</td><td>The office location's primary phone number.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocations.FaxNumber</td><td>The office location's primary fax number.</td></tr>
        <tr><td>OfficeLocations.AddressType</td><td>The office location's address type.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocations.SourceDescriptor</td><td>The name of the original datasource that the office location was imported from.</td></tr>
        <tr><td>OfficeLocations.SourcePrimaryKey</td><td>The office location's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <a name="GetOfficeLocations2Request"><b>GetOfficeLocations2Request</b></a><br />
      Get all office locations for a company's Newforma database ID.</p><p>
      It is an error to retrieve office locations for a company that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"CompanyId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>CompanyId</td><td>The company's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>GetOfficeLocations2Response</b><br />
      Returns all office locations for a company's Newforma database ID.  If the company does not exist, the response status will indicate an error.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"OfficeLocations" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"OfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"LocationName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FaxNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AddressType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PrimaryLocation" : <i>boolean</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>OfficeLocations</td><td>All office locations associated with the company in the Newforma database.</td></tr>
        <tr><td>OfficeLocations.OfficeLocationId</td><td>The office location's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocations.CompanyId</td><td>The office location's associated company's Newforma database ID.</td></tr>
        <tr><td>OfficeLocations.LocationName</td><td>The office location's name.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocations.StreetAddress</td><td>The office location's street address.  The format of a street address is either
            five fields (address│city│state│zip│country)
            separated by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>OfficeLocations.PhoneNumber</td><td>The office location's primary phone number.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocations.FaxNumber</td><td>The office location's primary fax number.</td></tr>
        <tr><td>OfficeLocations.AddressType</td><td>The office location's address type.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocations.SourceDescriptor</td><td>The name of the original datasource that the office location was imported from.</td></tr>
        <tr><td>OfficeLocations.SourcePrimaryKey</td><td>The office location's primary key in its original datasource.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocations.PrimaryLocation</td><td>Is this office location the company's primary location?</td></tr>
      </tbody></table><p>
      <a name="GetProjectDescriptorsForNumbersRequest"><b>GetProjectDescriptorsForNumbersRequest</b></a><br />
      Get project descriptors for a set of project numbers.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Numbers" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Numbers</td><td>The project numbers to retrieve project descriptors for.</td></tr>
      </tbody></table><p>
      <b>GetProjectDescriptorsForNumbersResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Descriptors" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectName" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Descriptors</td><td>The set of project deescriptors matching the requested project numbers.</td></tr>
        <tr><td>Descriptors.ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.Number</td><td>The project's number.</td></tr>
        <tr><td>Descriptors.SourceDescriptor</td><td>The name of the original datasource that the project was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.SourcePrimaryKey</td><td>The projec's primary key in its original datasource.</td></tr>
        <tr><td>Descriptors.ProjectName</td><td>The project's name.</td></tr>
      </tbody></table><p>
      <a name="GetProjectDescriptorsForSourceDescriptorsRequest"><b>GetProjectDescriptorsForSourceDescriptorsRequest</b></a><br />
      Get project descriptors for a set of source descriptors.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"SourceDescriptors" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptors</td><td>The source descriptors to retrieve project descriptors for.</td></tr>
        <tr><td>SourceDescriptors.SourceDescriptor</td><td>The name of the original datasource that the item was imported from.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptors.SourcePrimaryKey</td><td>The item's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <b>GetProjectDescriptorsForSourceDescriptorsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Descriptors" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectName" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Descriptors</td><td>The set of project descriptors matching the requested source descriptors.</td></tr>
        <tr><td>Descriptors.ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.Number</td><td>The project's number.</td></tr>
        <tr><td>Descriptors.SourceDescriptor</td><td>The name of the original datasource that the project was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Descriptors.SourcePrimaryKey</td><td>The projec's primary key in its original datasource.</td></tr>
        <tr><td>Descriptors.ProjectName</td><td>The project's name.</td></tr>
      </tbody></table><p>
      <a name="GetProjectFoldersRequest"><b>GetProjectFoldersRequest</b></a> (Deprecated: use <a href="#GetProjectFolders2Request">GetProjectFolders2</a> instead.)<br />
      Get the project folder settings for a project.</p><p>
      It is an error to retrieve project folders for a project that does not exist, or is not available on NIX.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>GetProjectFoldersResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectFolders" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Path" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PrimaryFolder" : <i>boolean</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"ProjectEmailFolder" : <i>string</i>,<br />
        &nbsp;&nbsp;"DefaultIncomingFolder" : <i>string</i>,<br />
        &nbsp;&nbsp;"DefaultOutgoingFolder" : <i>string</i>,<br />
        &nbsp;&nbsp;"RecordCopyFolder" : <i>string</i>,<br />
        &nbsp;&nbsp;"PunchlistFolder" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>ProjectFolders</td><td>The top-level project folders for the project.</td></tr>
        <tr><td>ProjectFolders.Path</td><td>The UNC path for the project folder.</td></tr>
        <tr bgcolor="efefef"><td>ProjectFolders.PrimaryFolder</td><td>Is this the primary project folder?</td></tr>
        <tr bgcolor="efefef"><td>ProjectEmailFolder</td><td>The UNC path of the parent directory where automatically filed email is stored for the project.  Email may still be filed in subdirectories (by month, by quarter, etc.) underneath.</td></tr>
        <tr><td>DefaultIncomingFolder</td><td>The UNC path of the directory where incoming transfers are automatically stored for the project.</td></tr>
        <tr bgcolor="efefef"><td>DefaultOutgoingFolder</td><td>The UNC path of the directory where outgoing transfers are automatically stored for the project.</td></tr>
        <tr><td>RecordCopyFolder</td><td>The UNC path of the directory where record copy zip files are automatically stored for the project.</td></tr>
        <tr bgcolor="efefef"><td>PunchlistFolder</td><td>The UNC path of the directory where punch list supporting documents are automatically stored for the project.</td></tr>
      </tbody></table><p>
      <a name="GetProjectFolders2Request"><b>GetProjectFolders2Request</b></a> (Deprecated: use <a href="#GetProjectFolders3Request">GetProjectFolders3</a> instead.)<br />
      Get the project folder settings for a project.</p><p>
      It is an error to retrieve project folders for a project that does not exist, or is not available on NIX.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>GetProjectFolders2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectFolders" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Path" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PrimaryFolder" : <i>boolean</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"ProjectEmailFolder" : <i>string</i>,<br />
        &nbsp;&nbsp;"DefaultIncomingFolder" : <i>string</i>,<br />
        &nbsp;&nbsp;"DefaultOutgoingFolder" : <i>string</i>,<br />
        &nbsp;&nbsp;"RecordCopyFolder" : <i>string</i>,<br />
        &nbsp;&nbsp;"PunchlistFolder" : <i>string</i>,<br />
        &nbsp;&nbsp;"RecordCopyFolderByItemType" : <i>string</i>,<br />
        &nbsp;&nbsp;"OrganizeRecordCopiesByItemType" : <i>boolean</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>ProjectFolders</td><td>The top-level project folders for the project.</td></tr>
        <tr><td>ProjectFolders.Path</td><td>The UNC path for the project folder.</td></tr>
        <tr bgcolor="efefef"><td>ProjectFolders.PrimaryFolder</td><td>Is this the primary project folder?</td></tr>
        <tr bgcolor="efefef"><td>ProjectEmailFolder</td><td>The UNC path of the parent directory where automatically filed email is stored for the project.  Email may still be filed in subdirectories (by month, by quarter, etc.) underneath.</td></tr>
        <tr><td>DefaultIncomingFolder</td><td>The UNC path of the directory where incoming transfers are automatically stored for the project.</td></tr>
        <tr bgcolor="efefef"><td>DefaultOutgoingFolder</td><td>The UNC path of the directory where outgoing transfers are automatically stored for the project.</td></tr>
        <tr><td>RecordCopyFolder</td><td>The UNC path of the directory where record copy zip files are automatically stored for the project.</td></tr>
        <tr bgcolor="efefef"><td>PunchlistFolder</td><td>The UNC path of the directory where punch list supporting documents are automatically stored for the project.</td></tr>
        <tr><td>RecordCopyFolderByItemType</td><td>The UNC path of the directory where record copy zip files by item type are automatically stored for the project.</td></tr>
        <tr bgcolor="efefef"><td>OrganizeRecordCopiesByItemType</td><td>Are record copy zip files stored in subfolders by item type?</td></tr>
      </tbody></table><p>
      <a name="GetProjectFolders3Request"><b>GetProjectFolders3Request</b></a> (Deprecated: use <a href="#GetProjectFolders4Request">GetProjectFolders4</a> instead.)<br />
      Get the project folder settings for a project.</p><p>
      It is an error to retrieve project folders for a project that does not exist, or is not available on NIX.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>GetProjectFolders3Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectFolders" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Path" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PrimaryFolder" : <i>boolean</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"ProjectEmailFolder" : <i>string</i>,<br />
        &nbsp;&nbsp;"DefaultIncomingFolder" : <i>string</i>,<br />
        &nbsp;&nbsp;"DefaultOutgoingFolder" : <i>string</i>,<br />
        &nbsp;&nbsp;"RecordCopyFolder" : <i>string</i>,<br />
        &nbsp;&nbsp;"PunchlistFolder" : <i>string</i>,<br />
        &nbsp;&nbsp;"RecordCopyFolderByItemType" : <i>string</i>,<br />
        &nbsp;&nbsp;"OrganizeRecordCopiesByItemType" : <i>boolean</i>,<br />
        &nbsp;&nbsp;"FieldnotesFolder" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>ProjectFolders</td><td>The top-level project folders for the project.</td></tr>
        <tr><td>ProjectFolders.Path</td><td>The UNC path for the project folder.</td></tr>
        <tr bgcolor="efefef"><td>ProjectFolders.PrimaryFolder</td><td>Is this the primary project folder?</td></tr>
        <tr bgcolor="efefef"><td>ProjectEmailFolder</td><td>The UNC path of the parent directory where automatically filed email is stored for the project.  Email may still be filed in subdirectories (by month, by quarter, etc.) underneath.</td></tr>
        <tr><td>DefaultIncomingFolder</td><td>The UNC path of the directory where incoming transfers are automatically stored for the project.</td></tr>
        <tr bgcolor="efefef"><td>DefaultOutgoingFolder</td><td>The UNC path of the directory where outgoing transfers are automatically stored for the project.</td></tr>
        <tr><td>RecordCopyFolder</td><td>The UNC path of the directory where record copy zip files are automatically stored for the project.</td></tr>
        <tr bgcolor="efefef"><td>PunchlistFolder</td><td>The UNC path of the directory where punch list supporting documents are automatically stored for the project.</td></tr>
        <tr><td>RecordCopyFolderByItemType</td><td>The UNC path of the directory where record copy zip files by item type are automatically stored for the project.</td></tr>
        <tr bgcolor="efefef"><td>OrganizeRecordCopiesByItemType</td><td>Are record copy zip files stored in subfolders by item type?</td></tr>
        <tr><td>FieldnotesFolder</td><td>The UNC path of the directory where field notes supporting documents are automatically stored for the project.</td></tr>
      </tbody></table><p>
      <a name="GetProjectFolders4Request"><b>GetProjectFolders4Request</b></a><br />
      Get the project folder settings for a project.</p><p>
      It is an error to retrieve project folders for a project that does not exist, or is not available on NIX.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>GetProjectFolders4Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectFolders" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectFolderInfo" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PrimaryFolder" : <i>boolean</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"ProjectEmailFolder" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i><br />
        &nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;"DefaultIncomingFolder" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i><br />
        &nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;"DefaultOutgoingFolder" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i><br />
        &nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;"RecordCopyFolder" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i><br />
        &nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;"PunchlistFolder" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i><br />
        &nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;"RecordCopyFolderByItemType" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i><br />
        &nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;"OrganizeRecordCopiesByItemType" : <i>boolean</i>,<br />
        &nbsp;&nbsp;"FieldnotesFolder" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>ProjectFolders</td><td>The top-level project folders for the project.</td></tr>
        <tr><td>ProjectFolders.ProjectFolderInfo</td><td>The project folder information.</td></tr>
        <tr><td>ProjectFolders.ProjectFolderInfo.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>ProjectFolders.ProjectFolderInfo.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr bgcolor="efefef"><td>ProjectFolders.PrimaryFolder</td><td>Is this the primary project folder?</td></tr>
        <tr bgcolor="efefef"><td>ProjectEmailFolder</td><td>The folder info of the parent directory where automatically filed email is stored for the project.  Email may still be filed in subdirectories (by month, by quarter, etc.) underneath.</td></tr>
        <tr><td>ProjectEmailFolder.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>ProjectEmailFolder.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr><td>DefaultIncomingFolder</td><td>The folder info of the directory where incoming transfers are automatically stored for the project.</td></tr>
        <tr><td>DefaultIncomingFolder.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>DefaultIncomingFolder.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr bgcolor="efefef"><td>DefaultOutgoingFolder</td><td>The folder info of the directory where outgoing transfers are automatically stored for the project.</td></tr>
        <tr><td>DefaultOutgoingFolder.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>DefaultOutgoingFolder.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr><td>RecordCopyFolder</td><td>The folder info of the directory where record copy zip files are automatically stored for the project.</td></tr>
        <tr><td>RecordCopyFolder.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>RecordCopyFolder.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr bgcolor="efefef"><td>PunchlistFolder</td><td>The folder info of the directory where punch list supporting documents are automatically stored for the project.</td></tr>
        <tr><td>PunchlistFolder.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>PunchlistFolder.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr><td>RecordCopyFolderByItemType</td><td>The folder info of the directory where record copy zip files by item type are automatically stored for the project.</td></tr>
        <tr><td>RecordCopyFolderByItemType.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>RecordCopyFolderByItemType.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr bgcolor="efefef"><td>OrganizeRecordCopiesByItemType</td><td>Are record copy zip files stored in subfolders by item type?</td></tr>
        <tr><td>FieldnotesFolder</td><td>The folder info of the directory where field notes supporting documents are automatically stored for the project.</td></tr>
        <tr><td>FieldnotesFolder.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>FieldnotesFolder.FullPath</td><td>Full path of the file/folder</td></tr>
      </tbody></table><p>
      <a name="GetProjectTeamRequest"><b>GetProjectTeamRequest</b></a> (Deprecated: use <a href="#GetProjectTeam3Request">GetProjectTeam3</a> instead.)<br />
      Get the project team for a project in the Newforma database.</p><p>
      It is an error to retrieve the project team for a project that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>GetProjectTeamResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Members" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PermissionSetId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Visibility" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"Groups" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamGroupId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"GroupName" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"GroupMembers" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamGroupMemberId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamGroupId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Members</td><td>The project team members for the project.</td></tr>
        <tr><td>Members.ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Members.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>Members.ContactId</td><td>The associated contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Members.PermissionSetId</td><td>The associated permission set's Newforma database ID.</td></tr>
        <tr><td>Members.NixUser</td><td>Does the project team member have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Members.Visibility</td><td>The visibility on NIX of the project team member to other team members.<p>Allowed values:<br />
              VisibilityExtendedProjectTeam = 1<br />
              VisibilityFellowCompanyMembers = 2<br />
              VisibilityNotVisible = 3<br />
              VisibilityExtendedProjectTeamNameAndEmailOnly = 4</p></td></tr>
        <tr><td>Members.AcceptedDisclaimer</td><td>Has the project team member accepted the Terms and Conditions on NIX for this project?</td></tr>
        <tr bgcolor="efefef"><td>Groups</td><td>The project team groups for the project.</td></tr>
        <tr><td>Groups.ProjectTeamGroupId</td><td>The project team group's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Groups.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>Groups.GroupName</td><td>The project team group's name.</td></tr>
        <tr><td>GroupMembers</td><td>The project team group members for the project.</td></tr>
        <tr><td>GroupMembers.ProjectTeamGroupMemberId</td><td>The project team group member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>GroupMembers.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>GroupMembers.ProjectTeamGroupId</td><td>The associated project team group's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>GroupMembers.ProjectTeamMemberId</td><td>The associated project team member's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="GetProjectTeam2Request"><b>GetProjectTeam2Request</b></a> (Deprecated: use <a href="#GetProjectTeam3Request">GetProjectTeam3</a> instead.)<br />
      Get the project team for a project in the Newforma database.</p><p>
      It is an error to retrieve the project team for a project that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>GetProjectTeam2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Members" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PermissionSetId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Visibility" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PrimaryContact" : <i>boolean</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"Groups" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamGroupId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"GroupName" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"GroupMembers" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamGroupMemberId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamGroupId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Members</td><td>The project team members for the project.</td></tr>
        <tr><td>Members.ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Members.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>Members.ContactId</td><td>The associated contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Members.PermissionSetId</td><td>The associated permission set's Newforma database ID.</td></tr>
        <tr><td>Members.NixUser</td><td>Does the project team member have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Members.Visibility</td><td>The visibility on NIX of the project team member to other team members.<p>Allowed values:<br />
              VisibilityExtendedProjectTeam = 1<br />
              VisibilityFellowCompanyMembers = 2<br />
              VisibilityNotVisible = 3<br />
              VisibilityExtendedProjectTeamNameAndEmailOnly = 4</p></td></tr>
        <tr><td>Members.AcceptedDisclaimer</td><td>Has the project team member accepted the Terms and Conditions on NIX for this project?</td></tr>
        <tr bgcolor="efefef"><td>Members.PrimaryContact</td><td>Is the project team member a primary contact on the project team?</td></tr>
        <tr bgcolor="efefef"><td>Groups</td><td>The project team groups for the project.</td></tr>
        <tr><td>Groups.ProjectTeamGroupId</td><td>The project team group's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Groups.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>Groups.GroupName</td><td>The project team group's name.</td></tr>
        <tr><td>GroupMembers</td><td>The project team group members for the project.</td></tr>
        <tr><td>GroupMembers.ProjectTeamGroupMemberId</td><td>The project team group member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>GroupMembers.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>GroupMembers.ProjectTeamGroupId</td><td>The associated project team group's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>GroupMembers.ProjectTeamMemberId</td><td>The associated project team member's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="GetProjectTeam3Request"><b>GetProjectTeam3Request</b></a> (Deprecated: use <a href="#GetProjectTeam4Request">GetProjectTeam4</a> instead.)<br />
      Get the project team for a project in the Newforma database.</p><p>
      It is an error to retrieve the project team for a project that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>GetProjectTeam3Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Members" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PermissionSetId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Visibility" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PrimaryContact" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Roles" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ActiveUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFields" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"Groups" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamGroupId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"GroupName" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"GroupMembers" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamGroupMemberId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamGroupId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Members</td><td>The project team members for the project.</td></tr>
        <tr><td>Members.ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Members.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>Members.ContactId</td><td>The associated contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Members.PermissionSetId</td><td>The associated permission set's Newforma database ID.</td></tr>
        <tr><td>Members.NixUser</td><td>Does the project team member have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Members.Visibility</td><td>The visibility on NIX of the project team member to other team members.<p>Allowed values:<br />
              VisibilityExtendedProjectTeam = 1<br />
              VisibilityFellowCompanyMembers = 2<br />
              VisibilityNotVisible = 3<br />
              VisibilityExtendedProjectTeamNameAndEmailOnly = 4</p></td></tr>
        <tr><td>Members.AcceptedDisclaimer</td><td>Has the project team member accepted the Terms and Conditions on NIX for this project?</td></tr>
        <tr bgcolor="efefef"><td>Members.PrimaryContact</td><td>Is the project team member a primary contact on the project team?</td></tr>
        <tr><td>Members.Roles</td><td>The project team member's roles.</td></tr>
        <tr bgcolor="efefef"><td>Members.ActiveUser</td><td>Is the project team member active on the project team?</td></tr>
        <tr><td>Members.CustomFields</td><td>The project team member's custom fields.</td></tr>
        <tr><td>Members.CustomFields.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>Members.CustomFields.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>Members.CustomFields.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>Members.CustomFields.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>Members.CustomFields.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>Members.CustomFields.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>Members.CustomFields.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>Members.CustomFields.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>Members.CustomFields.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>Members.CustomFields.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>Members.CustomFields.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>Members.CustomFields.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Members.CustomFields.ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Groups</td><td>The project team groups for the project.</td></tr>
        <tr><td>Groups.ProjectTeamGroupId</td><td>The project team group's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Groups.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>Groups.GroupName</td><td>The project team group's name.</td></tr>
        <tr><td>GroupMembers</td><td>The project team group members for the project.</td></tr>
        <tr><td>GroupMembers.ProjectTeamGroupMemberId</td><td>The project team group member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>GroupMembers.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>GroupMembers.ProjectTeamGroupId</td><td>The associated project team group's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>GroupMembers.ProjectTeamMemberId</td><td>The associated project team member's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="GetProjectTeam4Request"><b>GetProjectTeam4Request</b></a><br />
      Get the project team for a project in the Newforma database.</p><p>
      It is an error to retrieve the project team for a project that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>GetProjectTeam4Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Members" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PermissionSetId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Visibility" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PrimaryContact" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Roles" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ActiveUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFields" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CloudServicesUser" : <i>boolean</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"Groups" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamGroupId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"GroupName" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"GroupMembers" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamGroupMemberId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamGroupId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Members</td><td>The project team members for the project.</td></tr>
        <tr><td>Members.ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Members.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>Members.ContactId</td><td>The associated contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Members.PermissionSetId</td><td>The associated permission set's Newforma database ID.</td></tr>
        <tr><td>Members.NixUser</td><td>Does the project team member have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Members.Visibility</td><td>The visibility on NIX of the project team member to other team members.<p>Allowed values:<br />
              VisibilityExtendedProjectTeam = 1<br />
              VisibilityFellowCompanyMembers = 2<br />
              VisibilityNotVisible = 3<br />
              VisibilityExtendedProjectTeamNameAndEmailOnly = 4</p></td></tr>
        <tr><td>Members.AcceptedDisclaimer</td><td>Has the project team member accepted the Terms and Conditions on NIX for this project?</td></tr>
        <tr bgcolor="efefef"><td>Members.PrimaryContact</td><td>Is the project team member a primary contact on the project team?</td></tr>
        <tr><td>Members.Roles</td><td>The project team member's roles.</td></tr>
        <tr bgcolor="efefef"><td>Members.ActiveUser</td><td>Is the project team member active on the project team?</td></tr>
        <tr><td>Members.CustomFields</td><td>The project team member's custom fields.</td></tr>
        <tr><td>Members.CustomFields.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>Members.CustomFields.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>Members.CustomFields.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>Members.CustomFields.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>Members.CustomFields.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>Members.CustomFields.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>Members.CustomFields.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>Members.CustomFields.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>Members.CustomFields.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>Members.CustomFields.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>Members.CustomFields.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>Members.CustomFields.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Members.CustomFields.ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Members.CloudServicesUser</td><td>Does the project team member have Cloud Services access?</td></tr>
        <tr bgcolor="efefef"><td>Groups</td><td>The project team groups for the project.</td></tr>
        <tr><td>Groups.ProjectTeamGroupId</td><td>The project team group's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Groups.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>Groups.GroupName</td><td>The project team group's name.</td></tr>
        <tr><td>GroupMembers</td><td>The project team group members for the project.</td></tr>
        <tr><td>GroupMembers.ProjectTeamGroupMemberId</td><td>The project team group member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>GroupMembers.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>GroupMembers.ProjectTeamGroupId</td><td>The associated project team group's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>GroupMembers.ProjectTeamMemberId</td><td>The associated project team member's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="GetProjectsForIdsRequest"><b>GetProjectsForIdsRequest</b></a> (Deprecated: use <a href="#GetProjectsForIds2Request">GetProjectsForIds2</a> instead.)<br />
      Get projects for a set of Newforma database IDs.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectIds" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectIds</td><td>The Newforma database IDs to retrieve projects for.</td></tr>
      </tbody></table><p>
      <b>GetProjectsForIdsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Projects" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ClientOfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectManagerContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PrincipleInChargeContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"MainContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectCode" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Description" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Phase" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Latitude" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Longitude" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StatusType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StatusName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ConfidentialType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Server" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"GlobalAdminOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TeamEditableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemsDeletableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CalendarItemsEditableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RemindersEnabled" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CreationTime" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ShowOnNix" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ItemsToFileLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PreviousItemsToFileLabels" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StorageLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ClientProjectNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ClientCompanyId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Projects</td><td>The set of projects matching the requested Newforma database IDs.</td></tr>
        <tr><td>Projects.ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ClientOfficeLocationId</td><td>The client company office location's Newforma database ID.</td></tr>
        <tr><td>Projects.ProjectManagerContactId</td><td>The project manager contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.PrincipleInChargeContactId</td><td>The principle in charge contact's Newforma database ID.</td></tr>
        <tr><td>Projects.MainContactId</td><td>The client's main contact Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ProjectName</td><td>The project's name.</td></tr>
        <tr><td>Projects.Number</td><td>The project's number.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ProjectCode</td><td>The project's five-digit alpha-numeric email filing code.</td></tr>
        <tr><td>Projects.Description</td><td>The project's description.</td></tr>
        <tr bgcolor="efefef"><td>Projects.Culture</td><td>The project's culture used for determining currency information.</td></tr>
        <tr><td>Projects.Phase</td><td>The project's phase.</td></tr>
        <tr bgcolor="efefef"><td>Projects.StreetAddress</td><td>The project's street address.  The format of a street address is either five
            fields (address│city│state│zip│country) separated
            by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>Projects.Latitude</td><td>The project's latitute.</td></tr>
        <tr bgcolor="efefef"><td>Projects.Longitude</td><td>The project's longitude.</td></tr>
        <tr><td>Projects.StatusType</td><td>The project's status type.<p>Allowed values:<br />
              StatusTypeActive = 0<br />
              StatusTypeOpportunity = 1<br />
              StatusTypeArchive = 2<br />
              StatusTypeOffline = 3<br />
              StatusTypeRepinning = 4<br />
              StatusTypeUpgrading = 5<br />
              StatusTypeRestoring = 6</p></td></tr>
        <tr bgcolor="efefef"><td>Projects.StatusName</td><td>The project's status name.</td></tr>
        <tr><td>Projects.ConfidentialType</td><td>The project's confidential type determining which users are allowed to see the project.<p>Allowed values:<br />
              ConfidentialTypeNone = 0<br />
              ConfidentialTypeAdmin = 1<br />
              ConfidentialTypeProjectTeam = 2</p></td></tr>
        <tr bgcolor="efefef"><td>Projects.Server</td><td>The NPCS server that the project is pinned to.</td></tr>
        <tr><td>Projects.GlobalAdminOnly</td><td>Are global admins the only users allowed to edit the project settings?  If this value is false, project administrators may edit the project's settings as well.</td></tr>
        <tr bgcolor="efefef"><td>Projects.TeamEditableByAdminsOnly</td><td>Is the project team editable only by project administrators?</td></tr>
        <tr><td>Projects.ProjectItemsDeletableByAdminsOnly</td><td>Are project items deletable only by project administrators?</td></tr>
        <tr bgcolor="efefef"><td>Projects.CalendarItemsEditableByAdminsOnly</td><td>Are calendar items (phases, milestones, etc) editable only by project administrators?</td></tr>
        <tr><td>Projects.RemindersEnabled</td><td>Are email reminders enabled for this project?</td></tr>
        <tr bgcolor="efefef"><td>Projects.CreationTime</td><td>The time when the project was created.</td></tr>
        <tr><td>Projects.ShowOnNix</td><td>Is the project available on NIX?</td></tr>
        <tr bgcolor="efefef"><td>Projects.ItemsToFileLabel</td><td>The project's email filing label.</td></tr>
        <tr><td>Projects.PreviousItemsToFileLabels</td><td>Previous email filing labels used by the project.</td></tr>
        <tr bgcolor="efefef"><td>Projects.StorageLabel</td><td>The storage label indicating where the archive media resides for offline projects.</td></tr>
        <tr><td>Projects.ClientProjectNumber</td><td>The project's number used by the client.</td></tr>
        <tr bgcolor="efefef"><td>Projects.SourceDescriptor</td><td>The name of the original datasource that the project was imported from.</td></tr>
        <tr><td>Projects.SourcePrimaryKey</td><td>The project's primary key in its original datasource.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ClientCompanyId</td><td>The client company's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="GetProjectsForIds2Request"><b>GetProjectsForIds2Request</b></a> (Deprecated: use <a href="#GetProjectsForIds3Request">GetProjectsForIds3</a> instead.)<br />
      Get projects for a set of Newforma database IDs.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectIds" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectIds</td><td>The Newforma database IDs to retrieve projects for.</td></tr>
      </tbody></table><p>
      <b>GetProjectsForIds2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Projects" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ClientOfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectManagerContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PrincipleInChargeContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"MainContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectCode" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Description" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Phase" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Latitude" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Longitude" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StatusType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StatusName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ConfidentialType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Server" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"GlobalAdminOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TeamEditableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemsDeletableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CalendarItemsEditableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RemindersEnabled" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CreationTime" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ShowOnNix" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ItemsToFileLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PreviousItemsToFileLabels" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StorageLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ClientProjectNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyRoles" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RoleType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RoleLabel" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectAdminContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Projects</td><td>The set of projects matching the requested Newforma database IDs.</td></tr>
        <tr><td>Projects.ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ClientOfficeLocationId</td><td>The client company office location's Newforma database ID.</td></tr>
        <tr><td>Projects.ProjectManagerContactId</td><td>The project manager contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.PrincipleInChargeContactId</td><td>The principle in charge contact's Newforma database ID.</td></tr>
        <tr><td>Projects.MainContactId</td><td>The client's main contact Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ProjectName</td><td>The project's name.</td></tr>
        <tr><td>Projects.Number</td><td>The project's number.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ProjectCode</td><td>The project's five-digit alpha-numeric email filing code.</td></tr>
        <tr><td>Projects.Description</td><td>The project's description.</td></tr>
        <tr bgcolor="efefef"><td>Projects.Culture</td><td>The project's culture used for determining currency information.</td></tr>
        <tr><td>Projects.Phase</td><td>The project's phase.</td></tr>
        <tr bgcolor="efefef"><td>Projects.StreetAddress</td><td>The project's street address.  The format of a street address is either five
            fields (address│city│state│zip│country) separated
            by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>Projects.Latitude</td><td>The project's latitute.</td></tr>
        <tr bgcolor="efefef"><td>Projects.Longitude</td><td>The project's longitude.</td></tr>
        <tr><td>Projects.StatusType</td><td>The project's status type.<p>Allowed values:<br />
              StatusTypeActive = 0<br />
              StatusTypeOpportunity = 1<br />
              StatusTypeArchive = 2<br />
              StatusTypeOffline = 3<br />
              StatusTypeRepinning = 4<br />
              StatusTypeUpgrading = 5<br />
              StatusTypeRestoring = 6</p></td></tr>
        <tr bgcolor="efefef"><td>Projects.StatusName</td><td>The project's status name.</td></tr>
        <tr><td>Projects.ConfidentialType</td><td>The project's confidential type determining which users are allowed to see the project.<p>Allowed values:<br />
              ConfidentialTypeNone = 0<br />
              ConfidentialTypeAdmin = 1<br />
              ConfidentialTypeProjectTeam = 2</p></td></tr>
        <tr bgcolor="efefef"><td>Projects.Server</td><td>The NPCS server that the project is pinned to.</td></tr>
        <tr><td>Projects.GlobalAdminOnly</td><td>Are global admins the only users allowed to edit the project settings?  If this value is false, project administrators may edit the project's settings as well.</td></tr>
        <tr bgcolor="efefef"><td>Projects.TeamEditableByAdminsOnly</td><td>Is the project team editable only by project administrators?</td></tr>
        <tr><td>Projects.ProjectItemsDeletableByAdminsOnly</td><td>Are project items deletable only by project administrators?</td></tr>
        <tr bgcolor="efefef"><td>Projects.CalendarItemsEditableByAdminsOnly</td><td>Are calendar items (phases, milestones, etc) editable only by project administrators?</td></tr>
        <tr><td>Projects.RemindersEnabled</td><td>Are email reminders enabled for this project?</td></tr>
        <tr bgcolor="efefef"><td>Projects.CreationTime</td><td>The time when the project was created.</td></tr>
        <tr><td>Projects.ShowOnNix</td><td>Is the project available on NIX?</td></tr>
        <tr bgcolor="efefef"><td>Projects.ItemsToFileLabel</td><td>The project's email filing label.</td></tr>
        <tr><td>Projects.PreviousItemsToFileLabels</td><td>Previous email filing labels used by the project.</td></tr>
        <tr bgcolor="efefef"><td>Projects.StorageLabel</td><td>The storage label indicating where the archive media resides for offline projects.</td></tr>
        <tr><td>Projects.ClientProjectNumber</td><td>The project's number used by the client.</td></tr>
        <tr bgcolor="efefef"><td>Projects.SourceDescriptor</td><td>The name of the original datasource that the project was imported from.</td></tr>
        <tr><td>Projects.SourcePrimaryKey</td><td>The project's primary key in its original datasource.</td></tr>
        <tr bgcolor="efefef"><td>Projects.CompanyRoles</td><td>The companies and their roles associated with this project.</td></tr>
        <tr><td>Projects.CompanyRoles.CompanyId</td><td>The company's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.CompanyRoles.RoleType</td><td>The company's role type.<p>Allowed values:<br />
              RoleTypeLeadDesigner = 65<br />
              RoleTypeClient = 66<br />
              RoleTypeGeneralContractor = 67<br />
              RoleTypeContractor = 68<br />
              RoleTypeSubContractor = 69<br />
              RoleTypeConsultant = 70</p></td></tr>
        <tr><td>Projects.CompanyRoles.RoleLabel</td><td>The company's role label.</td></tr>
        <tr><td>Projects.ProjectAdminContactIds</td><td>The project admin contacts' Newforma database IDs.</td></tr>
      </tbody></table><p>
      <a name="GetProjectsForIds3Request"><b>GetProjectsForIds3Request</b></a><br />
      Get projects for a set of Newforma database IDs.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectIds" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectIds</td><td>The Newforma database IDs to retrieve projects for.</td></tr>
      </tbody></table><p>
      <b>GetProjectsForIds3Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Projects" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ClientOfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectManagerContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PrincipleInChargeContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"MainContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectCode" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Description" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Phase" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Latitude" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Longitude" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StatusType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StatusName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ConfidentialType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Server" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"GlobalAdminOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TeamEditableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemsDeletableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CalendarItemsEditableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RemindersEnabled" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CreationTime" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ShowOnNix" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ItemsToFileLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PreviousItemsToFileLabels" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StorageLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ClientProjectNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyRoles" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RoleType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RoleLabel" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectAdminContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFields" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Projects</td><td>The set of projects matching the requested Newforma database IDs.</td></tr>
        <tr><td>Projects.ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ClientOfficeLocationId</td><td>The client company office location's Newforma database ID.</td></tr>
        <tr><td>Projects.ProjectManagerContactId</td><td>The project manager contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.PrincipleInChargeContactId</td><td>The principle in charge contact's Newforma database ID.</td></tr>
        <tr><td>Projects.MainContactId</td><td>The client's main contact Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ProjectName</td><td>The project's name.</td></tr>
        <tr><td>Projects.Number</td><td>The project's number.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ProjectCode</td><td>The project's five-digit alpha-numeric email filing code.</td></tr>
        <tr><td>Projects.Description</td><td>The project's description.</td></tr>
        <tr bgcolor="efefef"><td>Projects.Culture</td><td>The project's culture used for determining currency information.</td></tr>
        <tr><td>Projects.Phase</td><td>The project's phase.</td></tr>
        <tr bgcolor="efefef"><td>Projects.StreetAddress</td><td>The project's street address.  The format of a street address is either five
            fields (address│city│state│zip│country) separated
            by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>Projects.Latitude</td><td>The project's latitute.</td></tr>
        <tr bgcolor="efefef"><td>Projects.Longitude</td><td>The project's longitude.</td></tr>
        <tr><td>Projects.StatusType</td><td>The project's status type.<p>Allowed values:<br />
              StatusTypeActive = 0<br />
              StatusTypeOpportunity = 1<br />
              StatusTypeArchive = 2<br />
              StatusTypeOffline = 3<br />
              StatusTypeRepinning = 4<br />
              StatusTypeUpgrading = 5<br />
              StatusTypeRestoring = 6</p></td></tr>
        <tr bgcolor="efefef"><td>Projects.StatusName</td><td>The project's status name.</td></tr>
        <tr><td>Projects.ConfidentialType</td><td>The project's confidential type determining which users are allowed to see the project.<p>Allowed values:<br />
              ConfidentialTypeNone = 0<br />
              ConfidentialTypeAdmin = 1<br />
              ConfidentialTypeProjectTeam = 2</p></td></tr>
        <tr bgcolor="efefef"><td>Projects.Server</td><td>The NPCS server that the project is pinned to.</td></tr>
        <tr><td>Projects.GlobalAdminOnly</td><td>Are global admins the only users allowed to edit the project settings?  If this value is false, project administrators may edit the project's settings as well.</td></tr>
        <tr bgcolor="efefef"><td>Projects.TeamEditableByAdminsOnly</td><td>Is the project team editable only by project administrators?</td></tr>
        <tr><td>Projects.ProjectItemsDeletableByAdminsOnly</td><td>Are project items deletable only by project administrators?</td></tr>
        <tr bgcolor="efefef"><td>Projects.CalendarItemsEditableByAdminsOnly</td><td>Are calendar items (phases, milestones, etc) editable only by project administrators?</td></tr>
        <tr><td>Projects.RemindersEnabled</td><td>Are email reminders enabled for this project?</td></tr>
        <tr bgcolor="efefef"><td>Projects.CreationTime</td><td>The time when the project was created.</td></tr>
        <tr><td>Projects.ShowOnNix</td><td>Is the project available on NIX?</td></tr>
        <tr bgcolor="efefef"><td>Projects.ItemsToFileLabel</td><td>The project's email filing label.</td></tr>
        <tr><td>Projects.PreviousItemsToFileLabels</td><td>Previous email filing labels used by the project.</td></tr>
        <tr bgcolor="efefef"><td>Projects.StorageLabel</td><td>The storage label indicating where the archive media resides for offline projects.</td></tr>
        <tr><td>Projects.ClientProjectNumber</td><td>The project's number used by the client.</td></tr>
        <tr bgcolor="efefef"><td>Projects.SourceDescriptor</td><td>The name of the original datasource that the project was imported from.</td></tr>
        <tr><td>Projects.SourcePrimaryKey</td><td>The project's primary key in its original datasource.</td></tr>
        <tr bgcolor="efefef"><td>Projects.CompanyRoles</td><td>The companies and their roles associated with this project.</td></tr>
        <tr><td>Projects.CompanyRoles.CompanyId</td><td>The company's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.CompanyRoles.RoleType</td><td>The company's role type.<p>Allowed values:<br />
              RoleTypeLeadDesigner = 65<br />
              RoleTypeClient = 66<br />
              RoleTypeGeneralContractor = 67<br />
              RoleTypeContractor = 68<br />
              RoleTypeSubContractor = 69<br />
              RoleTypeConsultant = 70</p></td></tr>
        <tr><td>Projects.CompanyRoles.RoleLabel</td><td>The company's role label.</td></tr>
        <tr><td>Projects.ProjectAdminContactIds</td><td>The project admin contacts' Newforma database IDs.</td></tr>
        <tr bgcolor="efefef"><td>Projects.CustomFields</td><td>The project's custom fields.</td></tr>
        <tr><td>Projects.CustomFields.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>Projects.CustomFields.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>Projects.CustomFields.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>Projects.CustomFields.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>Projects.CustomFields.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>Projects.CustomFields.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>Projects.CustomFields.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>Projects.CustomFields.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>Projects.CustomFields.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>Projects.CustomFields.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>Projects.CustomFields.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>Projects.CustomFields.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.CustomFields.ProjectId</td><td>The project's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="GetProjectsForNumbersRequest"><b>GetProjectsForNumbersRequest</b></a> (Deprecated: use <a href="#GetProjectsForNumbers2Request">GetProjectsForNumbers2</a> instead.)<br />
      Get projects for a set of project numbers.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Numbers" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Numbers</td><td>The project numbers to retrieve projects for.</td></tr>
      </tbody></table><p>
      <b>GetProjectsForNumbersResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Projects" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ClientOfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectManagerContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PrincipleInChargeContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"MainContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectCode" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Description" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Phase" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Latitude" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Longitude" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StatusType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StatusName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ConfidentialType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Server" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"GlobalAdminOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TeamEditableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemsDeletableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CalendarItemsEditableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RemindersEnabled" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CreationTime" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ShowOnNix" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ItemsToFileLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PreviousItemsToFileLabels" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StorageLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ClientProjectNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ClientCompanyId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Projects</td><td>The set of projects matching the requested project numbers.</td></tr>
        <tr><td>Projects.ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ClientOfficeLocationId</td><td>The client company office location's Newforma database ID.</td></tr>
        <tr><td>Projects.ProjectManagerContactId</td><td>The project manager contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.PrincipleInChargeContactId</td><td>The principle in charge contact's Newforma database ID.</td></tr>
        <tr><td>Projects.MainContactId</td><td>The client's main contact Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ProjectName</td><td>The project's name.</td></tr>
        <tr><td>Projects.Number</td><td>The project's number.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ProjectCode</td><td>The project's five-digit alpha-numeric email filing code.</td></tr>
        <tr><td>Projects.Description</td><td>The project's description.</td></tr>
        <tr bgcolor="efefef"><td>Projects.Culture</td><td>The project's culture used for determining currency information.</td></tr>
        <tr><td>Projects.Phase</td><td>The project's phase.</td></tr>
        <tr bgcolor="efefef"><td>Projects.StreetAddress</td><td>The project's street address.  The format of a street address is either five
            fields (address│city│state│zip│country) separated
            by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>Projects.Latitude</td><td>The project's latitute.</td></tr>
        <tr bgcolor="efefef"><td>Projects.Longitude</td><td>The project's longitude.</td></tr>
        <tr><td>Projects.StatusType</td><td>The project's status type.<p>Allowed values:<br />
              StatusTypeActive = 0<br />
              StatusTypeOpportunity = 1<br />
              StatusTypeArchive = 2<br />
              StatusTypeOffline = 3<br />
              StatusTypeRepinning = 4<br />
              StatusTypeUpgrading = 5<br />
              StatusTypeRestoring = 6</p></td></tr>
        <tr bgcolor="efefef"><td>Projects.StatusName</td><td>The project's status name.</td></tr>
        <tr><td>Projects.ConfidentialType</td><td>The project's confidential type determining which users are allowed to see the project.<p>Allowed values:<br />
              ConfidentialTypeNone = 0<br />
              ConfidentialTypeAdmin = 1<br />
              ConfidentialTypeProjectTeam = 2</p></td></tr>
        <tr bgcolor="efefef"><td>Projects.Server</td><td>The NPCS server that the project is pinned to.</td></tr>
        <tr><td>Projects.GlobalAdminOnly</td><td>Are global admins the only users allowed to edit the project settings?  If this value is false, project administrators may edit the project's settings as well.</td></tr>
        <tr bgcolor="efefef"><td>Projects.TeamEditableByAdminsOnly</td><td>Is the project team editable only by project administrators?</td></tr>
        <tr><td>Projects.ProjectItemsDeletableByAdminsOnly</td><td>Are project items deletable only by project administrators?</td></tr>
        <tr bgcolor="efefef"><td>Projects.CalendarItemsEditableByAdminsOnly</td><td>Are calendar items (phases, milestones, etc) editable only by project administrators?</td></tr>
        <tr><td>Projects.RemindersEnabled</td><td>Are email reminders enabled for this project?</td></tr>
        <tr bgcolor="efefef"><td>Projects.CreationTime</td><td>The time when the project was created.</td></tr>
        <tr><td>Projects.ShowOnNix</td><td>Is the project available on NIX?</td></tr>
        <tr bgcolor="efefef"><td>Projects.ItemsToFileLabel</td><td>The project's email filing label.</td></tr>
        <tr><td>Projects.PreviousItemsToFileLabels</td><td>Previous email filing labels used by the project.</td></tr>
        <tr bgcolor="efefef"><td>Projects.StorageLabel</td><td>The storage label indicating where the archive media resides for offline projects.</td></tr>
        <tr><td>Projects.ClientProjectNumber</td><td>The project's number used by the client.</td></tr>
        <tr bgcolor="efefef"><td>Projects.SourceDescriptor</td><td>The name of the original datasource that the project was imported from.</td></tr>
        <tr><td>Projects.SourcePrimaryKey</td><td>The project's primary key in its original datasource.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ClientCompanyId</td><td>The client company's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="GetProjectsForNumbers2Request"><b>GetProjectsForNumbers2Request</b></a> (Deprecated: use <a href="#GetProjectDescriptorsForNumbersRequest">GetProjectDescriptorsForNumbers</a> instead.)<br />
      Get projects for a set of project numbers.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Numbers" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Numbers</td><td>The project numbers to retrieve projects for.</td></tr>
      </tbody></table><p>
      <b>GetProjectsForNumbers2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Projects" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ClientOfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectManagerContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PrincipleInChargeContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"MainContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectCode" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Description" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Phase" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Latitude" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Longitude" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StatusType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StatusName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ConfidentialType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Server" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"GlobalAdminOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TeamEditableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemsDeletableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CalendarItemsEditableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RemindersEnabled" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CreationTime" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ShowOnNix" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ItemsToFileLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PreviousItemsToFileLabels" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StorageLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ClientProjectNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyRoles" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RoleType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RoleLabel" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectAdminContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Projects</td><td>The set of projects matching the requested project numbers.</td></tr>
        <tr><td>Projects.ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ClientOfficeLocationId</td><td>The client company office location's Newforma database ID.</td></tr>
        <tr><td>Projects.ProjectManagerContactId</td><td>The project manager contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.PrincipleInChargeContactId</td><td>The principle in charge contact's Newforma database ID.</td></tr>
        <tr><td>Projects.MainContactId</td><td>The client's main contact Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ProjectName</td><td>The project's name.</td></tr>
        <tr><td>Projects.Number</td><td>The project's number.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ProjectCode</td><td>The project's five-digit alpha-numeric email filing code.</td></tr>
        <tr><td>Projects.Description</td><td>The project's description.</td></tr>
        <tr bgcolor="efefef"><td>Projects.Culture</td><td>The project's culture used for determining currency information.</td></tr>
        <tr><td>Projects.Phase</td><td>The project's phase.</td></tr>
        <tr bgcolor="efefef"><td>Projects.StreetAddress</td><td>The project's street address.  The format of a street address is either five
            fields (address│city│state│zip│country) separated
            by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>Projects.Latitude</td><td>The project's latitute.</td></tr>
        <tr bgcolor="efefef"><td>Projects.Longitude</td><td>The project's longitude.</td></tr>
        <tr><td>Projects.StatusType</td><td>The project's status type.<p>Allowed values:<br />
              StatusTypeActive = 0<br />
              StatusTypeOpportunity = 1<br />
              StatusTypeArchive = 2<br />
              StatusTypeOffline = 3<br />
              StatusTypeRepinning = 4<br />
              StatusTypeUpgrading = 5<br />
              StatusTypeRestoring = 6</p></td></tr>
        <tr bgcolor="efefef"><td>Projects.StatusName</td><td>The project's status name.</td></tr>
        <tr><td>Projects.ConfidentialType</td><td>The project's confidential type determining which users are allowed to see the project.<p>Allowed values:<br />
              ConfidentialTypeNone = 0<br />
              ConfidentialTypeAdmin = 1<br />
              ConfidentialTypeProjectTeam = 2</p></td></tr>
        <tr bgcolor="efefef"><td>Projects.Server</td><td>The NPCS server that the project is pinned to.</td></tr>
        <tr><td>Projects.GlobalAdminOnly</td><td>Are global admins the only users allowed to edit the project settings?  If this value is false, project administrators may edit the project's settings as well.</td></tr>
        <tr bgcolor="efefef"><td>Projects.TeamEditableByAdminsOnly</td><td>Is the project team editable only by project administrators?</td></tr>
        <tr><td>Projects.ProjectItemsDeletableByAdminsOnly</td><td>Are project items deletable only by project administrators?</td></tr>
        <tr bgcolor="efefef"><td>Projects.CalendarItemsEditableByAdminsOnly</td><td>Are calendar items (phases, milestones, etc) editable only by project administrators?</td></tr>
        <tr><td>Projects.RemindersEnabled</td><td>Are email reminders enabled for this project?</td></tr>
        <tr bgcolor="efefef"><td>Projects.CreationTime</td><td>The time when the project was created.</td></tr>
        <tr><td>Projects.ShowOnNix</td><td>Is the project available on NIX?</td></tr>
        <tr bgcolor="efefef"><td>Projects.ItemsToFileLabel</td><td>The project's email filing label.</td></tr>
        <tr><td>Projects.PreviousItemsToFileLabels</td><td>Previous email filing labels used by the project.</td></tr>
        <tr bgcolor="efefef"><td>Projects.StorageLabel</td><td>The storage label indicating where the archive media resides for offline projects.</td></tr>
        <tr><td>Projects.ClientProjectNumber</td><td>The project's number used by the client.</td></tr>
        <tr bgcolor="efefef"><td>Projects.SourceDescriptor</td><td>The name of the original datasource that the project was imported from.</td></tr>
        <tr><td>Projects.SourcePrimaryKey</td><td>The project's primary key in its original datasource.</td></tr>
        <tr bgcolor="efefef"><td>Projects.CompanyRoles</td><td>The companies and their roles associated with this project.</td></tr>
        <tr><td>Projects.CompanyRoles.CompanyId</td><td>The company's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.CompanyRoles.RoleType</td><td>The company's role type.<p>Allowed values:<br />
              RoleTypeLeadDesigner = 65<br />
              RoleTypeClient = 66<br />
              RoleTypeGeneralContractor = 67<br />
              RoleTypeContractor = 68<br />
              RoleTypeSubContractor = 69<br />
              RoleTypeConsultant = 70</p></td></tr>
        <tr><td>Projects.CompanyRoles.RoleLabel</td><td>The company's role label.</td></tr>
        <tr><td>Projects.ProjectAdminContactIds</td><td>The project admin contacts' Newforma database IDs.</td></tr>
      </tbody></table><p>
      <a name="GetProjectsForSourceDescriptorsRequest"><b>GetProjectsForSourceDescriptorsRequest</b></a> (Deprecated: use <a href="#GetProjectsForSourceDescriptors2Request">GetProjectsForSourceDescriptors2</a> instead.)<br />
      Get projects for a set of source descriptors.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"SourceDescriptors" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptors</td><td>The source descriptors to retrieve projects for.</td></tr>
        <tr><td>SourceDescriptors.SourceDescriptor</td><td>The name of the original datasource that the item was imported from.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptors.SourcePrimaryKey</td><td>The item's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <b>GetProjectsForSourceDescriptorsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Projects" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ClientOfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectManagerContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PrincipleInChargeContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"MainContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectCode" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Description" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Phase" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Latitude" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Longitude" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StatusType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StatusName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ConfidentialType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Server" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"GlobalAdminOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TeamEditableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemsDeletableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CalendarItemsEditableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RemindersEnabled" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CreationTime" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ShowOnNix" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ItemsToFileLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PreviousItemsToFileLabels" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StorageLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ClientProjectNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ClientCompanyId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Projects</td><td>The set of projects matching the requested source descriptors.</td></tr>
        <tr><td>Projects.ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ClientOfficeLocationId</td><td>The client company office location's Newforma database ID.</td></tr>
        <tr><td>Projects.ProjectManagerContactId</td><td>The project manager contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.PrincipleInChargeContactId</td><td>The principle in charge contact's Newforma database ID.</td></tr>
        <tr><td>Projects.MainContactId</td><td>The client's main contact Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ProjectName</td><td>The project's name.</td></tr>
        <tr><td>Projects.Number</td><td>The project's number.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ProjectCode</td><td>The project's five-digit alpha-numeric email filing code.</td></tr>
        <tr><td>Projects.Description</td><td>The project's description.</td></tr>
        <tr bgcolor="efefef"><td>Projects.Culture</td><td>The project's culture used for determining currency information.</td></tr>
        <tr><td>Projects.Phase</td><td>The project's phase.</td></tr>
        <tr bgcolor="efefef"><td>Projects.StreetAddress</td><td>The project's street address.  The format of a street address is either five
            fields (address│city│state│zip│country) separated
            by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>Projects.Latitude</td><td>The project's latitute.</td></tr>
        <tr bgcolor="efefef"><td>Projects.Longitude</td><td>The project's longitude.</td></tr>
        <tr><td>Projects.StatusType</td><td>The project's status type.<p>Allowed values:<br />
              StatusTypeActive = 0<br />
              StatusTypeOpportunity = 1<br />
              StatusTypeArchive = 2<br />
              StatusTypeOffline = 3<br />
              StatusTypeRepinning = 4<br />
              StatusTypeUpgrading = 5<br />
              StatusTypeRestoring = 6</p></td></tr>
        <tr bgcolor="efefef"><td>Projects.StatusName</td><td>The project's status name.</td></tr>
        <tr><td>Projects.ConfidentialType</td><td>The project's confidential type determining which users are allowed to see the project.<p>Allowed values:<br />
              ConfidentialTypeNone = 0<br />
              ConfidentialTypeAdmin = 1<br />
              ConfidentialTypeProjectTeam = 2</p></td></tr>
        <tr bgcolor="efefef"><td>Projects.Server</td><td>The NPCS server that the project is pinned to.</td></tr>
        <tr><td>Projects.GlobalAdminOnly</td><td>Are global admins the only users allowed to edit the project settings?  If this value is false, project administrators may edit the project's settings as well.</td></tr>
        <tr bgcolor="efefef"><td>Projects.TeamEditableByAdminsOnly</td><td>Is the project team editable only by project administrators?</td></tr>
        <tr><td>Projects.ProjectItemsDeletableByAdminsOnly</td><td>Are project items deletable only by project administrators?</td></tr>
        <tr bgcolor="efefef"><td>Projects.CalendarItemsEditableByAdminsOnly</td><td>Are calendar items (phases, milestones, etc) editable only by project administrators?</td></tr>
        <tr><td>Projects.RemindersEnabled</td><td>Are email reminders enabled for this project?</td></tr>
        <tr bgcolor="efefef"><td>Projects.CreationTime</td><td>The time when the project was created.</td></tr>
        <tr><td>Projects.ShowOnNix</td><td>Is the project available on NIX?</td></tr>
        <tr bgcolor="efefef"><td>Projects.ItemsToFileLabel</td><td>The project's email filing label.</td></tr>
        <tr><td>Projects.PreviousItemsToFileLabels</td><td>Previous email filing labels used by the project.</td></tr>
        <tr bgcolor="efefef"><td>Projects.StorageLabel</td><td>The storage label indicating where the archive media resides for offline projects.</td></tr>
        <tr><td>Projects.ClientProjectNumber</td><td>The project's number used by the client.</td></tr>
        <tr bgcolor="efefef"><td>Projects.SourceDescriptor</td><td>The name of the original datasource that the project was imported from.</td></tr>
        <tr><td>Projects.SourcePrimaryKey</td><td>The project's primary key in its original datasource.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ClientCompanyId</td><td>The client company's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="GetProjectsForSourceDescriptors2Request"><b>GetProjectsForSourceDescriptors2Request</b></a> (Deprecated: use <a href="#GetProjectDescriptorsForSourceDescriptorsRequest">GetProjectDescriptorsForSourceDescriptors</a> instead.)<br />
      Get projects for a set of source descriptors.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"SourceDescriptors" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptors</td><td>The source descriptors to retrieve projects for.</td></tr>
        <tr><td>SourceDescriptors.SourceDescriptor</td><td>The name of the original datasource that the item was imported from.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptors.SourcePrimaryKey</td><td>The item's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <b>GetProjectsForSourceDescriptors2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Projects" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ClientOfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectManagerContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PrincipleInChargeContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"MainContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectCode" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Description" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Phase" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Latitude" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Longitude" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StatusType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StatusName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ConfidentialType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Server" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"GlobalAdminOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TeamEditableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemsDeletableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CalendarItemsEditableByAdminsOnly" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RemindersEnabled" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CreationTime" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ShowOnNix" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ItemsToFileLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PreviousItemsToFileLabels" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StorageLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ClientProjectNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyRoles" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RoleType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RoleLabel" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectAdminContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Projects</td><td>The set of projects matching the requested source descriptors.</td></tr>
        <tr><td>Projects.ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ClientOfficeLocationId</td><td>The client company office location's Newforma database ID.</td></tr>
        <tr><td>Projects.ProjectManagerContactId</td><td>The project manager contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.PrincipleInChargeContactId</td><td>The principle in charge contact's Newforma database ID.</td></tr>
        <tr><td>Projects.MainContactId</td><td>The client's main contact Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ProjectName</td><td>The project's name.</td></tr>
        <tr><td>Projects.Number</td><td>The project's number.</td></tr>
        <tr bgcolor="efefef"><td>Projects.ProjectCode</td><td>The project's five-digit alpha-numeric email filing code.</td></tr>
        <tr><td>Projects.Description</td><td>The project's description.</td></tr>
        <tr bgcolor="efefef"><td>Projects.Culture</td><td>The project's culture used for determining currency information.</td></tr>
        <tr><td>Projects.Phase</td><td>The project's phase.</td></tr>
        <tr bgcolor="efefef"><td>Projects.StreetAddress</td><td>The project's street address.  The format of a street address is either five
            fields (address│city│state│zip│country) separated
            by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>Projects.Latitude</td><td>The project's latitute.</td></tr>
        <tr bgcolor="efefef"><td>Projects.Longitude</td><td>The project's longitude.</td></tr>
        <tr><td>Projects.StatusType</td><td>The project's status type.<p>Allowed values:<br />
              StatusTypeActive = 0<br />
              StatusTypeOpportunity = 1<br />
              StatusTypeArchive = 2<br />
              StatusTypeOffline = 3<br />
              StatusTypeRepinning = 4<br />
              StatusTypeUpgrading = 5<br />
              StatusTypeRestoring = 6</p></td></tr>
        <tr bgcolor="efefef"><td>Projects.StatusName</td><td>The project's status name.</td></tr>
        <tr><td>Projects.ConfidentialType</td><td>The project's confidential type determining which users are allowed to see the project.<p>Allowed values:<br />
              ConfidentialTypeNone = 0<br />
              ConfidentialTypeAdmin = 1<br />
              ConfidentialTypeProjectTeam = 2</p></td></tr>
        <tr bgcolor="efefef"><td>Projects.Server</td><td>The NPCS server that the project is pinned to.</td></tr>
        <tr><td>Projects.GlobalAdminOnly</td><td>Are global admins the only users allowed to edit the project settings?  If this value is false, project administrators may edit the project's settings as well.</td></tr>
        <tr bgcolor="efefef"><td>Projects.TeamEditableByAdminsOnly</td><td>Is the project team editable only by project administrators?</td></tr>
        <tr><td>Projects.ProjectItemsDeletableByAdminsOnly</td><td>Are project items deletable only by project administrators?</td></tr>
        <tr bgcolor="efefef"><td>Projects.CalendarItemsEditableByAdminsOnly</td><td>Are calendar items (phases, milestones, etc) editable only by project administrators?</td></tr>
        <tr><td>Projects.RemindersEnabled</td><td>Are email reminders enabled for this project?</td></tr>
        <tr bgcolor="efefef"><td>Projects.CreationTime</td><td>The time when the project was created.</td></tr>
        <tr><td>Projects.ShowOnNix</td><td>Is the project available on NIX?</td></tr>
        <tr bgcolor="efefef"><td>Projects.ItemsToFileLabel</td><td>The project's email filing label.</td></tr>
        <tr><td>Projects.PreviousItemsToFileLabels</td><td>Previous email filing labels used by the project.</td></tr>
        <tr bgcolor="efefef"><td>Projects.StorageLabel</td><td>The storage label indicating where the archive media resides for offline projects.</td></tr>
        <tr><td>Projects.ClientProjectNumber</td><td>The project's number used by the client.</td></tr>
        <tr bgcolor="efefef"><td>Projects.SourceDescriptor</td><td>The name of the original datasource that the project was imported from.</td></tr>
        <tr><td>Projects.SourcePrimaryKey</td><td>The project's primary key in its original datasource.</td></tr>
        <tr bgcolor="efefef"><td>Projects.CompanyRoles</td><td>The companies and their roles associated with this project.</td></tr>
        <tr><td>Projects.CompanyRoles.CompanyId</td><td>The company's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Projects.CompanyRoles.RoleType</td><td>The company's role type.<p>Allowed values:<br />
              RoleTypeLeadDesigner = 65<br />
              RoleTypeClient = 66<br />
              RoleTypeGeneralContractor = 67<br />
              RoleTypeContractor = 68<br />
              RoleTypeSubContractor = 69<br />
              RoleTypeConsultant = 70</p></td></tr>
        <tr><td>Projects.CompanyRoles.RoleLabel</td><td>The company's role label.</td></tr>
        <tr><td>Projects.ProjectAdminContactIds</td><td>The project admin contacts' Newforma database IDs.</td></tr>
      </tbody></table><p>
      <a name="GetRecordDocumentSummaryRequest"><b>GetRecordDocumentSummaryRequest</b></a><br />
      Get Record Document summaries from a project matching a category filter.</p><p>
      It is an error to retrieve project items for a project that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"CategoryFilter" : <i>int</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>CategoryFilter</td><td>The category of project items to return.  To return all project items use the CategoryFilterAll filter.<p>Allowed values:<br />
              CategoryFilterAll = 1<br />
              CategoryFilterActive = 2<br />
              CategoryFilterInactive = 4<br />
              CategoryFilterActiveIssued = 8<br />
              CategoryFilterActiveNotIssued = 16<br />
              CategoryFilterInactiveIssued = 32<br />
              CategoryFilterInactiveNotIssued = 64</p></td></tr>
      </tbody></table><p>
      <b>GetRecordDocumentSummaryResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Summaries" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Name" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Summaries</td><td>The Record Document summaries matching the category filter.</td></tr>
        <tr><td>Summaries.ProjectItemId</td><td>The project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>Summaries.Name</td><td>The project item's name.</td></tr>
        <tr><td>Summaries.Number</td><td>The project item's number.</td></tr>
      </tbody></table><p>
      <a name="GetRecordDocumentsRequest"><b>GetRecordDocumentsRequest</b></a><br />
      Get Record Documents from a project for a set of project item IDs.</p><p>
      It is an error to retrieve project items for a project that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectItemIds" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>ProjectItemIds</td><td>The project items' Newforma database IDs.</td></tr>
      </tbody></table><p>
      <b>GetRecordDocumentsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"RecordDocuments" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Name" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Keywords" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SupportingDocuments" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EmailLog" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"OwnerContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"MembersContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Scale" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Size" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RevisionPrefix" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RevisionSuffix" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Disciplines" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Type" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StatusLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Purpose" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Description" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Revisions" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Name" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Keywords" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SupportingDocuments" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EmailLog" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RevisionDate" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FileLastSavedDate" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"State" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StateLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Description" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Path" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>RecordDocuments</td><td>The Record Documents matching the project item IDs.</td></tr>
        <tr><td>RecordDocuments.ProjectItemId</td><td>The project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Name</td><td>The project item's name.</td></tr>
        <tr><td>RecordDocuments.Number</td><td>The project item's number.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Keywords</td><td>The project item's keywords.</td></tr>
        <tr><td>RecordDocuments.SupportingDocuments</td><td>The project item's supporting documents as a collection of UNC paths.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.EmailLog</td><td>The project item's email log as a collection of UNC paths.</td></tr>
        <tr><td>RecordDocuments.OwnerContactId</td><td>The Newforma database ID of the contact that owns the Record Document.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.MembersContactIds</td><td>The Newforma database IDs of the contacts who are members on the Record Document.</td></tr>
        <tr><td>RecordDocuments.Scale</td><td>The Record Document's scale.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Size</td><td>The Record Document's size.</td></tr>
        <tr><td>RecordDocuments.RevisionPrefix</td><td>The Record Document's revision prefix.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.RevisionSuffix</td><td>The Record Document's revision suffix.</td></tr>
        <tr><td>RecordDocuments.Disciplines</td><td>The Record Document's semicolon-separated discipline list.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Type</td><td>The Record Document's type.</td></tr>
        <tr><td>RecordDocuments.Status</td><td>The Record Document's status.<p>Allowed values:<br />
              StatusActive = 1<br />
              StatusInactive = 2</p></td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.StatusLabel</td><td>The Record Document's status label.</td></tr>
        <tr><td>RecordDocuments.Purpose</td><td>The Record Document's purpose.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Description</td><td>The Record Document's description.</td></tr>
        <tr><td>RecordDocuments.Revisions</td><td>The Record Document's revisions.</td></tr>
        <tr><td>RecordDocuments.Revisions.ProjectItemId</td><td>The project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Revisions.Name</td><td>The project item's name.</td></tr>
        <tr><td>RecordDocuments.Revisions.Number</td><td>The project item's number.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Revisions.Keywords</td><td>The project item's keywords.</td></tr>
        <tr><td>RecordDocuments.Revisions.SupportingDocuments</td><td>The project item's supporting documents as a collection of UNC paths.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Revisions.EmailLog</td><td>The project item's email log as a collection of UNC paths.</td></tr>
        <tr><td>RecordDocuments.Revisions.RevisionDate</td><td>The date of the Record Document Revision.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Revisions.FileLastSavedDate</td><td>The last known date of when the revision file was saved.</td></tr>
        <tr><td>RecordDocuments.Revisions.State</td><td>The Record Document Revision's state.<p>Allowed values:<br />
              StateIssued = 1<br />
              StateNotIssued = 2</p></td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Revisions.StateLabel</td><td>The Record Document Revision's state label.</td></tr>
        <tr><td>RecordDocuments.Revisions.Description</td><td>The Record Document Revision's description.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Revisions.Path</td><td>The UNC path of the Record Document Revision's file.</td></tr>
      </tbody></table><p>
      <a name="GetRecordDocuments2Request"><b>GetRecordDocuments2Request</b></a><br />
      Get Record Documents from a project for a set of project item IDs.</p><p>
      It is an error to retrieve project items for a project that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectItemIds" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>ProjectItemIds</td><td>The project items' Newforma database IDs.</td></tr>
      </tbody></table><p>
      <b>GetRecordDocuments2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"RecordDocuments" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Name" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Keywords" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SupportingDocuments" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProviderId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"VersionNumber" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EmailLog" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProviderId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"OwnerContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"MembersContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Scale" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Size" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RevisionPrefix" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RevisionSuffix" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Disciplines" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Type" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StatusLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Purpose" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Description" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Revisions" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Name" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Keywords" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SupportingDocuments" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProviderId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"VersionNumber" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EmailLog" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProviderId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RevisionDate" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FileLastSavedDate" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"State" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StateLabel" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Description" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FileInfo" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProviderId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"VersionNumber" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>RecordDocuments</td><td>The Record Documents matching the project item IDs.</td></tr>
        <tr><td>RecordDocuments.ProjectItemId</td><td>The project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Name</td><td>The project item's name.</td></tr>
        <tr><td>RecordDocuments.Number</td><td>The project item's number.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Keywords</td><td>The project item's keywords.</td></tr>
        <tr><td>RecordDocuments.SupportingDocuments</td><td>--</td></tr>
        <tr><td>RecordDocuments.SupportingDocuments.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.SupportingDocuments.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr><td>RecordDocuments.SupportingDocuments.ProviderId</td><td>File's EDMS plugin's provider id</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.SupportingDocuments.VersionNumber</td><td>File's version number</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.EmailLog</td><td>--</td></tr>
        <tr><td>RecordDocuments.EmailLog.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.EmailLog.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr><td>RecordDocuments.EmailLog.ProviderId</td><td>File's EDMS plugin's provider id</td></tr>
        <tr><td>RecordDocuments.OwnerContactId</td><td>The Newforma database ID of the contact that owns the Record Document.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.MembersContactIds</td><td>The Newforma database IDs of the contacts who are members on the Record Document.</td></tr>
        <tr><td>RecordDocuments.Scale</td><td>The Record Document's scale.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Size</td><td>The Record Document's size.</td></tr>
        <tr><td>RecordDocuments.RevisionPrefix</td><td>The Record Document's revision prefix.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.RevisionSuffix</td><td>The Record Document's revision suffix.</td></tr>
        <tr><td>RecordDocuments.Disciplines</td><td>The Record Document's semicolon-separated discipline list.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Type</td><td>The Record Document's type.</td></tr>
        <tr><td>RecordDocuments.Status</td><td>The Record Document's status.<p>Allowed values:<br />
              StatusActive = 1<br />
              StatusInactive = 2</p></td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.StatusLabel</td><td>The Record Document's status label.</td></tr>
        <tr><td>RecordDocuments.Purpose</td><td>The Record Document's purpose.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Description</td><td>The Record Document's description.</td></tr>
        <tr><td>RecordDocuments.Revisions</td><td>The Record Document's revisions.</td></tr>
        <tr><td>RecordDocuments.Revisions.ProjectItemId</td><td>The project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Revisions.Name</td><td>The project item's name.</td></tr>
        <tr><td>RecordDocuments.Revisions.Number</td><td>The project item's number.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Revisions.Keywords</td><td>The project item's keywords.</td></tr>
        <tr><td>RecordDocuments.Revisions.SupportingDocuments</td><td>--</td></tr>
        <tr><td>RecordDocuments.Revisions.SupportingDocuments.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Revisions.SupportingDocuments.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr><td>RecordDocuments.Revisions.SupportingDocuments.ProviderId</td><td>File's EDMS plugin's provider id</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Revisions.SupportingDocuments.VersionNumber</td><td>File's version number</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Revisions.EmailLog</td><td>--</td></tr>
        <tr><td>RecordDocuments.Revisions.EmailLog.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Revisions.EmailLog.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr><td>RecordDocuments.Revisions.EmailLog.ProviderId</td><td>File's EDMS plugin's provider id</td></tr>
        <tr><td>RecordDocuments.Revisions.RevisionDate</td><td>The date of the Record Document Revision.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Revisions.FileLastSavedDate</td><td>The last known date of when the revision file was saved.</td></tr>
        <tr><td>RecordDocuments.Revisions.State</td><td>The Record Document Revision's state.<p>Allowed values:<br />
              StateIssued = 1<br />
              StateNotIssued = 2</p></td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Revisions.StateLabel</td><td>The Record Document Revision's state label.</td></tr>
        <tr><td>RecordDocuments.Revisions.Description</td><td>The Record Document Revision's description.</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Revisions.FileInfo</td><td>The info of the Record Document Revision's file.</td></tr>
        <tr><td>RecordDocuments.Revisions.FileInfo.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Revisions.FileInfo.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr><td>RecordDocuments.Revisions.FileInfo.ProviderId</td><td>File's EDMS plugin's provider id</td></tr>
        <tr bgcolor="efefef"><td>RecordDocuments.Revisions.FileInfo.VersionNumber</td><td>File's version number</td></tr>
      </tbody></table><p>
      <a name="GetServerSettingsRequest"><b>GetServerSettingsRequest</b></a><br />
      Get all server settings for the NIX server.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
      </tbody></table><p>
      <b>GetServerSettingsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"LogoURL" : <i>string</i>,<br />
        &nbsp;&nbsp;"TermsAndConditions" : <i>string</i>,<br />
        &nbsp;&nbsp;"ShowTermsAndConditions" : <i>int</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>LogoURL</td><td>The URL to the company's logo.</td></tr>
        <tr bgcolor="efefef"><td>TermsAndConditions</td><td>The HTML for the company's terms and conditions for using NIX.</td></tr>
        <tr><td>ShowTermsAndConditions</td><td>Indicator as to when terms and conditions need to be acccepted on NIX.<p>Allowed values:<br />
              ShowTermsAndConditionsFirstLogIn = 0<br />
              ShowTermsAndConditionsAccessingProject = 1<br />
              ShowTermsAndConditionsLoginOrDownloads = 2</p></td></tr>
      </tbody></table><p>
      <a name="GetSupportedVersionRequest"><b>GetSupportedVersionRequest</b></a><br />
      Query the server to determine which version of an interface a client needs to use to communicate with the server.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"InterfaceType" : <i>int</i>,<br />
        &nbsp;&nbsp;"ClientVersions" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>int</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>InterfaceType</td><td>The interface type being queried.<p>
              Allowed values:<br />
              InterfaceTypeNewformaAPI = 3</p></td></tr>
        <tr bgcolor="efefef"><td>ClientVersions</td><td>The set of supported client versions for that interface.<p>Allowed values:<br />
              Version80 = 800<br />
              Version90 = 900<br />
              Version91 = 910<br />
              Version92 = 920<br />
              Version100 = 1000<br />
              Version101 = 1010<br />
              Version102 = 1020<br />
              Version110 = 1100<br />
              Version111 = 1110<br />
              Version115 = 1150<br />
              Version116 = 1160<br />
              Version117 = 1170</p></td></tr>
      </tbody></table><p>
      <b>GetSupportedVersionResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"SupportedVersion" : <i>int</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>SupportedVersion</td><td>The highest value of the intersection of the supported client versions and the supported server versions or -1 if not supported.</td></tr>
      </tbody></table><p>
      <a name="GetTransmittalDetailRequest"><b>GetTransmittalDetailRequest</b></a><br />
      Get the detailed transmittal information for a project.</p><p>
      It is an error to retrieve transmittals for a project that does not exist.</p><p>
      It is an error to retrieve transmittals based upon a project item ID that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectItemIDs" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>ProjectItemIDs</td><td>The transmittals's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>GetTransmittalDetailResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Transmittals" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Name" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Keywords" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SupportingDocuments" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EmailLog" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CreatedByContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FromContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Company" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ToContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CCContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Received" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Size" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Via" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Purpose" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Type" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RelatedItems" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemType" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DescriptionOfContents" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Quantity" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Title" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Revision" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Date" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Scale" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Size" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Action" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Remarks" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AssociatedFiles" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProviderId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"VersionNumber" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Transmittals</td><td>The transmittals fetched from the request.</td></tr>
        <tr><td>Transmittals.ProjectItemId</td><td>The project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.Name</td><td>The project item's name.</td></tr>
        <tr><td>Transmittals.Number</td><td>The project item's number.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.Keywords</td><td>The project item's keywords.</td></tr>
        <tr><td>Transmittals.SupportingDocuments</td><td>The project item's supporting documents as a collection of UNC paths.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.EmailLog</td><td>The project item's email log as a collection of UNC paths.</td></tr>
        <tr><td>Transmittals.CreatedByContactId</td><td>The Newforma database ID of the contact that created the transmittal.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.FromContactId</td><td>The Newforma database ID of the contact that the transmittal was sent from.</td></tr>
        <tr><td>Transmittals.Company</td><td>The company to which the transmittal sender belongs.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.ToContactIds</td><td>The Newforma database ID of the contacts that the transmittal was sent to.</td></tr>
        <tr><td>Transmittals.CCContactIds</td><td>The Newforma database ID of the contact that were CC'd on the transmittal.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.Received</td><td>The date the transmittal was received.</td></tr>
        <tr><td>Transmittals.Size</td><td>The size of the transmittal.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.Via</td><td>The method through which the transmittal was transmitted.</td></tr>
        <tr><td>Transmittals.Purpose</td><td>The purpose for which the transmittal was transmitted.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.Type</td><td>The type of transmittal.</td></tr>
        <tr><td>Transmittals.RelatedItems</td><td>Project Items related to this transmittal.</td></tr>
        <tr><td>Transmittals.RelatedItems.ProjectItemId</td><td>The related project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.RelatedItems.ProjectItemType</td><td>The related project item's type.<p>Allowed values:<br />
              ProjectItemTypeDocumentSet = 1<br />
              ProjectItemTypeActionItem = 2<br />
              ProjectItemTypeCalendarItem = 8<br />
              ProjectItemTypeRecordDocument = 18</p></td></tr>
        <tr bgcolor="efefef"><td>Transmittals.DescriptionOfContents</td><td>The description of contents for this transmittal.</td></tr>
        <tr><td>Transmittals.DescriptionOfContents.Quantity</td><td>Quantity of this content document being transmitted.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.DescriptionOfContents.Title</td><td>Title of this content document being transmitted.</td></tr>
        <tr><td>Transmittals.DescriptionOfContents.Number</td><td>Number of this content document being transmitted.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.DescriptionOfContents.Revision</td><td>Revision of this content document being transmitted.</td></tr>
        <tr><td>Transmittals.DescriptionOfContents.Date</td><td>Date of this content document being transmitted.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.DescriptionOfContents.Scale</td><td>Scale of this content document being transmitted.</td></tr>
        <tr><td>Transmittals.DescriptionOfContents.Size</td><td>Size of this content document being transmitted.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.DescriptionOfContents.Action</td><td>Action for this content document being transmitted.</td></tr>
        <tr><td>Transmittals.DescriptionOfContents.Remarks</td><td>Remarks for this content document being transmitted.</td></tr>
        <tr><td>Transmittals.AssociatedFiles</td><td>The files associated with this transmittal.</td></tr>
        <tr><td>Transmittals.AssociatedFiles.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.AssociatedFiles.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr><td>Transmittals.AssociatedFiles.ProviderId</td><td>File's EDMS plugin's provider id</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.AssociatedFiles.VersionNumber</td><td>File's version number</td></tr>
      </tbody></table><p>
      <a name="GetTransmittalSummaryRequest"><b>GetTransmittalSummaryRequest</b></a><br />
      Get the transmittal summary information for a project.</p><p>
      It is an error to retrieve transmittals for a project that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"TransmittalType" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>TransmittalType</td><td>The type of transmittals to fetch. Use a null or empty string to fetch all transmittals.</td></tr>
      </tbody></table><p>
      <b>GetTransmittalSummaryResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Transmittals" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Name" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Number" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Keywords" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SupportingDocuments" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EmailLog" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CreatedByContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FromContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Company" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ToContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CCContactIds" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Received" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Size" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Via" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Purpose" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Type" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Transmittals</td><td>The transmittals fetched that match the criteria specified in the request (if any).</td></tr>
        <tr><td>Transmittals.ProjectItemId</td><td>The project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.Name</td><td>The project item's name.</td></tr>
        <tr><td>Transmittals.Number</td><td>The project item's number.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.Keywords</td><td>The project item's keywords.</td></tr>
        <tr><td>Transmittals.SupportingDocuments</td><td>The project item's supporting documents as a collection of UNC paths.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.EmailLog</td><td>The project item's email log as a collection of UNC paths.</td></tr>
        <tr><td>Transmittals.CreatedByContactId</td><td>The Newforma database ID of the contact that created the transmittal.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.FromContactId</td><td>The Newforma database ID of the contact that the transmittal was sent from.</td></tr>
        <tr><td>Transmittals.Company</td><td>The company to which the transmittal sender belongs.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.ToContactIds</td><td>The Newforma database ID of the contacts that the transmittal was sent to.</td></tr>
        <tr><td>Transmittals.CCContactIds</td><td>The Newforma database ID of the contact that were CC'd on the transmittal.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.Received</td><td>The date the transmittal was received.</td></tr>
        <tr><td>Transmittals.Size</td><td>The size of the transmittal.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.Via</td><td>The method through which the transmittal was transmitted.</td></tr>
        <tr><td>Transmittals.Purpose</td><td>The purpose for which the transmittal was transmitted.</td></tr>
        <tr bgcolor="efefef"><td>Transmittals.Type</td><td>The type of transmittal.</td></tr>
      </tbody></table><p>
      <a name="GetUsersForNamesRequest"><b>GetUsersForNamesRequest</b></a> (Deprecated: use <a href="#GetUsersForNames3Request">GetUsersForNames3</a> instead.)<br />
      Get users for a set of user names.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"UserNames" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>UserNames</td><td>The user names to retrieve users for.</td></tr>
      </tbody></table><p>
      <b>GetUsersForNamesResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Users" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"UserName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"HomeServer" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AdminUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectCreator" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CAUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProfessionalUser" : <i>boolean</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Users</td><td>The set of users matching the requested user names.</td></tr>
        <tr><td>Users.UserName</td><td>The user's user name and Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Users.ContactId</td><td>The user's associated contact's Newforma database ID.</td></tr>
        <tr><td>Users.HomeServer</td><td>The user's home NPCS server.</td></tr>
        <tr bgcolor="efefef"><td>Users.AdminUser</td><td>Is the user a Newform administrator?</td></tr>
        <tr><td>Users.ProjectCreator</td><td>Does the user have project creation privledges?  Administrators always have this privledge.</td></tr>
        <tr bgcolor="efefef"><td>Users.CAUser</td><td>Is the user a Contract Administrator?</td></tr>
        <tr><td>Users.ProfessionalUser</td><td>Is the user a Professional-licensed user?  Contact Administrators are always Professional-licensed users as well.</td></tr>
      </tbody></table><p>
      <a name="GetUsersForNames2Request"><b>GetUsersForNames2Request</b></a> (Deprecated: use <a href="#GetUsersForNames3Request">GetUsersForNames3</a> instead.)<br />
      Get users for a set of user names.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"UserNames" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>UserNames</td><td>The user names to retrieve users for.</td></tr>
      </tbody></table><p>
      <b>GetUsersForNames2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Users" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"UserName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"HomeServer" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AdminUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectCreator" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CAUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProfessionalUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContentAdmin" : <i>boolean</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Users</td><td>The set of users matching the requested user names.</td></tr>
        <tr><td>Users.UserName</td><td>The user's user name and Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Users.ContactId</td><td>The user's associated contact's Newforma database ID.</td></tr>
        <tr><td>Users.HomeServer</td><td>The user's home NPCS server.</td></tr>
        <tr bgcolor="efefef"><td>Users.AdminUser</td><td>Is the user a Newform administrator?</td></tr>
        <tr><td>Users.ProjectCreator</td><td>Does the user have project creation privledges?  Administrators always have this privledge.</td></tr>
        <tr bgcolor="efefef"><td>Users.CAUser</td><td>Is the user a Contract Administrator?</td></tr>
        <tr><td>Users.ProfessionalUser</td><td>Is the user a Professional-licensed user?  Contact Administrators are always Professional-licensed users as well.</td></tr>
        <tr bgcolor="efefef"><td>Users.ContentAdmin</td><td>Does the user have content administration privledges?  Administrators always have this privledge.</td></tr>
      </tbody></table><p>
      <a name="GetUsersForNames3Request"><b>GetUsersForNames3Request</b></a><br />
      Get users for a set of user names.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"UserNames" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>UserNames</td><td>The user names to retrieve users for.</td></tr>
      </tbody></table><p>
      <b>GetUsersForNames3Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Users" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"UserName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"HomeServer" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"AdminUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectCreator" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CAUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProfessionalUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContentAdmin" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FinancialManager" : <i>boolean</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Users</td><td>The set of users matching the requested user names.</td></tr>
        <tr><td>Users.UserName</td><td>The user's user name and Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Users.ContactId</td><td>The user's associated contact's Newforma database ID.</td></tr>
        <tr><td>Users.HomeServer</td><td>The user's home NPCS server.</td></tr>
        <tr bgcolor="efefef"><td>Users.AdminUser</td><td>Is the user a Newform administrator?</td></tr>
        <tr><td>Users.ProjectCreator</td><td>Does the user have project creation privledges?  Administrators always have this privledge.</td></tr>
        <tr bgcolor="efefef"><td>Users.CAUser</td><td>Is the user a Contract Administrator?</td></tr>
        <tr><td>Users.ProfessionalUser</td><td>Is the user a Professional-licensed user?  Contact Administrators are always Professional-licensed users as well.</td></tr>
        <tr bgcolor="efefef"><td>Users.ContentAdmin</td><td>Does the user have content administration privledges?  Administrators always have this privledge.</td></tr>
        <tr><td>Users.FinancialManager</td><td>Does the user have financial manager privileges?</td></tr>
      </tbody></table><p>
      <a name="GetWebLinksRequest"><b>GetWebLinksRequest</b></a><br />
      Retrieve all web links for a particular project item.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectItemId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma datababase ID.</td></tr>
        <tr><td>ProjectItemId</td><td>The project item's Newforma datababase ID.</td></tr>
      </tbody></table><p>
      <b>GetWebLinksResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"WebLinks" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"UrlName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Subject" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"SharedExternally" : <i>boolean</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>WebLinks</td><td>The web links associated with the project item.</td></tr>
        <tr><td>WebLinks.UrlName</td><td>The web link's URL.</td></tr>
        <tr bgcolor="efefef"><td>WebLinks.Subject</td><td>The web link's subject.</td></tr>
        <tr><td>WebLinks.SharedExternally</td><td>Is the web link shared externally on NIX?</td></tr>
      </tbody></table><p>
      <a name="LinkCompaniesRequest"><b>LinkCompaniesRequest</b></a><br />
      Link two company records together in the Newforma global database.  When company records are linked together, all references to the secondary company are merged together with the primary company.  The following fields are affected on the primary company:
    </p><ul>
      <li>The primary company fields (names, web address, phone numbers, etc.) are preserved.</li>
      <li>If the secondary company has a main contact but the primary does not, the primary company inherits the secondary's main contact.</li>
      <li>The primary company inherits all contacts from the secondary company.</li>
      <li>The primary company inherits all server assignments from the secondary company.</li>
      <li>The primary company inherits all company roles on projects from the secondary company.</li>
      <li>The primary company inherits all office locations from the secondary company unless the office location already exists by name within the primary company.  In that case:</li>
      <ul>
        <li>All contacts referencing the secondary office location will be redirected to the primary company's office location.</li>
        <li>All servers referencing the secondary office location will be redirected to the primary company's office location.</li>
        <li>All project sites referencing the secondary office location will be redirected to the primary company's office location.</li>
      </ul>
    </ul>
    <b>NOTE:</b> A host company cannot be linked to another company with a Newforma to Newforma (N2N) integration associated with it.  Only the primary company may have a N2N integration; attempting to link two companies with N2N integrations or a secondary company with a N2N integration is an error.
    <p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"PrimaryCompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;"SecondaryCompanyId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>PrimaryCompanyId</td><td>The primary company's Newforma database ID.</td></tr>
        <tr><td>SecondaryCompanyId</td><td>The secondary company's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>LinkCompaniesResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="LinkContactsRequest"><b>LinkContactsRequest</b></a><br />
      Link two contact records together in the Newforma global database.  When contact records are linked together, all references to the secondary contact are merged together with the primary contact.  The following fields are affected on the primary contact:
    </p><ul>
      <li>The primary contact fields (names, email address, phone numbers, company, and office location, etc.) are preserved.</li>
      <li>If the secondary contact has NIX access but the primary does not, the primary contact inherits the secondary's NIX settings.</li>
      <li>If the secondary contact has a user association and the primary does not, the primary contact inherits the secondary's user.</li>
      <li>The primary contact inherits all of the secondary contact's my projects.</li>
      <li>The primary contact will become a project team member on all of the secondary contact's project teams with the following settings:</li>
      <ul>
        <li>Project team member settings are be preserved at the highest level including primary contact, NIX access, accepted disclaimer, team visibility, and permission set.</li>
        <li>The primary contact becomes a group member on all project team groups the secondary contact was part of.</li>
        <li>The primary contact inherits all of the secondary contact's member/group subscriptions.</li>
        <li>All member subscriptions to the secondary contact are redirected to the primary contact.</li>
      </ul>
      <li>If the secondary contact has project admin/manager/principle in charge/main contact associations but the primary contact does not, the primary contact inerhits the secondary's values.</li>
    </ul>
    <p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"PrimaryContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;"SecondaryContactId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>PrimaryContactId</td><td>The primary contact's Newforma database ID.</td></tr>
        <tr><td>SecondaryContactId</td><td>The secondary contact's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>LinkContactsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="NIDGetMyProjectsRequest"><b>NIDGetMyProjectsRequest</b></a><br />
      Request to retrieve a list of projects that the given contact has access to on the info exchange server. This is a request from NID and should use the X-NID-Signature header for signed authentication. No need to pass in a UserToken.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ContactToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Limit" : <i>int</i>,<br />
        &nbsp;&nbsp;"IncludeOffline" : <i>boolean</i>,<br />
        &nbsp;&nbsp;"IncludeArchive" : <i>boolean</i>,<br />
        &nbsp;&nbsp;"IncludeReadOnly" : <i>boolean</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ContactToken</td><td>The contact token is a contact's Newforma database Id, a contact's email address, or a contact's user id in the form domain\username.</td></tr>
        <tr><td>Limit</td><td>An optional limit on the number of rows returned.</td></tr>
        <tr bgcolor="efefef"><td>IncludeOffline</td><td>Include offline projects. Default is false.</td></tr>
        <tr><td>IncludeArchive</td><td>Include archived projects. Default is false.</td></tr>
        <tr bgcolor="efefef"><td>IncludeReadOnly</td><td>Include read only projects. Default is false.</td></tr>
      </tbody></table><p>
      <b>NIDGetMyProjectsResponse</b><br />
      Response to retrieve a list of projects
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;"MyProjects" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"URL" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"LastModifiedTime" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>ContactId</td><td>The contact's Newforma database Id.</td></tr>
        <tr bgcolor="efefef"><td>MyProjects</td><td>a list of projects with extra information</td></tr>
        <tr><td>MyProjects.ProjectId</td><td>project guid</td></tr>
        <tr bgcolor="efefef"><td>MyProjects.ProjectName</td><td>project name</td></tr>
        <tr><td>MyProjects.URL</td><td>The URL to the project NIX.</td></tr>
        <tr bgcolor="efefef"><td>MyProjects.LastModifiedTime</td><td>The last modified date time for the project.</td></tr>
      </tbody></table><p>
      <a name="NIDGetUserForVEOAuthenticationRequest"><b>NIDGetUserForVEOAuthenticationRequest</b></a><br />
      Request to validate a user for VEO authentication. This is a request from NID and should use the X-NID-Signature header for signed authentication. No need to pass in a UserToken.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"HostUsername" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>HostUsername</td><td>The username NID knows the user as. Could be an email address or Windows login name</td></tr>
      </tbody></table><p>
      <b>NIDGetUserForVEOAuthenticationResponse</b><br />
      Response to validate a user for VEO authentication
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"HostUsername" : <i>string</i>,<br />
        &nbsp;&nbsp;"Success" : <i>boolean</i>,<br />
        &nbsp;&nbsp;"IsInternal" : <i>boolean</i>,<br />
        &nbsp;&nbsp;"IsGlobalAdmin" : <i>boolean</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>HostUsername</td><td>The username NID knows the user as. Could be an email address or Windows login name</td></tr>
        <tr bgcolor="efefef"><td>Success</td><td>Indicates if the user's authentication request succeeds.</td></tr>
        <tr><td>IsInternal</td><td>Indicates if the user is an internal user.</td></tr>
        <tr bgcolor="efefef"><td>IsGlobalAdmin</td><td>Indicates if the user is a global admin.</td></tr>
      </tbody></table><p>
      <a name="ReplicateWithServerRequest"><b>ReplicateWithServerRequest</b></a><br />
      Force an immediate database replication from NIX to a specific NPCS server.  This replication will cause all database updates performed via the Newforma API to appear on the NPCS.
      Without this request, the NIX will replicate to each of its associated NPCS servers asynchronously at an interval of approximately every three minutes.</p><p>
      It is an error to replicate with a NPCS that does not exist, or is not associated with the NIX server.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Server" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Server</td><td>The NPCS server to replicate with.</td></tr>
      </tbody></table><p>
      <b>ReplicateWithServerResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="SearchProjectFileContentsRequest"><b>SearchProjectFileContentsRequest</b></a><br />
      Perform a full-text search against a project's files.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"Properties" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PropertySet" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PropertyId" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PropertyName" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"ImpersonationToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Phrase" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>Properties</td><td>The set of properties requested for each search result.</td></tr>
        <tr><td>Properties.PropertySet</td><td>The ID of the property set.  For more information on property sets consult the Microsoft
            <a href="http://msdn.microsoft.com/en-us/library/ms691041(v=vs.85).aspx">Property Set</a> reference documentation.
            The allowed values below are supported by the Newforma Indexing Service.  Additional property sets may be supported
            only if third-party IFilters emit properties associated with other property sets.<p>Allowed values:<br />
              PSGUID_NEWFORMA = <code>"f8b22d19-beaa-48a5-b33c-61552945cc23"</code><br />
              PSGUID_STORAGE = <code>"b725f130-47ef-101a-a5f1-02608c9eebac"</code></p></td></tr>
        <tr bgcolor="efefef"><td>Properties.PropertyId</td><td>The ID of the property.  A property is identified with a property set GUID and either an ID
            or name, but not both.  Properties prefixed with <code>PID_STG</code> have the same meaning, and type as their
            definition in the Microsoft Indeing Service.  Properties prefixed with <code>PID_N4</code> are part of the extended
            Newforma property set.<p>Allowed values:<br />
              PID_N4_ENTRY_PATH = 5<br />
              PID_N4_IMG_APPLICATION_NAME = 14<br />
              PID_N4_IMG_AUTHOR = 15<br />
              PID_N4_IMG_CAMERA_MANUFACTURER = 16<br />
              PID_N4_IMG_CAMERA_MODEL = 17<br />
              PID_N4_IMG_COMMENT = 18<br />
              PID_N4_IMG_COPYRIGHT = 19<br />
              PID_N4_IMG_DATE_TAKEN = 20<br />
              PID_N4_IMG_FORMAT = 21<br />
              PID_N4_IMG_KEYWORDS = 22<br />
              PID_N4_IMG_LOCATION = 23<br />
              PID_N4_IMG_RATING = 24<br />
              PID_N4_IMG_SUBJECT = 25<br />
              PID_N4_IMG_TITLE = 26<br />
              PID_N4_IMG_PIXEL_DIMENSIONS = 27<br />
              PID_N4_IMG_BITS_PER_PIXEL = 28<br />
              PID_N4_EDMS_PLUGIN_CONFIG_ID = 29<br />
              PID_N4_EDMS_PROVIDER_ID = 30<br />
              PID_STG_DIRECTORY = 2<br />
              PID_STG_NAME = 10<br />
              PID_STG_PATH = 11<br />
              PID_STG_SIZE = 12<br />
              PID_STG_ATTRIBUTES = 13<br />
              PID_STG_WRITETIME = 14<br />
              PID_STG_CREATETIME = 15</p></td></tr>
        <tr><td>Properties.PropertyName</td><td>The name of the property.  A property is identified with a property set GUID and either an ID or
            name, but not both.</td></tr>
        <tr bgcolor="efefef"><td>ImpersonationToken</td><td>Optional user token to impersonate for verifying permissions of search results so that only
            items the user has folder read access to are returned.  The token must either be empty or in the form
            <code>domain\\username;password</code>.  In order for impersonation to be performed, three properties must be specified
            in thequery along with any other desired properties.  These properties are <code>PID_STG_PATH</code>,
            <code>PID_N4_EDMS_PLUGIN_CONFIG_ID</code>, and <code>PID_N4_EDMS_PROVIDER_ID</code>.</td></tr>
        <tr><td>Phrase</td><td>The search phrase which is a space-delimited set of search terms.  For advanced searching
            consult the Newforma Project Center documentation including the following topics:
            <ul>
              <li>"Exclude Words or Phrases from Search Results" for using quotation marks ("), plus (+), and minus (-) to search
                whole phrases, or require/exclude particular terms.
              </li><li>"Search for Text Using Wildcards" for using asterisks (*), and question marks (?) for wildcard searches.
              </li><li>"Search for Text Using Text Matching" for changing the search text match mode to require all/any terms, or to
                perform literal text matching.
              </li></ul></td></tr>
      </tbody></table><p>
      <b>SearchProjectFileContentsResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Results" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>any</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Results</td><td>The set of search results returned for the operation.  The top level array contains one
            element for each matching file.  The inner array contains the property results corresponding in the same order as the
            property values in the original request.  Null elements may occur within the inner array if a file does not contain the
            associated property value.</td></tr>
      </tbody></table><p>
      <a name="SearchProjectFileNamesRequest"><b>SearchProjectFileNamesRequest</b></a><br />
      Perform a search against a project's filenames.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"Properties" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PropertySet" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PropertyId" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PropertyName" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"ImpersonationToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Phrase" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>Properties</td><td>The set of properties requested for each search result.</td></tr>
        <tr><td>Properties.PropertySet</td><td>The ID of the property set.  For more information on property sets consult the Microsoft
            <a href="http://msdn.microsoft.com/en-us/library/ms691041(v=vs.85).aspx">Property Set</a> reference documentation.
            The allowed values below are supported by the Newforma Indexing Service.  Additional property sets may be supported
            only if third-party IFilters emit properties associated with other property sets.<p>Allowed values:<br />
              PSGUID_NEWFORMA = <code>"f8b22d19-beaa-48a5-b33c-61552945cc23"</code><br />
              PSGUID_STORAGE = <code>"b725f130-47ef-101a-a5f1-02608c9eebac"</code></p></td></tr>
        <tr bgcolor="efefef"><td>Properties.PropertyId</td><td>The ID of the property.  A property is identified with a property set GUID and either an ID
            or name, but not both.  Properties prefixed with <code>PID_STG</code> have the same meaning, and type as their
            definition in the Microsoft Indeing Service.  Properties prefixed with <code>PID_N4</code> are part of the extended
            Newforma property set.<p>Allowed values:<br />
              PID_N4_ENTRY_PATH = 5<br />
              PID_N4_IMG_APPLICATION_NAME = 14<br />
              PID_N4_IMG_AUTHOR = 15<br />
              PID_N4_IMG_CAMERA_MANUFACTURER = 16<br />
              PID_N4_IMG_CAMERA_MODEL = 17<br />
              PID_N4_IMG_COMMENT = 18<br />
              PID_N4_IMG_COPYRIGHT = 19<br />
              PID_N4_IMG_DATE_TAKEN = 20<br />
              PID_N4_IMG_FORMAT = 21<br />
              PID_N4_IMG_KEYWORDS = 22<br />
              PID_N4_IMG_LOCATION = 23<br />
              PID_N4_IMG_RATING = 24<br />
              PID_N4_IMG_SUBJECT = 25<br />
              PID_N4_IMG_TITLE = 26<br />
              PID_N4_IMG_PIXEL_DIMENSIONS = 27<br />
              PID_N4_IMG_BITS_PER_PIXEL = 28<br />
              PID_N4_EDMS_PLUGIN_CONFIG_ID = 29<br />
              PID_N4_EDMS_PROVIDER_ID = 30<br />
              PID_STG_DIRECTORY = 2<br />
              PID_STG_NAME = 10<br />
              PID_STG_PATH = 11<br />
              PID_STG_SIZE = 12<br />
              PID_STG_ATTRIBUTES = 13<br />
              PID_STG_WRITETIME = 14<br />
              PID_STG_CREATETIME = 15</p></td></tr>
        <tr><td>Properties.PropertyName</td><td>The name of the property.  A property is identified with a property set GUID and either an ID or
            name, but not both.</td></tr>
        <tr bgcolor="efefef"><td>ImpersonationToken</td><td>Optional user token to impersonate for verifying permissions of search results so that only
            items the user has folder read access to are returned.  The token must either be empty or in the form
            <code>domain\\username;password</code>.  In order for impersonation to be performed, three properties must be specified
            in thequery along with any other desired properties.  These properties are <code>PID_STG_PATH</code>,
            <code>PID_N4_EDMS_PLUGIN_CONFIG_ID</code>, and <code>PID_N4_EDMS_PROVIDER_ID</code>.</td></tr>
        <tr><td>Phrase</td><td>The search phrase which is a space-delimited set of search terms.  For advanced searching
            consult the Newforma Project Center documentation including the following topics:
            <ul>
              <li>"Exclude Words or Phrases from Search Results" for using quotation marks ("), plus (+), and minus (-) to search
                whole phrases, or require/exclude particular terms.
              </li><li>"Search for Text Using Wildcards" for using asterisks (*), and question marks (?) for wildcard searches.
              </li><li>"Search for Text Using Text Matching" for changing the search text match mode to require all/any terms, or to
                perform literal text matching.
              </li></ul></td></tr>
      </tbody></table><p>
      <b>SearchProjectFileNamesResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Results" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>any</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Results</td><td>The set of search results returned for the operation.  The top level array contains one
            element for each matching file.  The inner array contains the property results corresponding in the same order as the
            property values in the original request.  Null elements may occur within the inner array if a file does not contain the
            associated property value.</td></tr>
      </tbody></table><p>
      <a name="SearchProjectFilePropertiesRequest"><b>SearchProjectFilePropertiesRequest</b></a><br />
      Perform a full-text search against a project's files' extended properties.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"Properties" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PropertySet" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PropertyId" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"PropertyName" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;],<br />
        &nbsp;&nbsp;"ImpersonationToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Phrase" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>Properties</td><td>The set of properties requested for each search result.</td></tr>
        <tr><td>Properties.PropertySet</td><td>The ID of the property set.  For more information on property sets consult the Microsoft
            <a href="http://msdn.microsoft.com/en-us/library/ms691041(v=vs.85).aspx">Property Set</a> reference documentation.
            The allowed values below are supported by the Newforma Indexing Service.  Additional property sets may be supported
            only if third-party IFilters emit properties associated with other property sets.<p>Allowed values:<br />
              PSGUID_NEWFORMA = <code>"f8b22d19-beaa-48a5-b33c-61552945cc23"</code><br />
              PSGUID_STORAGE = <code>"b725f130-47ef-101a-a5f1-02608c9eebac"</code></p></td></tr>
        <tr bgcolor="efefef"><td>Properties.PropertyId</td><td>The ID of the property.  A property is identified with a property set GUID and either an ID
            or name, but not both.  Properties prefixed with <code>PID_STG</code> have the same meaning, and type as their
            definition in the Microsoft Indeing Service.  Properties prefixed with <code>PID_N4</code> are part of the extended
            Newforma property set.<p>Allowed values:<br />
              PID_N4_ENTRY_PATH = 5<br />
              PID_N4_IMG_APPLICATION_NAME = 14<br />
              PID_N4_IMG_AUTHOR = 15<br />
              PID_N4_IMG_CAMERA_MANUFACTURER = 16<br />
              PID_N4_IMG_CAMERA_MODEL = 17<br />
              PID_N4_IMG_COMMENT = 18<br />
              PID_N4_IMG_COPYRIGHT = 19<br />
              PID_N4_IMG_DATE_TAKEN = 20<br />
              PID_N4_IMG_FORMAT = 21<br />
              PID_N4_IMG_KEYWORDS = 22<br />
              PID_N4_IMG_LOCATION = 23<br />
              PID_N4_IMG_RATING = 24<br />
              PID_N4_IMG_SUBJECT = 25<br />
              PID_N4_IMG_TITLE = 26<br />
              PID_N4_IMG_PIXEL_DIMENSIONS = 27<br />
              PID_N4_IMG_BITS_PER_PIXEL = 28<br />
              PID_N4_EDMS_PLUGIN_CONFIG_ID = 29<br />
              PID_N4_EDMS_PROVIDER_ID = 30<br />
              PID_STG_DIRECTORY = 2<br />
              PID_STG_NAME = 10<br />
              PID_STG_PATH = 11<br />
              PID_STG_SIZE = 12<br />
              PID_STG_ATTRIBUTES = 13<br />
              PID_STG_WRITETIME = 14<br />
              PID_STG_CREATETIME = 15</p></td></tr>
        <tr><td>Properties.PropertyName</td><td>The name of the property.  A property is identified with a property set GUID and either an ID or
            name, but not both.</td></tr>
        <tr bgcolor="efefef"><td>ImpersonationToken</td><td>Optional user token to impersonate for verifying permissions of search results so that only
            items the user has folder read access to are returned.  The token must either be empty or in the form
            <code>domain\\username;password</code>.  In order for impersonation to be performed, three properties must be specified
            in thequery along with any other desired properties.  These properties are <code>PID_STG_PATH</code>,
            <code>PID_N4_EDMS_PLUGIN_CONFIG_ID</code>, and <code>PID_N4_EDMS_PROVIDER_ID</code>.</td></tr>
        <tr><td>Phrase</td><td>The search phrase which is a space-delimited set of search terms.  For advanced searching
            consult the Newforma Project Center documentation including the following topics:
            <ul>
              <li>"Exclude Words or Phrases from Search Results" for using quotation marks ("), plus (+), and minus (-) to search
                whole phrases, or require/exclude particular terms.
              </li><li>"Search for Text Using Wildcards" for using asterisks (*), and question marks (?) for wildcard searches.
              </li><li>"Search for Text Using Text Matching" for changing the search text match mode to require all/any terms, or to
                perform literal text matching.
              </li></ul></td></tr>
      </tbody></table><p>
      <b>SearchProjectFilePropertiesResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"Results" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>any</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>Results</td><td>The set of search results returned for the operation.  The top level array contains one
            element for each matching file.  The inner array contains the property results corresponding in the same order as the
            property values in the original request.  Null elements may occur within the inner array if a file does not contain the
            associated property value.</td></tr>
      </tbody></table><p>
      <a name="SendNixAccountNotificationRequest"><b>SendNixAccountNotificationRequest</b></a><br />
      Send a new account notification for NIX for a contact.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ContactId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ContactId</td><td>The contact's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>SendNixAccountNotificationResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="SendNixPasswordReminderRequest"><b>SendNixPasswordReminderRequest</b></a><br />
      Send a password notification for NIX for a contact.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ContactId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ContactId</td><td>The contact's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>SendNixPasswordReminderResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateCompanyRequest"><b>UpdateCompanyRequest</b></a> (Deprecated: use <a href="#UpdateCompany2Request">UpdateCompany2</a> instead.)<br />
      Update a company in the Newforma database.</p><p>
      It is an error to update a company that does not exist, or set the same company name as another company.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Company" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"MainContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DisciplineList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SpecSectionList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"WebUrl" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NoteText" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Company</td><td>The company to update.</td></tr>
        <tr><td>Company.CompanyId</td><td>The company's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Company.MainContactId</td><td>The contact's associated main contact's Newforma database ID.</td></tr>
        <tr><td>Company.CompanyName</td><td>The company's name.</td></tr>
        <tr bgcolor="efefef"><td>Company.DisciplineList</td><td>The company's discipline list.</td></tr>
        <tr><td>Company.SpecSectionList</td><td>The company's spec section list.</td></tr>
        <tr bgcolor="efefef"><td>Company.WebUrl</td><td>The company's website URL.</td></tr>
        <tr><td>Company.NoteText</td><td>The company's HTML note text.</td></tr>
        <tr bgcolor="efefef"><td>Company.SourceDescriptor</td><td>The name of the original datasource that the company was imported from.</td></tr>
        <tr><td>Company.SourcePrimaryKey</td><td>The company's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <b>UpdateCompanyResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateCompany2Request"><b>UpdateCompany2Request</b></a><br />
      Update a company in the Newforma database.</p><p>
      It is an error to update a company that does not exist, or set the same company name as another company.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Company" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"MainContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DisciplineList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SpecSectionList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"WebUrl" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NoteText" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Rating" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CustomFields" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Company</td><td>The company to update.</td></tr>
        <tr><td>Company.CompanyId</td><td>The company's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Company.MainContactId</td><td>The contact's associated main contact's Newforma database ID.</td></tr>
        <tr><td>Company.CompanyName</td><td>The company's name.</td></tr>
        <tr bgcolor="efefef"><td>Company.DisciplineList</td><td>The company's discipline list.</td></tr>
        <tr><td>Company.SpecSectionList</td><td>The company's spec section list.</td></tr>
        <tr bgcolor="efefef"><td>Company.WebUrl</td><td>The company's website URL.</td></tr>
        <tr><td>Company.NoteText</td><td>The company's HTML note text.</td></tr>
        <tr bgcolor="efefef"><td>Company.SourceDescriptor</td><td>The name of the original datasource that the company was imported from.</td></tr>
        <tr><td>Company.SourcePrimaryKey</td><td>The company's primary key in its original datasource.</td></tr>
        <tr bgcolor="efefef"><td>Company.Rating</td><td>The company's rating in the range 0 - 5.</td></tr>
        <tr><td>Company.CompanyType</td><td>The company's type.</td></tr>
        <tr bgcolor="efefef"><td>Company.CustomFields</td><td>The company's custom fields.</td></tr>
        <tr><td>Company.CustomFields.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>Company.CustomFields.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>Company.CustomFields.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>Company.CustomFields.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>Company.CustomFields.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>Company.CustomFields.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>Company.CustomFields.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>Company.CustomFields.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>Company.CustomFields.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>Company.CustomFields.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>Company.CustomFields.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>Company.CustomFields.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Company.CustomFields.CompanyId</td><td>The company's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>UpdateCompany2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateCompanyCommentRequest"><b>UpdateCompanyCommentRequest</b></a><br />
      Update a company comment in the Newforma database.</p><p>
      It is an error to update a comment that does not exist.  The only field that can be updated on a comment is Remarks.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"FieldValue" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CommentId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AuthorContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CommentTime" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Remarks" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue</td><td>The comment to update.</td></tr>
        <tr><td>FieldValue.CommentId</td><td>The comment's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.ProjectId</td><td>An optional associated project's Newforma database ID.</td></tr>
        <tr><td>FieldValue.AuthorContactId</td><td>The authoring contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CommentTime</td><td>The time when the comment was created/last changed.</td></tr>
        <tr><td>FieldValue.Remarks</td><td>The comment text.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CompanyId</td><td>The company's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>UpdateCompanyCommentResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateCompanyCustomFieldValueRequest"><b>UpdateCompanyCustomFieldValueRequest</b></a><br />
      Update a company custom field value in the Newforma database.  Updating a custom field value with its default value deletes the value.</p><p>
      The only fields that can be updated on a custom field are:
    </p><ul>
      <li>StringValue</li>
      <li>DateTimeValue</li>
      <li>TimeOfDayValue</li>
      <li>CurrencyValue</li>
      <li>NumberValue</li>
      <li>BooeanValue</li>
    </ul>
    It is an error to update a custom field value that does not exist, or set the custom field's value to an unsupported type for that field.
    <p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"FieldValue" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue</td><td>The custom field value to update.</td></tr>
        <tr><td>FieldValue.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>FieldValue.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>FieldValue.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>FieldValue.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CompanyId</td><td>The company's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>UpdateCompanyCustomFieldValueResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateContactRequest"><b>UpdateContactRequest</b></a> (Deprecated: use <a href="#UpdateContact3Request">UpdateContact3</a> instead.)<br />
      Update a contact in the Newforma database.</p><p>
      It is an error to update a contact that does not exist, or set the same email address as another contact.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Contact" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"OfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"EmailAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FirstName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"LastName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DepartmentName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"JobTitle" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DisciplineList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberWork" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberMobile" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberHome" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FaxNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NoteText" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ActiveUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AddressType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"UseOfficeAddress" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Contact</td><td>The contact to update.</td></tr>
        <tr><td>Contact.ContactId</td><td>The contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CompanyId</td><td>The contact's associated company's Newforma database ID.</td></tr>
        <tr><td>Contact.OfficeLocationId</td><td>The contact's associated office location's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contact.EmailAddress</td><td>The contact's email address.</td></tr>
        <tr><td>Contact.FirstName</td><td>The contact's first name.</td></tr>
        <tr bgcolor="efefef"><td>Contact.LastName</td><td>The contact's last name.</td></tr>
        <tr><td>Contact.DepartmentName</td><td>The contact's department name.</td></tr>
        <tr bgcolor="efefef"><td>Contact.JobTitle</td><td>The contact's job title.</td></tr>
        <tr><td>Contact.DisciplineList</td><td>The contact's discipline list.</td></tr>
        <tr bgcolor="efefef"><td>Contact.PhoneNumberWork</td><td>The contact's work phone number.</td></tr>
        <tr><td>Contact.PhoneNumberMobile</td><td>The contact's mobile phone number.</td></tr>
        <tr bgcolor="efefef"><td>Contact.PhoneNumberHome</td><td>The contact's home phone number.</td></tr>
        <tr><td>Contact.FaxNumber</td><td>The contact's fax number.</td></tr>
        <tr bgcolor="efefef"><td>Contact.StreetAddress</td><td>The contact's street address.  The format of a street address is either five
            fields (address│city│state│zip│country) separated
            by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>Contact.NoteText</td><td>The contact's HTML note text.</td></tr>
        <tr bgcolor="efefef"><td>Contact.ActiveUser</td><td>Is the contact an active Newforma user?</td></tr>
        <tr><td>Contact.NixUser</td><td>Does the contact have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Contact.AcceptedDisclaimer</td><td>Has the contact accepted the Terms and Conditions on NIX?</td></tr>
        <tr><td>Contact.AddressType</td><td>The contact's address type.</td></tr>
        <tr bgcolor="efefef"><td>Contact.UseOfficeAddress</td><td>Should the contact use their associated office location's address?</td></tr>
        <tr><td>Contact.SourceDescriptor</td><td>The name of the original datasource that the contact was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Contact.SourcePrimaryKey</td><td>The contact's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <b>UpdateContactResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateContact2Request"><b>UpdateContact2Request</b></a><br />
      Update a contact in the Newforma database.</p><p>
      It is an error to update a contact that does not exist, or set the same email address as another contact.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Contact" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"OfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"EmailAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FirstName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"LastName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DepartmentName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"JobTitle" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DisciplineList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberWork" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberMobile" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberHome" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FaxNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NoteText" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ActiveUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AddressType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"UseOfficeAddress" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Roles" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CustomFields" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Contact</td><td>The contact to update.</td></tr>
        <tr><td>Contact.ContactId</td><td>The contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CompanyId</td><td>The contact's associated company's Newforma database ID.</td></tr>
        <tr><td>Contact.OfficeLocationId</td><td>The contact's associated office location's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contact.EmailAddress</td><td>The contact's email address.</td></tr>
        <tr><td>Contact.FirstName</td><td>The contact's first name.</td></tr>
        <tr bgcolor="efefef"><td>Contact.LastName</td><td>The contact's last name.</td></tr>
        <tr><td>Contact.DepartmentName</td><td>The contact's department name.</td></tr>
        <tr bgcolor="efefef"><td>Contact.JobTitle</td><td>The contact's job title.</td></tr>
        <tr><td>Contact.DisciplineList</td><td>The contact's discipline list.</td></tr>
        <tr bgcolor="efefef"><td>Contact.PhoneNumberWork</td><td>The contact's work phone number.</td></tr>
        <tr><td>Contact.PhoneNumberMobile</td><td>The contact's mobile phone number.</td></tr>
        <tr bgcolor="efefef"><td>Contact.PhoneNumberHome</td><td>The contact's home phone number.</td></tr>
        <tr><td>Contact.FaxNumber</td><td>The contact's fax number.</td></tr>
        <tr bgcolor="efefef"><td>Contact.StreetAddress</td><td>The contact's street address.  The format of a street address is either five
            fields (address│city│state│zip│country) separated
            by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>Contact.NoteText</td><td>The contact's HTML note text.</td></tr>
        <tr bgcolor="efefef"><td>Contact.ActiveUser</td><td>Is the contact an active Newforma user?</td></tr>
        <tr><td>Contact.NixUser</td><td>Does the contact have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Contact.AcceptedDisclaimer</td><td>Has the contact accepted the Terms and Conditions on NIX?</td></tr>
        <tr><td>Contact.AddressType</td><td>The contact's address type.</td></tr>
        <tr bgcolor="efefef"><td>Contact.UseOfficeAddress</td><td>Should the contact use their associated office location's address?</td></tr>
        <tr><td>Contact.SourceDescriptor</td><td>The name of the original datasource that the contact was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Contact.SourcePrimaryKey</td><td>The contact's primary key in its original datasource.</td></tr>
        <tr><td>Contact.Roles</td><td>The contact's roles.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields</td><td>The contact's custom fields.</td></tr>
        <tr><td>Contact.CustomFields.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>Contact.CustomFields.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>Contact.CustomFields.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>Contact.CustomFields.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>Contact.CustomFields.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>Contact.CustomFields.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>Contact.CustomFields.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.ContactId</td><td>The contact's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>UpdateContact2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateContact3Request"><b>UpdateContact3Request</b></a><br />
      Update a contact in the Newforma database.</p><p>
      It is an error to update a contact that does not exist, or set the same email address as another contact.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Contact" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"OfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"EmailAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FirstName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"LastName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DepartmentName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"JobTitle" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DisciplineList" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberWork" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberMobile" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumberHome" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FaxNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NoteText" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ActiveUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AddressType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"UseOfficeAddress" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Roles" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CustomFields" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Contact</td><td>The contact to update.</td></tr>
        <tr><td>Contact.ContactId</td><td>The contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CompanyId</td><td>The contact's associated company's Newforma database ID.</td></tr>
        <tr><td>Contact.OfficeLocationId</td><td>The contact's associated office location's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contact.EmailAddress</td><td>The contact's email address.</td></tr>
        <tr><td>Contact.FirstName</td><td>The contact's first name.</td></tr>
        <tr bgcolor="efefef"><td>Contact.LastName</td><td>The contact's last name.</td></tr>
        <tr><td>Contact.DepartmentName</td><td>The contact's department name.</td></tr>
        <tr bgcolor="efefef"><td>Contact.JobTitle</td><td>The contact's job title.</td></tr>
        <tr><td>Contact.DisciplineList</td><td>The contact's discipline list.</td></tr>
        <tr bgcolor="efefef"><td>Contact.PhoneNumberWork</td><td>The contact's work phone number.</td></tr>
        <tr><td>Contact.PhoneNumberMobile</td><td>The contact's mobile phone number.</td></tr>
        <tr bgcolor="efefef"><td>Contact.PhoneNumberHome</td><td>The contact's home phone number.</td></tr>
        <tr><td>Contact.FaxNumber</td><td>The contact's fax number.</td></tr>
        <tr bgcolor="efefef"><td>Contact.StreetAddress</td><td>The contact's street address.  The format of a street address is either five
            fields (address│city│state│zip│country) separated
            by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>Contact.NoteText</td><td>The contact's HTML note text.</td></tr>
        <tr bgcolor="efefef"><td>Contact.ActiveUser</td><td>Is the contact an active Newforma user?</td></tr>
        <tr><td>Contact.NixUser</td><td>Does the contact have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Contact.AcceptedDisclaimer</td><td>Has the contact accepted the Terms and Conditions on NIX?</td></tr>
        <tr><td>Contact.AddressType</td><td>The contact's address type.</td></tr>
        <tr bgcolor="efefef"><td>Contact.UseOfficeAddress</td><td>Should the contact use their associated office location's address?</td></tr>
        <tr><td>Contact.SourceDescriptor</td><td>The name of the original datasource that the contact was imported from.</td></tr>
        <tr bgcolor="efefef"><td>Contact.SourcePrimaryKey</td><td>The contact's primary key in its original datasource.</td></tr>
        <tr><td>Contact.Roles</td><td>The contact's roles.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields</td><td>The contact's custom fields.</td></tr>
        <tr><td>Contact.CustomFields.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>Contact.CustomFields.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>Contact.CustomFields.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>Contact.CustomFields.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>Contact.CustomFields.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>Contact.CustomFields.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>Contact.CustomFields.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Contact.CustomFields.ContactId</td><td>The contact's Newforma database ID.</td></tr>
        <tr><td>Contact.Culture</td><td>The contact's culture for notifications without a project context.</td></tr>
      </tbody></table><p>
      <b>UpdateContact3Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateContactCommentRequest"><b>UpdateContactCommentRequest</b></a><br />
      Update a contact comment in the Newforma database.</p><p>
      It is an error to update a comment that does not exist.  The only field that can be updated on a comment is Remarks.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"FieldValue" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CommentId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AuthorContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CommentTime" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Remarks" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue</td><td>The comment to update.</td></tr>
        <tr><td>FieldValue.CommentId</td><td>The comment's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.ProjectId</td><td>An optional associated project's Newforma database ID.</td></tr>
        <tr><td>FieldValue.AuthorContactId</td><td>The authoring contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CommentTime</td><td>The time when the comment was created/last changed.</td></tr>
        <tr><td>FieldValue.Remarks</td><td>The comment text.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.ContactId</td><td>The contact's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>UpdateContactCommentResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateContactCustomFieldValueRequest"><b>UpdateContactCustomFieldValueRequest</b></a><br />
      Update a contact custom field value in the Newforma database.  Updating a custom field value with its default value deletes the value.</p><p>
      The only fields that can be updated on a custom field are:
    </p><ul>
      <li>StringValue</li>
      <li>DateTimeValue</li>
      <li>TimeOfDayValue</li>
      <li>CurrencyValue</li>
      <li>NumberValue</li>
      <li>BooeanValue</li>
    </ul>
    It is an error to update a custom field value that does not exist, or set the custom field's value to an unsupported type for that field.
    <p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"FieldValue" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue</td><td>The custom field value to update.</td></tr>
        <tr><td>FieldValue.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>FieldValue.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>FieldValue.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>FieldValue.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.ContactId</td><td>The contact's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>UpdateContactCustomFieldValueResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateKeywordsForProjectFilesRequest"><b>UpdateKeywordsForProjectFilesRequest</b></a><br />
      Update the keywords for project files.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"FileKeywords" : <br />
        &nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSObjectInfo" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"EDMSPluginConfigId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"FullPath" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProviderId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Keywords" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;]<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma database ID.</td></tr>
        <tr><td>FileKeywords</td><td>Collection of file / keyword pairs to update in the database.</td></tr>
        <tr><td>FileKeywords.EDMSObjectInfo</td><td>EDMS information referring to a specific project file.</td></tr>
        <tr><td>FileKeywords.EDMSObjectInfo.EDMSPluginConfigId</td><td>EDMS plugin configuration ID</td></tr>
        <tr bgcolor="efefef"><td>FileKeywords.EDMSObjectInfo.FullPath</td><td>Full path of the file/folder</td></tr>
        <tr><td>FileKeywords.EDMSObjectInfo.ProviderId</td><td>Provider-specific ID for files to differentiate non-unique filenames within the same container.</td></tr>
        <tr bgcolor="efefef"><td>FileKeywords.Keywords</td><td>The keywords to assign to a project file. Use a blank string to clear.</td></tr>
      </tbody></table><p>
      <b>UpdateKeywordsForProjectFilesResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateMyProjectRequest"><b>UpdateMyProjectRequest</b></a><br />
      Update a my-project in the Newforma database.  The only field that can be updated on a my-project is the DisplayOrder.</p><p>
      It is an error to update a my-project that does not exist.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"MyProject" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"MyProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DisplayOrder" : <i>int</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>MyProject</td><td>The my-project to update.</td></tr>
        <tr><td>MyProject.MyProjectId</td><td>The my-project's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>MyProject.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>MyProject.ContactId</td><td>The associated contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>MyProject.DisplayOrder</td><td>The my-project's display order within UIs.</td></tr>
      </tbody></table><p>
      <b>UpdateMyProjectResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateOfficeLocationRequest"><b>UpdateOfficeLocationRequest</b></a> (Deprecated: use <a href="#UpdateOfficeLocation2Request">UpdateOfficeLocation2</a> instead.)<br />
      Update an office location in the Newforma database.  All fields on an office location can be updated except the CompanyId.</p><p>
      It is an error to update an office location that does not exist, or set the same location name as another office location in the same company.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"OfficeLocation" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"OfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"LocationName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FaxNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AddressType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation</td><td>The office location to update.</td></tr>
        <tr><td>OfficeLocation.OfficeLocationId</td><td>The office location's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation.CompanyId</td><td>The office location's associated company's Newforma database ID.</td></tr>
        <tr><td>OfficeLocation.LocationName</td><td>The office location's name.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation.StreetAddress</td><td>The office location's street address.  The format of a street address is either
            five fields (address│city│state│zip│country)
            separated by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>OfficeLocation.PhoneNumber</td><td>The office location's primary phone number.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation.FaxNumber</td><td>The office location's primary fax number.</td></tr>
        <tr><td>OfficeLocation.AddressType</td><td>The office location's address type.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation.SourceDescriptor</td><td>The name of the original datasource that the office location was imported from.</td></tr>
        <tr><td>OfficeLocation.SourcePrimaryKey</td><td>The office location's primary key in its original datasource.</td></tr>
      </tbody></table><p>
      <b>UpdateOfficeLocationResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateOfficeLocation2Request"><b>UpdateOfficeLocation2Request</b></a><br />
      Update an office location in the Newforma database.  All fields on an office location can be updated except the CompanyId.</p><p>
      It is an error to update an office location that does not exist, or set the same location name as another office location in the same company.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"OfficeLocation" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"OfficeLocationId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CompanyId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"LocationName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"StreetAddress" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PhoneNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FaxNumber" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AddressType" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptor" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourcePrimaryKey" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PrimaryLocation" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation</td><td>The office location to update.</td></tr>
        <tr><td>OfficeLocation.OfficeLocationId</td><td>The office location's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation.CompanyId</td><td>The office location's associated company's Newforma database ID.</td></tr>
        <tr><td>OfficeLocation.LocationName</td><td>The office location's name.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation.StreetAddress</td><td>The office location's street address.  The format of a street address is either
            five fields (address│city│state│zip│country)
            separated by Unicode character <a href="http://www.unicode.org/charts/PDF/U2500.pdf">U+2502</a>
            or a single multi-line string.</td></tr>
        <tr><td>OfficeLocation.PhoneNumber</td><td>The office location's primary phone number.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation.FaxNumber</td><td>The office location's primary fax number.</td></tr>
        <tr><td>OfficeLocation.AddressType</td><td>The office location's address type.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation.SourceDescriptor</td><td>The name of the original datasource that the office location was imported from.</td></tr>
        <tr><td>OfficeLocation.SourcePrimaryKey</td><td>The office location's primary key in its original datasource.</td></tr>
        <tr bgcolor="efefef"><td>OfficeLocation.PrimaryLocation</td><td>Is this office location the company's primary location?</td></tr>
      </tbody></table><p>
      <b>UpdateOfficeLocation2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateProjectCustomFieldValueRequest"><b>UpdateProjectCustomFieldValueRequest</b></a><br />
      Update a project custom field value in the Newforma database.  Updating a custom field value with its default value deletes the value.</p><p>
      The only fields that can be updated on a custom field are:
    </p><ul>
      <li>StringValue</li>
      <li>DateTimeValue</li>
      <li>TimeOfDayValue</li>
      <li>CurrencyValue</li>
      <li>NumberValue</li>
      <li>BooeanValue</li>
    </ul>
    It is an error to update a custom field value that does not exist, or set the custom field's value to an unsupported type for that field.
    <p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"FieldValue" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue</td><td>The custom field value to update.</td></tr>
        <tr><td>FieldValue.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>FieldValue.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>FieldValue.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>FieldValue.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.ProjectId</td><td>The project's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>UpdateProjectCustomFieldValueResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateProjectTeamGroupRequest"><b>UpdateProjectTeamGroupRequest</b></a><br />
      Update a project team group in the Newforma database.  The only field that can be updated on a project team group is the GroupName.</p><p>
      It is an error to update a project team group that does not exist, or set the same group name as another project team group in the project.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Group" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamGroupId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"GroupName" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Group</td><td>The project team group to update.</td></tr>
        <tr><td>Group.ProjectTeamGroupId</td><td>The project team group's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Group.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>Group.GroupName</td><td>The project team group's name.</td></tr>
      </tbody></table><p>
      <b>UpdateProjectTeamGroupResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectTeamGroupId" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
        <tr><td>ProjectTeamGroupId</td><td>The project team group's Newforma database ID.</td></tr>
      </tbody></table><p>
      <a name="UpdateProjectTeamMemberRequest"><b>UpdateProjectTeamMemberRequest</b></a> (Deprecated: use <a href="#UpdateProjectTeamMember3Request">UpdateProjectTeamMember3</a> instead.)<br />
      Update a project team member in the Newforma database.  The only fields that can be updated on a project team member are:
    </p><ul>
      <li>PermissionSetId</li>
      <li>NixUser</li>
      <li>Visibility</li>
      <li>AcceptedDisclaimer</li>
    </ul>
    It is an error to update a project team member that does not exist.
    <p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Member" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PermissionSetId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Visibility" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Member</td><td>The project team member to update.</td></tr>
        <tr><td>Member.ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>Member.ContactId</td><td>The associated contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.PermissionSetId</td><td>The associated permission set's Newforma database ID.</td></tr>
        <tr><td>Member.NixUser</td><td>Does the project team member have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Member.Visibility</td><td>The visibility on NIX of the project team member to other team members.<p>Allowed values:<br />
              VisibilityExtendedProjectTeam = 1<br />
              VisibilityFellowCompanyMembers = 2<br />
              VisibilityNotVisible = 3<br />
              VisibilityExtendedProjectTeamNameAndEmailOnly = 4</p></td></tr>
        <tr><td>Member.AcceptedDisclaimer</td><td>Has the project team member accepted the Terms and Conditions on NIX for this project?</td></tr>
      </tbody></table><p>
      <b>UpdateProjectTeamMemberResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateProjectTeamMember2Request"><b>UpdateProjectTeamMember2Request</b></a> (Deprecated: use <a href="#UpdateProjectTeamMember3Request">UpdateProjectTeamMember3</a> instead.)<br />
      Update a project team member in the Newforma database.  The only fields that can be updated on a project team member are:
    </p><ul>
      <li>PermissionSetId</li>
      <li>NixUser</li>
      <li>Visibility</li>
      <li>AcceptedDisclaimer</li>
      <li>PrimaryContact</li>
    </ul>
    It is an error to update a project team member that does not exist.
    <p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Member" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PermissionSetId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Visibility" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PrimaryContact" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Member</td><td>The project team member to update.</td></tr>
        <tr><td>Member.ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>Member.ContactId</td><td>The associated contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.PermissionSetId</td><td>The associated permission set's Newforma database ID.</td></tr>
        <tr><td>Member.NixUser</td><td>Does the project team member have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Member.Visibility</td><td>The visibility on NIX of the project team member to other team members.<p>Allowed values:<br />
              VisibilityExtendedProjectTeam = 1<br />
              VisibilityFellowCompanyMembers = 2<br />
              VisibilityNotVisible = 3<br />
              VisibilityExtendedProjectTeamNameAndEmailOnly = 4</p></td></tr>
        <tr><td>Member.AcceptedDisclaimer</td><td>Has the project team member accepted the Terms and Conditions on NIX for this project?</td></tr>
        <tr bgcolor="efefef"><td>Member.PrimaryContact</td><td>Is the project team member a primary contact on the project team?</td></tr>
      </tbody></table><p>
      <b>UpdateProjectTeamMember2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateProjectTeamMember3Request"><b>UpdateProjectTeamMember3Request</b></a> (Deprecated: use <a href="#UpdateProjectTeamMember4Request">UpdateProjectTeamMember4</a> instead.)<br />
      Update a project team member in the Newforma database.  The only fields that can be updated on a project team member are:
    </p><ul>
      <li>PermissionSetId</li>
      <li>NixUser</li>
      <li>Visibility</li>
      <li>AcceptedDisclaimer</li>
      <li>PrimaryContact</li>
      <li>Roles</li>
      <li>ActiveUser</li>
    </ul>
    It is an error to update a project team member that does not exist.
    <p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Member" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PermissionSetId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Visibility" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PrimaryContact" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Roles" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ActiveUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CustomFields" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;]<br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Member</td><td>The project team member to update.</td></tr>
        <tr><td>Member.ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>Member.ContactId</td><td>The associated contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.PermissionSetId</td><td>The associated permission set's Newforma database ID.</td></tr>
        <tr><td>Member.NixUser</td><td>Does the project team member have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Member.Visibility</td><td>The visibility on NIX of the project team member to other team members.<p>Allowed values:<br />
              VisibilityExtendedProjectTeam = 1<br />
              VisibilityFellowCompanyMembers = 2<br />
              VisibilityNotVisible = 3<br />
              VisibilityExtendedProjectTeamNameAndEmailOnly = 4</p></td></tr>
        <tr><td>Member.AcceptedDisclaimer</td><td>Has the project team member accepted the Terms and Conditions on NIX for this project?</td></tr>
        <tr bgcolor="efefef"><td>Member.PrimaryContact</td><td>Is the project team member a primary contact on the project team?</td></tr>
        <tr><td>Member.Roles</td><td>The project team member's roles.</td></tr>
        <tr bgcolor="efefef"><td>Member.ActiveUser</td><td>Is the project team member active on the project team?</td></tr>
        <tr><td>Member.CustomFields</td><td>The project team member's custom fields.</td></tr>
        <tr><td>Member.CustomFields.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>Member.CustomFields.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>Member.CustomFields.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>Member.CustomFields.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>Member.CustomFields.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>Member.CustomFields.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>Member.CustomFields.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>UpdateProjectTeamMember3Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateProjectTeamMember4Request"><b>UpdateProjectTeamMember4Request</b></a><br />
      Update a project team member in the Newforma database.  The only fields that can be updated on a project team member are:
    </p><ul>
      <li>PermissionSetId</li>
      <li>NixUser</li>
      <li>Visibility</li>
      <li>AcceptedDisclaimer</li>
      <li>PrimaryContact</li>
      <li>Roles</li>
      <li>ActiveUser</li>
      <li>CloudServicesUser</li>
    </ul>
    It is an error to update a project team member that does not exist.
    <p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"Member" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PermissionSetId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NixUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Visibility" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AcceptedDisclaimer" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"PrimaryContact" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Roles" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ActiveUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CustomFields" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;[<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'}'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;],<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CloudServicesUser" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>Member</td><td>The project team member to update.</td></tr>
        <tr><td>Member.ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.ProjectId</td><td>The associated project's Newforma database ID.</td></tr>
        <tr><td>Member.ContactId</td><td>The associated contact's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.PermissionSetId</td><td>The associated permission set's Newforma database ID.</td></tr>
        <tr><td>Member.NixUser</td><td>Does the project team member have NIX access?</td></tr>
        <tr bgcolor="efefef"><td>Member.Visibility</td><td>The visibility on NIX of the project team member to other team members.<p>Allowed values:<br />
              VisibilityExtendedProjectTeam = 1<br />
              VisibilityFellowCompanyMembers = 2<br />
              VisibilityNotVisible = 3<br />
              VisibilityExtendedProjectTeamNameAndEmailOnly = 4</p></td></tr>
        <tr><td>Member.AcceptedDisclaimer</td><td>Has the project team member accepted the Terms and Conditions on NIX for this project?</td></tr>
        <tr bgcolor="efefef"><td>Member.PrimaryContact</td><td>Is the project team member a primary contact on the project team?</td></tr>
        <tr><td>Member.Roles</td><td>The project team member's roles.</td></tr>
        <tr bgcolor="efefef"><td>Member.ActiveUser</td><td>Is the project team member active on the project team?</td></tr>
        <tr><td>Member.CustomFields</td><td>The project team member's custom fields.</td></tr>
        <tr><td>Member.CustomFields.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>Member.CustomFields.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>Member.CustomFields.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>Member.CustomFields.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>Member.CustomFields.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>Member.CustomFields.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>Member.CustomFields.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.CustomFields.ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>Member.CloudServicesUser</td><td>Does the project team member have Cloud Services access?</td></tr>
      </tbody></table><p>
      <b>UpdateProjectTeamMember4Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateProjectTeamMemberCustomFieldValueRequest"><b>UpdateProjectTeamMemberCustomFieldValueRequest</b></a><br />
      Update a project team member custom field value in the Newforma database.  Updating a custom field value with its default value deletes the value.</p><p>
      The only fields that can be updated on a custom field are:
    </p><ul>
      <li>StringValue</li>
      <li>DateTimeValue</li>
      <li>TimeOfDayValue</li>
      <li>CurrencyValue</li>
      <li>NumberValue</li>
      <li>BooeanValue</li>
    </ul>
    It is an error to update a custom field value that does not exist, or set the custom field's value to an unsupported type for that field.
    <p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"FieldValue" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"StringValue" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DateTimeValue" : <i>datetime</i> <sup>1</sup>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"TimeOfDayValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Hour" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Minute" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Second" : <i>int</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CurrencyValue" : <br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Culture" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"Value" : <i>number</i><br />
        &nbsp;&nbsp;&nbsp;&nbsp;{'}'},<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"NumberValue" : <i>number</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"BooleanValue" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CustomFieldId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectTeamMemberId" : <i>string</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue</td><td>The custom field value to update.</td></tr>
        <tr><td>FieldValue.StringValue</td><td>The value for text, note, email, phone, URL, keyword, and keyword list custom fields.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.DateTimeValue</td><td>The value for date, and datetime custom fields.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue</td><td>The time of day value.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue.Hour</td><td>The hour of the day in the range 0 - 23.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.TimeOfDayValue.Minute</td><td>The minute of the hour in the range 0 - 59.</td></tr>
        <tr><td>FieldValue.TimeOfDayValue.Second</td><td>The second of the minute in the range 0 - 59.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CurrencyValue</td><td>The currency value.</td></tr>
        <tr><td>FieldValue.CurrencyValue.Culture</td><td>The currency's culture name (ex. <code>en-US</code>).  For more details see the <a href="http://msdn.microsoft.com/en-us/goglobal/bb896001.aspx">National Language Support (NLS) API Reference</a>.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.CurrencyValue.Value</td><td>The currency value.</td></tr>
        <tr><td>FieldValue.NumberValue</td><td>The value for quantity, and numeric fields.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.BooleanValue</td><td>The boolean value.</td></tr>
        <tr><td>FieldValue.CustomFieldId</td><td>The value's associated custom field Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>FieldValue.ProjectTeamMemberId</td><td>The project team member's Newforma database ID.</td></tr>
      </tbody></table><p>
      <b>UpdateProjectTeamMemberCustomFieldValueResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateSourceDescriptorRequest"><b>UpdateSourceDescriptorRequest</b></a> (Deprecated: use <a href="#UpdateSourceDescriptor2Request">UpdateSourceDescriptor2</a> instead.)<br />
      Update a source descriptor in the Newforma database.</p><p>
      It is an error to update a source descriptor that does not exist, or set the same DescriptorName/DescriptorType/FieldType values as another source descriptor.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"SourceDescriptor" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptorId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DescriptorName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DescriptorType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FieldType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"IsEditable" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptor</td><td>The source descriptor to update.</td></tr>
        <tr><td>SourceDescriptor.SourceDescriptorId</td><td>The source descriptor's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptor.DescriptorName</td><td>The source descriptor's name.</td></tr>
        <tr><td>SourceDescriptor.DescriptorType</td><td>The source descriptor's object type.<p>Allowed values:<br />
              DescriptorTypeContact = 1<br />
              DescriptorTypeCompany = 4<br />
              DescriptorTypeOfficeLocation = 6</p></td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptor.FieldType</td><td>The source descriptor's field type.<p>Allowed values:<br />
              FieldTypeContactEmailAddress = 100<br />
              FieldTypeContactFirstName = 101<br />
              FieldTypeContactLastName = 102<br />
              FieldTypeContactCompany = 103<br />
              FieldTypeContactDepartmentName = 104<br />
              FieldTypeContactJobTitle = 105<br />
              FieldTypeContactDiscipline = 106<br />
              FieldTypeContactPhoneNumberWork = 107<br />
              FieldTypeContactPhoneNumberMobile = 108<br />
              FieldTypeContactPhoneNumberHome = 109<br />
              FieldTypeContactFaxNumber = 110<br />
              FieldTypeContactStreetAddress = 111<br />
              FieldTypeContactNoteText = 112<br />
              FieldTypeContactActiveUser = 113<br />
              FieldTypeCompanyCompanyName = 311<br />
              FieldTypeCompanyWebUrl = 312<br />
              FieldTypeCompanyDisciplineList = 313<br />
              FieldTypeCompanySpecSectionList = 314<br />
              FieldTypeCompanyMainContact = 315<br />
              FieldTypeCompanyNoteText = 316<br />
              FieldTypeOfficeLocationLocationName = 600<br />
              FieldTypeOfficeLocationStreetAddress = 601<br />
              FieldTypeOfficeLocationAddressType = 606<br />
              FieldTypeOfficeLocationPhoneNumber = 607<br />
              FieldTypeOfficeLocationFaxNumber = 608</p></td></tr>
        <tr><td>SourceDescriptor.IsEditable</td><td>Is the field editable in Newforma?</td></tr>
      </tbody></table><p>
      <b>UpdateSourceDescriptorResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateSourceDescriptor2Request"><b>UpdateSourceDescriptor2Request</b></a> (Deprecated: use <a href="#UpdateSourceDescriptor3Request">UpdateSourceDescriptor3</a> instead.)<br />
      Update a source descriptor in the Newforma database.</p><p>
      It is an error to update a source descriptor that does not exist, or set the same DescriptorName/DescriptorType/FieldType values as another source descriptor.
      It is an error use the following values for a source descriptor name:
    </p><ul>
      <li>Manual</li>
      <li>Global Address List</li>
      <li>Microsoft Project</li>
      <li>Microsoft Outlook</li>
      <li>Ad Hoc</li>
    </ul>
    <p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"SourceDescriptor" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptorId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DescriptorName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DescriptorType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FieldType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"IsEditable" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptor</td><td>The source descriptor to update.</td></tr>
        <tr><td>SourceDescriptor.SourceDescriptorId</td><td>The source descriptor's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptor.DescriptorName</td><td>The source descriptor's name.</td></tr>
        <tr><td>SourceDescriptor.DescriptorType</td><td>The source descriptor's object type.<p>Allowed values:<br />
              DescriptorTypeContact = 1<br />
              DescriptorTypeCompany = 4<br />
              DescriptorTypeOfficeLocation = 6</p></td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptor.FieldType</td><td>The source descriptor's field type.<p>Allowed values:<br />
              FieldTypeContactEmailAddress = 100<br />
              FieldTypeContactFirstName = 101<br />
              FieldTypeContactLastName = 102<br />
              FieldTypeContactCompany = 103<br />
              FieldTypeContactDepartmentName = 104<br />
              FieldTypeContactJobTitle = 105<br />
              FieldTypeContactDiscipline = 106<br />
              FieldTypeContactPhoneNumberWork = 107<br />
              FieldTypeContactPhoneNumberMobile = 108<br />
              FieldTypeContactPhoneNumberHome = 109<br />
              FieldTypeContactFaxNumber = 110<br />
              FieldTypeContactStreetAddress = 111<br />
              FieldTypeContactNoteText = 112<br />
              FieldTypeContactActiveUser = 113<br />
              FieldTypeCompanyCompanyName = 311<br />
              FieldTypeCompanyWebUrl = 312<br />
              FieldTypeCompanyDisciplineList = 313<br />
              FieldTypeCompanySpecSectionList = 314<br />
              FieldTypeCompanyMainContact = 315<br />
              FieldTypeCompanyNoteText = 316<br />
              FieldTypeOfficeLocationLocationName = 600<br />
              FieldTypeOfficeLocationStreetAddress = 601<br />
              FieldTypeOfficeLocationAddressType = 606<br />
              FieldTypeOfficeLocationPhoneNumber = 607<br />
              FieldTypeOfficeLocationFaxNumber = 608<br />
              FieldTypeContactOfficeLocation = 114<br />
              FieldTypeContactAddressType = 115<br />
              FieldTypeContactUseOfficeAddress = 116<br />
              FieldTypeOfficeLocationIsPrimary = 609</p></td></tr>
        <tr><td>SourceDescriptor.IsEditable</td><td>Is the field editable in Newforma?</td></tr>
      </tbody></table><p>
      <b>UpdateSourceDescriptor2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateSourceDescriptor3Request"><b>UpdateSourceDescriptor3Request</b></a><br />
      Update a source descriptor in the Newforma database.</p><p>
      It is an error to update a source descriptor that does not exist, or set the same DescriptorName/DescriptorType/FieldType values as another source descriptor.
      It is an error use the following values for a source descriptor name:
    </p><ul>
      <li>Manual</li>
      <li>Global Address List</li>
      <li>Microsoft Project</li>
      <li>Microsoft Outlook</li>
      <li>Ad Hoc</li>
    </ul>
    <p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"SourceDescriptor" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SourceDescriptorId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DescriptorName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"DescriptorType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FieldType" : <i>int</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"IsEditable" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptor</td><td>The source descriptor to update.</td></tr>
        <tr><td>SourceDescriptor.SourceDescriptorId</td><td>The source descriptor's Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptor.DescriptorName</td><td>The source descriptor's name.</td></tr>
        <tr><td>SourceDescriptor.DescriptorType</td><td>The source descriptor's object type.<p>Allowed values:<br />
              DescriptorTypeContact = 1<br />
              DescriptorTypeCompany = 4<br />
              DescriptorTypeOfficeLocation = 6</p></td></tr>
        <tr bgcolor="efefef"><td>SourceDescriptor.FieldType</td><td>The source descriptor's field type.<p>Allowed values:<br />
              FieldTypeContactEmailAddress = 100<br />
              FieldTypeContactFirstName = 101<br />
              FieldTypeContactLastName = 102<br />
              FieldTypeContactCompany = 103<br />
              FieldTypeContactDepartmentName = 104<br />
              FieldTypeContactJobTitle = 105<br />
              FieldTypeContactDiscipline = 106<br />
              FieldTypeContactPhoneNumberWork = 107<br />
              FieldTypeContactPhoneNumberMobile = 108<br />
              FieldTypeContactPhoneNumberHome = 109<br />
              FieldTypeContactFaxNumber = 110<br />
              FieldTypeContactStreetAddress = 111<br />
              FieldTypeContactNoteText = 112<br />
              FieldTypeContactActiveUser = 113<br />
              FieldTypeCompanyCompanyName = 311<br />
              FieldTypeCompanyWebUrl = 312<br />
              FieldTypeCompanyDisciplineList = 313<br />
              FieldTypeCompanySpecSectionList = 314<br />
              FieldTypeCompanyMainContact = 315<br />
              FieldTypeCompanyNoteText = 316<br />
              FieldTypeOfficeLocationLocationName = 600<br />
              FieldTypeOfficeLocationStreetAddress = 601<br />
              FieldTypeOfficeLocationAddressType = 606<br />
              FieldTypeOfficeLocationPhoneNumber = 607<br />
              FieldTypeOfficeLocationFaxNumber = 608<br />
              FieldTypeContactOfficeLocation = 114<br />
              FieldTypeContactAddressType = 115<br />
              FieldTypeContactUseOfficeAddress = 116<br />
              FieldTypeOfficeLocationIsPrimary = 609<br />
              FieldTypeContactRoles = 117</p></td></tr>
        <tr><td>SourceDescriptor.IsEditable</td><td>Is the field editable in Newforma?</td></tr>
      </tbody></table><p>
      <b>UpdateSourceDescriptor3Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateUserRequest"><b>UpdateUserRequest</b></a> (Deprecated: use <a href="#UpdateUser3Request">UpdateUser3</a> instead.)<br />
      Update a user in the Newforma database.</p><p>
      It is an error to update a user that does not exist, or to set the ContactId of the user to a contact which is already associated with a different user.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"User" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"UserName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"HomeServer" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AdminUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectCreator" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CAUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProfessionalUser" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>User</td><td>The user to update.</td></tr>
        <tr><td>User.UserName</td><td>The user's user name and Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>User.ContactId</td><td>The user's associated contact's Newforma database ID.</td></tr>
        <tr><td>User.HomeServer</td><td>The user's home NPCS server.</td></tr>
        <tr bgcolor="efefef"><td>User.AdminUser</td><td>Is the user a Newform administrator?</td></tr>
        <tr><td>User.ProjectCreator</td><td>Does the user have project creation privledges?  Administrators always have this privledge.</td></tr>
        <tr bgcolor="efefef"><td>User.CAUser</td><td>Is the user a Contract Administrator?</td></tr>
        <tr><td>User.ProfessionalUser</td><td>Is the user a Professional-licensed user?  Contact Administrators are always Professional-licensed users as well.</td></tr>
      </tbody></table><p>
      <b>UpdateUserResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateUser2Request"><b>UpdateUser2Request</b></a> (Deprecated: use <a href="#UpdateUser3Request">UpdateUser3</a> instead.)<br />
      Update a user in the Newforma database.</p><p>
      It is an error to update a user that does not exist, or to set the ContactId of the user to a contact which is already associated with a different user.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"User" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"UserName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"HomeServer" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AdminUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectCreator" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CAUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProfessionalUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContentAdmin" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>User</td><td>The user to update.</td></tr>
        <tr><td>User.UserName</td><td>The user's user name and Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>User.ContactId</td><td>The user's associated contact's Newforma database ID.</td></tr>
        <tr><td>User.HomeServer</td><td>The user's home NPCS server.</td></tr>
        <tr bgcolor="efefef"><td>User.AdminUser</td><td>Is the user a Newform administrator?</td></tr>
        <tr><td>User.ProjectCreator</td><td>Does the user have project creation privledges?  Administrators always have this privledge.</td></tr>
        <tr bgcolor="efefef"><td>User.CAUser</td><td>Is the user a Contract Administrator?</td></tr>
        <tr><td>User.ProfessionalUser</td><td>Is the user a Professional-licensed user?  Contact Administrators are always Professional-licensed users as well.</td></tr>
        <tr bgcolor="efefef"><td>User.ContentAdmin</td><td>Does the user have content administration privledges?  Administrators always have this privledge.</td></tr>
      </tbody></table><p>
      <b>UpdateUser2Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateUser3Request"><b>UpdateUser3Request</b></a><br />
      Update a user in the Newforma database.</p><p>
      It is an error to update a user that does not exist, or to set the ContactId of the user to a contact which is already associated with a different user.
    </p><p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"User" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"UserName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContactId" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"HomeServer" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"AdminUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProjectCreator" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"CAUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ProfessionalUser" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"ContentAdmin" : <i>boolean</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"FinancialManager" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>User</td><td>The user to update.</td></tr>
        <tr><td>User.UserName</td><td>The user's user name and Newforma database ID.</td></tr>
        <tr bgcolor="efefef"><td>User.ContactId</td><td>The user's associated contact's Newforma database ID.</td></tr>
        <tr><td>User.HomeServer</td><td>The user's home NPCS server.</td></tr>
        <tr bgcolor="efefef"><td>User.AdminUser</td><td>Is the user a Newform administrator?</td></tr>
        <tr><td>User.ProjectCreator</td><td>Does the user have project creation privledges?  Administrators always have this privledge.</td></tr>
        <tr bgcolor="efefef"><td>User.CAUser</td><td>Is the user a Contract Administrator?</td></tr>
        <tr><td>User.ProfessionalUser</td><td>Is the user a Professional-licensed user?  Contact Administrators are always Professional-licensed users as well.</td></tr>
        <tr bgcolor="efefef"><td>User.ContentAdmin</td><td>Does the user have content administration privledges?  Administrators always have this privledge.</td></tr>
        <tr><td>User.FinancialManager</td><td>Does the user have financial manager privileges?</td></tr>
      </tbody></table><p>
      <b>UpdateUser3Response</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <a name="UpdateWebLinkRequest"><b>UpdateWebLinkRequest</b></a><br />
      Update a web link for a project item.  The only fields that can be updated on a web link are:
    </p><ul>
      <li>Subject</li>
      <li>SharedExternally</li>
    </ul>
    <p>
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"UserToken" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectId" : <i>string</i>,<br />
        &nbsp;&nbsp;"ProjectItemId" : <i>string</i>,<br />
        &nbsp;&nbsp;"WebLink" : <br />
        &nbsp;&nbsp;{'{'}<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"UrlName" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"Subject" : <i>string</i>,<br />
        &nbsp;&nbsp;&nbsp;&nbsp;"SharedExternally" : <i>boolean</i><br />
        &nbsp;&nbsp;{'}'}<br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>UserToken</td><td>The authentication token for this request in the form <code>domain\username;password</code>.</td></tr>
        <tr bgcolor="efefef"><td>ProjectId</td><td>The project's Newforma datababase ID.</td></tr>
        <tr><td>ProjectItemId</td><td>The project item's Newforma datababase ID.</td></tr>
        <tr bgcolor="efefef"><td>WebLink</td><td>The web link to update.</td></tr>
        <tr><td>WebLink.UrlName</td><td>The web link's URL.</td></tr>
        <tr bgcolor="efefef"><td>WebLink.Subject</td><td>The web link's subject.</td></tr>
        <tr><td>WebLink.SharedExternally</td><td>Is the web link shared externally on NIX?</td></tr>
      </tbody></table><p>
      <b>UpdateWebLinkResponse</b><br />
      <code>
        {'{'}<br />
        &nbsp;&nbsp;"Status" : <i>int</i>,<br />
        &nbsp;&nbsp;"StatusDescription" : <i>string</i><br />
        {'}'}<br />
      </code><br />
      <b>Fields:</b><br />
    </p><table border={1}>
      <tbody><tr bgcolor="7f7f7f"><th width="300px">Field</th><th width="400px">Documentation</th>
        </tr><tr><td>Status</td><td>See the Integration Services specification for more details.</td></tr>
        <tr bgcolor="efefef"><td>StatusDescription</td><td>See the Integration Services specification for more details.</td></tr>
      </tbody></table><p>
      <sup>1</sup>: All datetimes are formatted according to the following <a href="http://msdn.microsoft.com/en-us/library/bb412170.aspx">rules</a>.  See the section titled "DateTime Wire Format" for more details.
    </p></div>




  </div> )


  }

}



/** WEBPACK FOOTER **
 ** ./src/pages/ReferenceLegacy/index.js
 **/